<template>

    <div>


         <div class="div" v-if="TablaProcesados" id="TablaProcesados">


            <h5>Procesados encontrados</h5>

            <hr />


            <div class="table-responsive">


              <table v-if="TablaProcesados"  class="table table-striped table-light table-hover table-bordered table-condensed " id="tablaDeProcesados_table"
                data-search="false" 
                data-toggle="tablaDeProcesados_table" 
                data-pagination="false" 
                data-toolbar="#tablaDeProcesados_texto_div"
                data-page-size="5"
                data-page-list="[2,5,10]"
                data-undefined-text="Sin información"
                data-minimum-count-columns="0">


                <thead class="thead-green">
                <tr>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:2%;" class="text-center">Clave del Procesado</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:30%;" class="text-center">Juzgado</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:4%;" class="text-center">Materia</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:35%;" class="text-center">Tipo de documento</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:2%;" class="text-center">Consecutivo</th>                                        
                <th v-if="AccionesMostrar.mostrardelitos" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:15%;" class="text-center">Delito/os</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:5%;" class="text-center">Temporalidad</th>
                <!-- <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:15%;" class="text-center">Fecha de alta</th> -->
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:25%;" class="text-center">Nombre</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:1%;" class="text-center">Acciones</th>
                </tr>
                </thead>
                
                <tbody class="text-dark">
             
               

                <tr v-for="(procesado, indexImp1) in TablaProcesados" :key="indexImp1">

                <td class="text-center align-middle" style="width:2%;">{{ procesado.ClaveDelProcesado }}</td>


                 <td  class="text-center align-middle"  style="width:25%;">




                  <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:center;"  >
                    <li v-for="(area,index) in (procesado.ExpedientesProcesados)" :key="index" style="height: auto;" >
                        {{area.Area.Nombre}}
                    </li>
                  </ul>
                
                 </td>


                <td class="text-center align-middle"  style="width:4%;">

                <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:center;"  >
                    <li v-for="(materia,index) in (procesado.ExpedientesProcesados)" :key="index" style="height: auto;">
                        {{materia.Materia.Nombre}}
                    </li>
                </ul>
                
                </td>




                <td class="text-center align-middle"  style="width:25%;">

                  <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:center;"  >
                    <li v-for="(tipodocumento,index) in (procesado.ExpedientesProcesados)" :key="index" style="height: auto;">
                        {{tipodocumento.TipoDocumento.Nombre}}
                    </li>
                  </ul>
                
                </td>



                <td  class="text-center align-middle"  style="width:2%;">

                  <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:center;"  >
                     <li v-for="(consecutivo,index) in (procesado.ExpedientesProcesados)" :key="index" style="height: auto;">
                        <!-- {{consecutivo.Expediente.Consecutivo+((consecutivo.Expediente.NumeroRomano) || "")}} -->
                        {{ (consecutivo.Expediente.NumeroRomano ? (consecutivo.Expediente.Consecutivo + '-' + consecutivo.Expediente.NumeroRomano) : consecutivo.Expediente.Consecutivo) }}
                    </li>
                  </ul>
                
                </td>





                <!-- <td class="text-center align-middle" style="width:10%;">{{ delito.Expediente.Consecutivo }}</td> -->


                 <!-- <td class="text-center align-middle" style="width:15%;">{{ delito.DelitoDBPJ.Nombre }}</td> -->


                 <td v-if="AccionesMostrar.mostrardelitos" class="text-center align-middle"  style="width:17%;">

                   <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:left;">
                     <li v-for="(procesado,index) in (procesado.DelitosProcesados)" :key="index">
                        {{procesado.Delito.Nombre}}
                     </li>
                   </ul>
                
                </td>





                <td class="text-center align-middle" style="width:5%;">{{  procesado.TipoTemporalidad.Temporalidad }} días</td>
                
                <!-- <td class="text-center align-middle" style="width:10%;">{{ procesado.FechaDeAlta ? obtenerFechaConFormato(procesado.FechaDeAlta) : ""}}</td> -->

                
                <td class="text-center align-middle" style="width:15%;">{{ procesado.Nombre + ' ' +  (procesado.ApellidoPaterno || "") + ' ' +(procesado.ApellidoMaterno || "") }}</td>
               
                <td class="text-center align-middle" style="width:12%;">


                <i v-show="AccionesMostrar.alta" class="fas fa-plus-circle fa-lg pl-1 pr-1 iconoHabilitado" title="Dar de alta un nuevo expediente" @click="limpiarAccionesParaPadre1(); informacionParaPadre1.Accion.Alta = true; eventoValorParaElPadre1(indexImp1)"></i>
                
                <i v-show="AccionesMostrar.cambios" class="fas fa-edit fa-lg p-1 iconoHabilitado" title="Edición del procesado"  @click="limpiarAccionesParaPadre1(); informacionParaPadre1.Accion.Cambios = true; eventoValorParaElPadre1(indexImp1)"></i>

                <i v-show="AccionesMostrar.cambiostemporalidad" class="fas fa-clock fa-lg p-1 iconoHabilitado" title="Editar Temporalidad"  @click="limpiarAccionesParaPadre1(); informacionParaPadre1.Accion.CambiosTemporalidad = true; eventoValorParaElPadre1(indexImp1)"></i>
                

                <i v-show="AccionesMostrar.visualizacion" class="fas fa-eye fa-lg p-1 iconoHabilitado" title="Visualizar toda la información" @click="limpiarAccionesParaPadre1(); informacionParaPadre1.Accion.Visualizar = true; eventoValorParaElPadre1(indexImp1)"></i>

                
            </td>
                </tr>
              
              
                </tbody>


              </table>


            </div>

            <hr />


         </div>

         <div class="div" v-if="TablaProcesadosExpedientes" id="TablaProcesadosExpedientes">

            <h5 >Expedientes del Procesado encontrados</h5>

            <hr />


            <div class="table-responsive">


            <table class="table table-striped table-light table-hover table-bordered table-condensed " id="tablaDeProcesados_table"
                data-search="false" 
                data-toggle="tablaDeProcesados_table" 
                data-pagination="false" 
                data-toolbar="#tablaDeProcesados_texto_div"
                data-page-size="5"
                data-page-list="[2,5,10]"
                data-undefined-text="Sin información"
                data-minimum-count-columns="0">
            <thead class="thead-green">
                <tr>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:7%;" class="text-center">Clave del Procesado</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:15%;" class="text-center">Juzgado</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Materia</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Tipo de documento</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Consecutivo</th>                                        
                    <!-- <th v-if="AccionesMostrar.mostrardelitos" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:15%;" class="text-center">Delito/os</th> -->
                    
                    <!-- <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:7%;" class="text-center">Temporalidad</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:15%;" class="text-center">Fecha de alta</th> -->
                    
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:20%;" class="text-center">Nombre</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:1%;" class="text-center">Acciones</th>
                </tr>
            </thead>
            <tbody class="text-dark">
                <template v-for="(procesado, indexImp6) in TablaProcesadosExpedientes"  > 

                    <tr v-for="(delito, indexDel6) in procesado.ExpedientesProcesados" :key="'procesado' + delito.ProcesadoId + procesado.PersonaId  + delito.ExpedienteId + indexDel6" >

                        <td class="text-center align-middle" style="width:7%;">{{ procesado.ClaveDelProcesado }}</td>


                        <!-- <td  class="text-center align-middle"  style="width:17%;">




                            <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:left;">
                                <li v-for="area in (procesado.ExpedientesProcesados)">
                                    {{area.Area.Nombre}}
                                </li>
                            </ul>
                            
                        </td> -->


                        <td class="text-center align-middle" style="width:7%;">{{ delito.Area.Nombre }}</td>





                        <!-- <td class="text-center align-middle"  style="width:17%;">

                            <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:left;">
                                <li v-for="materia in (procesado.ExpedientesProcesados)">
                                    {{materia.Materia.Nombre}}
                                </li>
                            </ul>
                            
                        </td> -->


                        <td class="text-center align-middle" style="width:7%;">{{ delito.Materia.Nombre }}</td>




                        <!-- <td class="text-center align-middle"  style="width:17%;">

                            <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:left;">
                                <li v-for="tipodocumento in (procesado.ExpedientesProcesados)">
                                    {{tipodocumento.TipoDocumento.Nombre}}
                                </li>
                            </ul>
                            
                        </td> -->


                        <td class="text-center align-middle" style="width:7%;">{{ delito.TipoDocumento.Nombre }}</td>



                        <!-- <td  class="text-center align-middle"  style="width:17%;">

                            <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:left;">
                                <li v-for="consecutivo in (procesado.ExpedientesProcesados)">
                                    {{consecutivo.Expediente.Consecutivo}}
                                </li>
                            </ul>
                            
                        </td> -->


                        <!-- <td class="text-center align-middle" style="width:7%;">{{ delito.Expediente.Consecutivo+(delito.Expediente.NumeroRomano || "") }}</td> -->
                        <td class="text-center align-middle" style="width:7%;">{{ (delito.Expediente.NumeroRomano ? (delito.Expediente.Consecutivo + '-' + delito.Expediente.NumeroRomano) : delito.Expediente.Consecutivo) }}</td>




                        <!-- //////////////////////////////////////////////// -->
                        <!-- <td class="text-center align-middle" style="width:10%;">{{ delito.Expediente.Consecutivo }}</td> -->


                        <!-- <td class="text-center align-middle" style="width:15%;">{{ delito.DelitoDBPJ.Nombre }}</td> -->
                        <!-- //////////////////////////////////////////////////// -->





                        <!-- <td v-if="AccionesMostrar.mostrardelitos" class="text-center align-middle"  style="width:17%;">

                            <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:left;">
                                <li v-for="procesado in (procesado.DelitosProcesados)">
                                    {{procesado.Delito.Nombre}}
                                </li>
                            </ul>
                            
                        </td> -->





                        <!-- <td class="text-center align-middle" style="width:7%;">{{  procesado.TipoTemporalidad.Temporalidad }} días</td>
                        <td class="text-center align-middle" style="width:10%;">{{ procesado.FechaDeAlta ? obtenerFechaConFormato(procesado.FechaDeAlta) : ""}}</td> -->

                        
                        <td class="text-center align-middle" style="width:20%;">{{ procesado.Nombre + ' ' +  (procesado.ApellidoPaterno || "") + ' ' +(procesado.ApellidoMaterno || "") }}</td>
                    
                        <td class="text-center align-middle" style="width:1%;">


                                                        
                            <i v-show="AccionesMostrar.cambios" class="fas fa-edit fa-lg p-1 iconoHabilitado" title="Editar el expediente del procesado"  @click="limpiarAccionesParaPadre6(); informacionParaPadre6.Accion.Cambios = true; eventoValorParaElPadre6(indexImp6,indexDel6)"></i>


                            <i v-show="AccionesMostrar.visualizacion" class="fas fa-eye fa-lg p-1 iconoHabilitado" title="Visualizar toda la información del expediente" @click="limpiarAccionesParaPadre6(); informacionParaPadre6.Accion.Visualizar = true; eventoValorParaElPadre6(indexImp6,indexDel6)"></i>


                            <i v-show="AccionesMostrar.baja" class="fas fa-trash-alt fa-lg pl-1 pr-1 iconoHabilitado" title="Dar de baja el expediente" @click="limpiarAccionesParaPadre6(); informacionParaPadre6.Accion.Baja = true; eventoValorParaElPadre6(indexImp6, indexDel6)"></i>

                            
                        </td>
                    </tr>
                </template>
            </tbody>
            </table>


            </div>

            <hr />



         </div>


        
         <div class="div" v-if="TablaFirmas" id="TablaFirmas" >

         <h5>Firmas vigentes encontradas</h5>

         <hr />

            <div class="table-responsive">

                <table  class="table table-striped table-light table-hover table-bordered table-condensed " id="tablaDeProcesadosParaFirma_table"
                    data-search="false" 
                    data-toggle="tablaDeProcesadosParaFirma_table" 
                    data-pagination="false" 
                    data-toolbar="#tablaDeProcesadosParaFirma_texto_div"
                    data-page-size="5"
                    data-page-list="[2,5,10]"
                    data-undefined-text="Sin información"
                    data-minimum-count-columns="0">
                <thead class="thead-green">
                    <tr>
                        <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Clave del Procesado</th>
                        <!-- <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:20%;" class="text-center">Delito</th> -->
                        <th v-if="AccionesMostrar.mostrarcatalogocompleto" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:35%;" class="text-center">Juzgado</th>
                        
                        <th v-if="AccionesMostrar.mostrarcatalogocompleto" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:35%;" class="text-center">Tipo de documento</th>
                        <th v-if="AccionesMostrar.mostrarcatalogocompleto" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:5%;" class="text-center">Consecutivo</th>
                        <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Temporalidad</th>
                        <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:15%;" class="text-center">Fecha Última Firma</th>
                        <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:15%;" class="text-center">Fecha Próxima Firma</th>
                        <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Estatus de Firma</th>
                        <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:20%;" class="text-center">Nombre</th>
                        <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:20%;" class="text-center">Dirección</th>

                        <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:1%;" class="text-center">Acciones</th>
                    </tr>
                </thead>
                <tbody class="text-dark">


                    
                         <tr v-for="(firma, indexImp2) in TablaFirmas" :key="indexImp2" >
                            
                         <td class="text-center align-middle" style="width:10%;">{{ firma.ClaveDelProcesado }}</td>

                         
                         <td v-if="AccionesMostrar.mostrarcatalogocompleto" class="text-center align-middle"  style="width:25%;">
                         <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:center;"  >
                         <li v-for="(area,index) in (firma.ExpedientesProcesados)" :key="index" style="height: auto;" >
                         {{area.Area.Nombre}}
                         </li>
                         </ul>
                         </td>



                           <td v-if="AccionesMostrar.mostrarcatalogocompleto" class="text-center align-middle"  style="width:25%;">

                           <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:center;"  >
                           <li v-for="(tipodocumento,index) in (firma.ExpedientesProcesados)" :key="index" style="height: auto;">
                            {{tipodocumento.TipoDocumento.Nombre}}
                           </li>
                           </ul>
                
                           </td>



                            <td v-if="AccionesMostrar.mostrarcatalogocompleto"  class="text-center align-middle"  style="width:5%;">

                             <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:center;"  >
                            <li v-for="(consecutivo,index) in (firma.ExpedientesProcesados)" :key="index" style="height: auto;">
                        <!-- {{consecutivo.Expediente.Consecutivo+((consecutivo.Expediente.NumeroRomano) || "")}} -->
                             {{ (consecutivo.Expediente.NumeroRomano ? (consecutivo.Expediente.Consecutivo + '-' + consecutivo.Expediente.NumeroRomano) : consecutivo.Expediente.Consecutivo) }}
                            </li>
                            </ul>
                
                            </td>




                        <!--  <td class="text-center align-middle" style="width:15%;">{{ firma.Procesado.DelitoDBPJ.Nombre }}</td> -->
                            <td class="text-center align-middle" style="width:7%;">{{ firma.TipoTemporalidad.Temporalidad }} días</td>
                            <td class="text-center align-middle" style="width:15%;">{{ firma.FechaUltimaFirma ? obtenerFechaConFormato(firma.FechaUltimaFirma) : ""}}</td>
                            <td class="text-center align-middle" style="width:15%;">{{ firma.FechaProximaFirma ? obtenerFechaConFormato(firma.FechaProximaFirma) : ""}}</td>

                            <td class="text-center align-middle" style="width:10%;">{{ firma.TipoEstatusFirma.Nombre }}</td>
                            

                            <td class="text-center align-middle" style="width:20%;">{{ firma.Nombre + ' ' +  (firma.ApellidoPaterno || "") + ' ' +(firma.ApellidoMaterno || "") }}</td>

                            <td class="text-center align-middle" style="width:20%;">{{ firma.Direccion }}</td>
                        
                            <td class="text-center align-middle" style="width:1%;">


                                <i v-show="AccionesMostrar.alta" class="fas fas fa-hand-paper fa-lg pl-1 pr-1 iconoHabilitado" title="Firmar con dispositivo" @click="limpiarAccionesParaPadre2(); informacionParaPadre2.Accion.Alta = true; eventoValorParaElPadre2(indexImp2)"></i>

                                <i v-show="AccionesMostrar.impresion" class="fas fa-print fa-lg p-1 iconoHabilitado" title="Imprimir" @click="limpiarAccionesParaPadre2(); informacionParaPadre2.Accion.Impresion = true; eventoValorParaElPadre2(indexImp2)"></i>
                                
                                <i v-show="AccionesMostrar.cambios" class="fas fa-edit fa-lg p-1 iconoHabilitado" title="Editar"  @click="limpiarAccionesParaPadre2(); informacionParaPadre2.Accion.Cambios = true; eventoValorParaElPadre2(indexImp2)"></i>

                                <i v-show="AccionesMostrar.altamanual" class="fas fas fa-allergies fa-lg pl-1 pr-1 iconoHabilitado" title="Firmar sin dispositivo" @click="limpiarAccionesParaPadre2(); informacionParaPadre2.Accion.AltaManual = true; eventoValorParaElPadre2(indexImp2)"></i>

                                <i v-show="AccionesMostrar.verificarregistro" class="fa fad fa-calendar-check fa-lg pl-1 pr-1 iconoHabilitado" title="Verificar registro de asistencia en el dispositivo checador" @click="limpiarAccionesParaPadre2(); informacionParaPadre2.Accion.VerificarRegistro = true; eventoValorParaElPadre2(indexImp2)"></i>

                                <i v-show="AccionesMostrar.mensaje" class="fas fa-envelope fa-lg pl-1 pr-1 iconoHabilitado" title="Enviar mensaje proxima firma" @click="limpiarAccionesParaPadre2(); informacionParaPadre2.Accion.Mensaje = true; eventoValorParaElPadre2(indexImp2)"></i>

                                <i v-show="AccionesMostrar.bajapersona" class="fas fa-trash-alt fa-lg pl-1 pr-1 iconoHabilitado" title="Dar de baja de firmas" @click="limpiarAccionesParaPadre2(); informacionParaPadre2.Accion.BajaPersona = true; eventoValorParaElPadre2(indexImp2)"></i>
                                
                            
                            <!--  // Nota: procesado.Firmas y firma.Delito vienen del API de igual firma firma.FirmaId y procesado.Nombre // -->
                                
                            </td>
                        </tr>
                    
                </tbody>
                </table>   

            </div>
        

         <hr />
    
         </div>


         <div class="div" v-if="TablaFirmasMensajes" id="TablaFirmasMensajes"  >


         <h5>Firmas vigentes encontradas para enviar un mensaje</h5>

         <hr />



         <div class="table-responsive">


         <table  class="table table-striped table-light table-hover table-bordered table-condensed " id="tablaDeFirmasMensajesPaginacion_table"
                data-search="false" 
                data-toggle="tablaDeFirmasMensajesPaginacion_table" 
                data-pagination="false" 
                data-toolbar="#tablaDeFirmasMensajesPaginacion_texto_div"
                data-page-size="5"
                data-page-list="[2,5,10]"
                data-undefined-text="Sin información"
                data-minimum-count-columns="0">
            <thead class="thead-green">
                <tr>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Clave del Procesado</th>
                    <!-- <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:20%;" class="text-center">Delito</th> -->
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:35%;" class="text-center">Juzgado</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:35%;" class="text-center">Tipo de documento</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:5%;" class="text-center">Consecutivo</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:7%;" class="text-center">Temporalidad</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Fecha Última Firma</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Fecha Próxima Firma</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Estatus de Firma</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:20%;" class="text-center">Nombre</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:20%;" class="text-center">Dirección</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:20%;" class="text-center">Mensaje</th>

                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:1%;" class="text-center">Acciones</th>
                </tr>
            </thead>
            <tbody class="text-dark">
                
                    <tr v-for="(firma, indexImp5) in TablaFirmasMensajes" :key="indexImp5" >
                        
                        <td class="text-center align-middle" style="width:10%;">{{ firma.ClaveDelProcesado }}</td>
                        <td class="text-center align-middle"  style="width:25%;">
                         <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:center;"  >
                         <li v-for="(area,index) in (firma.ExpedientesProcesados)" :key="index" style="height: auto;" >
                         {{area.Area.Nombre}}
                         </li>
                         </ul>
                         </td>



                           <td class="text-center align-middle"  style="width:25%;">

                           <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:center;"  >
                           <li v-for="(tipodocumento,index) in (firma.ExpedientesProcesados)" :key="index" style="height: auto;">
                            {{tipodocumento.TipoDocumento.Nombre}}
                           </li>
                           </ul>
                
                           </td>



                            <td  class="text-center align-middle"  style="width:5%;">

                             <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:center;"  >
                            <li v-for="(consecutivo,index) in (firma.ExpedientesProcesados)" :key="index" style="height: auto;">
                        <!-- {{consecutivo.Expediente.Consecutivo+((consecutivo.Expediente.NumeroRomano) || "")}} -->
                             {{ (consecutivo.Expediente.NumeroRomano ? (consecutivo.Expediente.Consecutivo + '-' + consecutivo.Expediente.NumeroRomano) : consecutivo.Expediente.Consecutivo) }}
                            </li>
                            </ul>
                
                            </td>

                    <!--  <td class="text-center align-middle" style="width:15%;">{{ firma.Procesado.DelitoDBPJ.Nombre }}</td> -->
                        <td class="text-center align-middle" style="width:7%;">{{ firma.TipoTemporalidad.Temporalidad }} días</td>
                        <td class="text-center align-middle" style="width:10%;">{{ firma.FechaUltimaFirma ? obtenerFechaConFormato(firma.FechaUltimaFirma) : ""}}</td>
                        <td class="text-center align-middle" style="width:14%;">{{ firma.FechaProximaFirma ? obtenerFechaConFormato(firma.FechaProximaFirma) : ""}}</td>

                        <td class="text-center align-middle" style="width:10%;">{{ firma.TipoEstatusFirma.Nombre }}</td>
                        

                        <td class="text-center align-middle" style="width:20%;">{{ firma.Nombre + ' ' +  (firma.ApellidoPaterno || "") + ' ' +(firma.ApellidoMaterno || "") }}</td>

                        <td class="text-center align-middle" style="width:20%;">{{ firma.Direccion }}</td>

                        <td class="text-center align-middle" style="width:20%;">{{ firma.MensajeProximaFirma || "Sin ningún mensaje"}}</td>
                    
                        <td class="text-center align-middle" style="width:1%;">


                            

                            <i v-show="AccionesMostrar.mensaje" class="fas fa-envelope fa-lg pl-1 pr-1 iconoHabilitado" title="Enviar mensaje proxima firma" @click="limpiarAccionesParaPadre5(); informacionParaPadre5.Accion.Mensaje = true; eventoValorParaElPadre5(indexImp5)"></i>

                            
                            
                        
                        <!--  // Nota: procesado.Firmas y firma.Delito vienen del API de igual firma firma.FirmaId y procesado.Nombre // -->
                            
                        </td>
                    </tr>
                
            </tbody>
         </table>    



         </div>


         <hr />





         </div>



         <div class="div" v-if="TablaReporteDeCatalogoDeFirmantes" id="TablaReporteDeCatalogoDeFirmantes"  >

            <!-- <h5 v-if="(TablaReporteDeCatalogoDeFirmantes) &&(AccionesMostrar.reportes)">Reporte de catalogo de firmantes</h5> -->


            


            <h5 v-if="(TablaReporteDeCatalogoDeFirmantes) &&(AccionesMostrar.reportes)">{{ obtenerTituloBusquedaReporteDeCatalogoDeFirmantes() }}</h5>

            <h5 v-if="(TablaReporteDeCatalogoDeFirmantes) &&(AccionesMostrar.consulta)">Consulta del catalogo de firmantes</h5> 

            <hr />

            <!-- <div v-if="(TablaReporteDeCatalogoDeFirmantes) &&(AccionesMostrar.reportes)" class="d-flex" style="height: 20px;">
            <div class="vr"></div>
            </div> -->

                

            <div class="table-responsive">

            <table v-if="TablaReporteDeCatalogoDeFirmantes" class="table table-striped table-light table-hover table-bordered table-condensed " id="tablaDeProcesados_ReporteDeCatalogoDeFirmantesPaginacion_table"
                data-search="false" 
                data-toggle="tablaDeProcesados_ReporteDeCatalogoDeFirmantes_table" 
                data-pagination="false" 
                data-toolbar="#tablaDeProcesados_texto_div"
                data-page-size="5"
                data-page-list="[2,5,10]"
                data-undefined-text="Sin información"
                data-minimum-count-columns="0">
            <thead class="thead-green">
                <tr>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:2%;" class="text-center">Clave del Procesado</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:25%;" class="text-center">Juzgado</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:4%;" class="text-center">Materia</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:25%;" class="text-center">Tipo de documento</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:2%;" class="text-center">Consecutivo</th>                                        
                    <th v-if="AccionesMostrar.mostrardelitos" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:2%;" class="text-center">Delito</th>

                    <th v-if="(TablaReporteDeCatalogoDeFirmantes) &&(AccionesMostrar.mostrartituloreporte)" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:7%;" class="text-center">Temporalidad</th>

                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:15%;" class="text-center">Fecha de alta</th>

                    <!-- <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:15%;" class="text-center">Estatus Procesado</th> -->
                    
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:20%;" class="text-center">Nombre</th>
                    <th v-if="!AccionesMostrar.reportes" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:12%;" class="text-center">Acciones</th>
                </tr>
            </thead>
            <tbody class="text-dark">
                
                    <tr v-for="(procesado, indexImp3) in TablaReporteDeCatalogoDeFirmantes" :key="indexImp3" >


                        <td class="text-center align-middle" style="width:2%;">{{ procesado.ClaveDelProcesado }}</td>




                        <td class="text-center align-middle"  style="width:25%;">




                        <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:center;">
                            <li v-for="(area,index) in (procesado.ExpedientesProcesados)" :key="index" style="height: auto;" >
                                    {{area.Area.Nombre}}
                                </li>
                            </ul>
                            
                        </td>


                        <td class="text-center align-middle"  style="width:4%;">

                            <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:center;">
                                <li v-for="(materia,index) in (procesado.ExpedientesProcesados)" :key="index" style="height: auto;">
                                    {{materia.Materia.Nombre}}
                                </li>
                            </ul>
                            
                        </td>




                        <td class="text-center align-middle"  style="width:25%;">

                            <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:center;">
                                <li v-for="(tipodocumento,index) in (procesado.ExpedientesProcesados)" :key="index" style="height: auto;">
                                    {{tipodocumento.TipoDocumento.Nombre}}
                                </li>
                            </ul>
                            
                        </td>



                        <td class="text-center align-middle"  style="width:2%;">

                            <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:center;">
                                <li v-for="(consecutivo,index) in (procesado.ExpedientesProcesados)" :key="index" style="height: auto;">
                                    {{ (consecutivo.Expediente.NumeroRomano ? (consecutivo.Expediente.Consecutivo + '-' + consecutivo.Expediente.NumeroRomano) : consecutivo.Expediente.Consecutivo) }}
                                </li>
                            </ul>
                            
                        </td>




                        <td v-if="AccionesMostrar.mostrardelitos" class="text-center align-middle"  style="width:2%;">

                            <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:center;">
                                <li v-for="(procesado,index) in (procesado.DelitosProcesados)" :key="index">
                                    {{procesado.Delito.Nombre}}
                                </li>
                            </ul>
                            
                        </td>




                        

                        <td v-if="(TablaReporteDeCatalogoDeFirmantes) &&(AccionesMostrar.mostrartituloreporte)"  class="text-center align-middle" style="width:7%;">{{  procesado.TipoTemporalidad.Temporalidad }} días</td>


                        <!-- <td class="text-center align-middle" style="width:15%;">{{ delito.DelitoDBPJ.Nombre }}</td> -->
                        <td class="text-center align-middle" style="width:10%;">{{ procesado.FechaDeAlta ? obtenerFechaConFormato(procesado.FechaDeAlta) : ""}}</td>
                        <!-- <td class="text-center align-middle" style="width:15%;">{{ procesado.TipoEstatusProcesado.Nombre }}</td> -->

                        
                        <td class="text-center align-middle" style="width:20%;">{{ procesado.Nombre + ' ' +  (procesado.ApellidoPaterno || "") + ' ' +(procesado.ApellidoMaterno || "") }}</td>
                    
                        <td v-if="!AccionesMostrar.reportes" class="text-center align-middle" style="width:12%;">


                            
                            

                            <i v-show="AccionesMostrar.visualizacion" class="fas fa-eye fa-lg p-1 iconoHabilitado" title="Visualizar toda la información" @click="limpiarAccionesParaPadre3(); informacionParaPadre3.Accion.Visualizar = true; eventoValorParaElPadre3(indexImp3)"></i>

                            
                        </td>
                    </tr>
                
            </tbody>
            </table>


            <div v-if="TablaReporteDeCatalogoDeFirmantes.length>=10"  class="d-flex" style="height: 40px;">

            </div>

            <!-- <div v-else="TablaReporteDeCatalogoDeFirmantes.length<=1"  class="d-flex" style="height: 5px;">

            </div> -->


             <hr />

         <h6 v-if="(TablaReporteDeCatalogoDeFirmantes) &&(AccionesMostrar.mostrartituloreporte)">Total de numero de firmantes dados de alta por reporte: {{TablaReporteDeCatalogoDeFirmantes.length}}</h6>

         <h6 v-if="(TablaReporteDeCatalogoDeFirmantes) &&(!AccionesMostrar.mostrartituloreporte)">Total de numero de firmantes dados de alta por busqueda: {{TablaReporteDeCatalogoDeFirmantes.length}}</h6>
         
         <div  class="d-flex" style="height: 5px;">
         </div>

                    <div v-if="(TablaReporteDeCatalogoDeFirmantes) &&(!AccionesMostrar.consulta)">
                                
                                <button type="button" class="btn btn-success overwrapDeBotones mr-3"  @click="ImprimirReporteCatalogoDeFirmantes()"><i class="fas fa-print fa-lg"></i>&nbsp;&nbsp;Imprimir</button>

                                <button type="button" class="btn btn-success overwrapDeBotones mr-3"  @click="DescargarExcelCatalogoDeFirmantes()"><i class="fas fa-download fa-lg"></i>&nbsp;&nbsp;Descargar excel</button>
                    
                        <div  class="d-flex" style="height: 5px;">
                        </div>
                    
                    </div>

                        </div>


              

                       




                     </div>



         <!-- ////////////////////////////////////////////////// reporte impreso de catalogo de firmantes -->



         <div  id="printMe5" v-if="TablaReporteDeCatalogoDeFirmantes" hidden>

            <!-- <h5 v-if="(TablaReporteDeCatalogoDeFirmantes) &&(AccionesMostrar.reportes)">Reporte de catalogo de firmantes</h5> -->

            <div v-if="TablaReporteDeCatalogoDeFirmantes" id="logo_div"> 



                <div class="table-responsive">

                <table>

                <tr >


            <td> <img style="width: 40%" src="../../../assets/Logotipo_Positivo_Vertical-recibo.png" alt="Logo de Poder Judicial del Estado de Aguascalientes"  />  </td>
            <td class="text-center"><h5>H. Supremo Tribunal de Justicia del Estado de Aguascalientes</h5></td>
                                


            </tr>
                            

                </table>
        
                </div>


        



                        

            </div>


            <h5 v-if="(TablaReporteDeCatalogoDeFirmantes) &&(AccionesMostrar.reportes)">{{ obtenerTituloBusquedaReporteDeCatalogoDeFirmantes() }}</h5>
                

            <div v-if="(TablaReporteDeCatalogoDeFirmantes) &&(AccionesMostrar.reportes)" class="d-flex" style="height: 20px;">
            <div class="vr"></div>
            </div>    

            <div class="table-responsive">


            <table v-if="TablaReporteDeCatalogoDeFirmantes" class="table table-bordered" id="tablaDeReporteDeCatalogoDeFirmantes_reporte_table"
                data-search="false" 
                data-toggle="tablaDeReporteDeCatalogoDeFirmantes_reporte_table" 
                data-pagination="false" 
                data-toolbar="#tablaDeReporteDeCatalogoDeFirmantes_reporte_texto_div"
                data-page-size="5"
                data-page-list="[2,5,10]"
                data-undefined-text="Sin información"
                data-minimum-count-columns="0">
            <thead class="thead-light">
                <tr>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:7%;" class="text-center">Clave del Procesado</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:15%;" class="text-center">Juzgado</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Materia</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Tipo de documento</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Consecutivo</th>                                        
                    <!-- <th v-if="AccionesMostrar.mostrardelitos" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:15%;" class="text-center">Delito/os</th> -->
                    
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:7%;" class="text-center">Temporalidad</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:15%;" class="text-center">Fecha de alta</th>

                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:20%;" class="text-center">Nombre</th>
                    
                </tr>
            </thead>
            <tbody class="text-dark">
                <template v-for="(procesado, indexImp3) in TablaReporteDeCatalogoDeFirmantes"  > 

                    <tr v-for="(delito, indexDel3) in procesado.ExpedientesProcesados" :key="'procesado' + delito.ProcesadoId + procesado.PersonaId  + delito.ExpedienteId + indexDel3" >

                        <td v-if="indexDel3 === 0" v-bind:rowspan = "procesado.ExpedientesProcesados.length"  class="text-center align-middle" style="width:7%;">{{ procesado.ClaveDelProcesado }}</td>


                        <!-- <td  class="text-center align-middle"  style="width:17%;">




                            <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:left;">
                                <li v-for="area in (procesado.ExpedientesProcesados)">
                                    {{area.Area.Nombre}}
                                </li>
                            </ul>
                            
                        </td> -->


                        <td class="text-center align-middle" style="width:7%;">{{ delito.Area.Nombre }}</td>





                        <!-- <td class="text-center align-middle"  style="width:17%;">

                            <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:left;">
                                <li v-for="materia in (procesado.ExpedientesProcesados)">
                                    {{materia.Materia.Nombre}}
                                </li>
                            </ul>
                            
                        </td> -->


                        <td class="text-center align-middle" style="width:7%;">{{ delito.Materia.Nombre }}</td>




                        <!-- <td class="text-center align-middle"  style="width:17%;">

                            <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:left;">
                                <li v-for="tipodocumento in (procesado.ExpedientesProcesados)">
                                    {{tipodocumento.TipoDocumento.Nombre}}
                                </li>
                            </ul>
                            
                        </td> -->


                        <td class="text-center align-middle" style="width:7%;">{{ delito.TipoDocumento.Nombre }}</td>



                        <!-- <td  class="text-center align-middle"  style="width:17%;">

                            <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:left;">
                                <li v-for="consecutivo in (procesado.ExpedientesProcesados)">
                                    {{consecutivo.Expediente.Consecutivo}}
                                </li>
                            </ul>
                            
                        </td> -->


                        <td class="text-center align-middle" style="width:7%;">{{ (delito.Expediente.NumeroRomano ? (delito.Expediente.Consecutivo + '-' + delito.Expediente.NumeroRomano) : delito.Expediente.Consecutivo) }}</td>




                        <!-- //////////////////////////////////////////////// -->
                        <!-- <td class="text-center align-middle" style="width:10%;">{{ delito.Expediente.Consecutivo }}</td> -->


                        <!-- <td class="text-center align-middle" style="width:15%;">{{ delito.DelitoDBPJ.Nombre }}</td> -->
                        <!-- //////////////////////////////////////////////////// -->





                        <!-- <td v-if="AccionesMostrar.mostrardelitos" class="text-center align-middle"  style="width:17%;">

                            <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:left;">
                                <li v-for="procesado in (procesado.DelitosProcesados)">
                                    {{procesado.Delito.Nombre}}
                                </li>
                            </ul>
                            
                        </td> -->





                    <td v-if="indexDel3 === 0" v-bind:rowspan = "procesado.ExpedientesProcesados.length" class="text-center align-middle" style="width:7%;">{{  procesado.TipoTemporalidad.Temporalidad }} días</td>

                        <td v-if="indexDel3 === 0" v-bind:rowspan = "procesado.ExpedientesProcesados.length" class="text-center align-middle" style="width:10%;">{{ procesado.FechaDeAlta ? obtenerFechaConFormato4(procesado.FechaDeAlta) : ""}}</td>


                        
                        <td v-if="indexDel3 === 0" v-bind:rowspan = "procesado.ExpedientesProcesados.length" class="text-center align-middle" style="width:20%;">{{ procesado.Nombre + ' ' +  (procesado.ApellidoPaterno || "") + ' ' +(procesado.ApellidoMaterno || "") }}</td>
                    
                    
                    </tr>
                </template>
            </tbody>
            </table>


            <div v-if="TablaReporteDeCatalogoDeFirmantes" class="d-flex" style="height: 5px;">

            </div>

            <h6 v-if="(TablaReporteDeCatalogoDeFirmantes) &&(AccionesMostrar.mostrartituloreporte)">Total de numero de firmantes dados de alta por reporte: {{TablaReporteDeCatalogoDeFirmantes.length}}</h6>

            <h6 v-if="(TablaReporteDeCatalogoDeFirmantes) &&(!AccionesMostrar.mostrartituloreporte)">Total de numero de firmantes dados de alta por busqueda: {{TablaReporteDeCatalogoDeFirmantes.length}}</h6>

            </div>





         </div>


         <!-- //////////////////////////////////////////////// -->



         <!-- ////////////////////////////////////////////////// reporte en excel de catalogo de firmantes -->


         <div id="TablaReporteDeCatalogoDeFirmantesExcel" v-if="TablaReporteDeCatalogoDeFirmantes" hidden>

            <!-- <h5 v-if="(TablaReporteDeCatalogoDeFirmantes) &&(AccionesMostrar.reportes)">Reporte de catalogo de firmantes</h5> -->

            <div v-if="TablaReporteDeCatalogoDeFirmantes" id="logo_div"> 

            <div class="table-responsive">

            <table>

            <tr >


            <td> <img style="width: 40%" src="../../../assets/Logotipo_Positivo_Vertical-recibo.png" alt="Logo de Poder Judicial del Estado de Aguascalientes"  />  </td>
            <td class="text-center"><h5>H. Supremo Tribunal de Justicia del Estado de Aguascalientes</h5></td>
                                


            </tr>
                            

            </table>

            </div>




                

            </div>


            <h5 v-if="(TablaReporteDeCatalogoDeFirmantes) &&(AccionesMostrar.reportes)">{{ obtenerTituloBusquedaReporteDeCatalogoDeFirmantes() }}</h5>


            <div v-if="(TablaReporteDeCatalogoDeFirmantes) &&(AccionesMostrar.reportes)" class="d-flex" style="height: 20px;">
            <div class="vr"></div>
            </div>    

            <div class="table-responsive">


            <table v-if="TablaReporteDeCatalogoDeFirmantes" class="table table-bordered" id="tablaDeReporteDeCatalogoDeFirmantes_reporte_excel_table"
                data-search="false" 
                data-toggle="tablaDeReporteDeCatalogoDeFirmantes_reporte_excel_table" 
                data-pagination="false" 
                data-toolbar="#tablaDeReporteDeCatalogoDeFirmantes_reporte_excel_texto_div"
                data-page-size="5"
                data-page-list="[2,5,10]"
                data-undefined-text="Sin información"
                data-minimum-count-columns="0">
            <thead class="thead-green">
                <tr>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:7%;" class="text-center">Clave del Procesado</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:15%;" class="text-center">Juzgado</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Materia</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Tipo de documento</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Consecutivo</th>                                        
                    <!-- <th v-if="AccionesMostrar.mostrardelitos" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:15%;" class="text-center">Delito/os</th> -->
                    
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:7%;" class="text-center">Temporalidad</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:15%;" class="text-center">Fecha de alta</th>

                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:20%;" class="text-center">Nombre</th>
                    
                </tr>
            </thead>
            <tbody class="text-dark">
                    <template v-for="(procesado, indexImp3) in TablaReporteDeCatalogoDeFirmantes"  > 

                        <tr v-for="(delito, indexDel3) in procesado.ExpedientesProcesados" :key="'procesado' + delito.ProcesadoId + procesado.PersonaId  + delito.ExpedienteId + indexDel3" >

                        <td  class="text-center align-middle" style="width:7%;">{{ procesado.ClaveDelProcesado }}</td>


                        

                        <td class="text-center align-middle" style="width:7%;">{{ delito.Area.Nombre }}</td>





                        
                        <td class="text-center align-middle" style="width:7%;">{{ delito.Materia.Nombre }}</td>




                        

                        <td class="text-center align-middle" style="width:7%;">{{ delito.TipoDocumento.Nombre }}</td>



                        

                        <td class="text-center align-middle" style="width:7%;">{{ (delito.Expediente.NumeroRomano ? (delito.Expediente.Consecutivo + '-' + delito.Expediente.NumeroRomano) : delito.Expediente.Consecutivo) }}</td>







                        <td  class="text-center align-middle" style="width:7%;">{{  procesado.TipoTemporalidad.Temporalidad }} días</td>

                        <td  class="text-center align-middle" style="width:10%;">{{ procesado.FechaDeAlta ? obtenerFechaConFormato4(procesado.FechaDeAlta) : ""}}</td>


                        
                        <td  class="text-center align-middle" style="width:20%;">{{ procesado.Nombre + ' ' +  (procesado.ApellidoPaterno || "") + ' ' +(procesado.ApellidoMaterno || "") }}</td>
                        
                        
                    </tr>
                </template>
            </tbody>
            </table>


            <div v-if="TablaReporteDeCatalogoDeFirmantes" class="d-flex" style="height: 5px;">

            </div>

            <h6 v-if="(TablaReporteDeCatalogoDeFirmantes) &&(AccionesMostrar.mostrartituloreporte)">Total de numero de firmantes dados de alta por reporte: {{TablaReporteDeCatalogoDeFirmantes.length}}</h6>

            <h6 v-if="(TablaReporteDeCatalogoDeFirmantes) &&(!AccionesMostrar.mostrartituloreporte)">Total de numero de firmantes dados de alta por busqueda: {{TablaReporteDeCatalogoDeFirmantes.length}}</h6>

            </div>





            </div>

         <!-- Nota: es por el formato de la fecha-->


         <!-- //////////////////////////////////////////////// -->



         <div class="div" id="TablaReporteDeCatalogoDeFirmantesDadosDeBaja" v-if="TablaReporteDeCatalogoDeFirmantesDadosDeBaja" >

            <!-- <h5 v-if="(TablaReporteDeCatalogoDeFirmantesDadosDeBaja) &&(AccionesMostrar.reportes)">Reporte de catalogo de firmantes dados de baja</h5> -->

            


            <h5 v-if="(TablaReporteDeCatalogoDeFirmantesDadosDeBaja) &&(AccionesMostrar.reportes)">{{ obtenerTituloBusquedaReporteDeCatalogoDeFirmantesDadosDeBaja() }}</h5>

            <h5 v-if="(TablaReporteDeCatalogoDeFirmantesDadosDeBaja) &&(AccionesMostrar.consulta)">Consulta del catalogo de firmantes dados de baja</h5>

            <hr />





            <!-- <div v-if="(TablaReporteDeCatalogoDeFirmantesDadosDeBaja) &&(AccionesMostrar.reportes)" class="d-flex" style="height: 20px;">
                <div class="vr"></div>
                </div> -->

        



            <div class="table-responsive">

            <table v-if="TablaReporteDeCatalogoDeFirmantesDadosDeBaja" class="table table-striped table-light table-hover table-bordered table-condensed " id="tablaDeProcesados_ReporteDeCatalogoDeFirmantesDadosDeBajaPaginacion_table"
                    data-search="false" 
                    data-toggle="tablaDeProcesados_ReporteDeCatalogoDeFirmantesDadosDeBaja_table" 
                    data-pagination="false" 
                    data-toolbar="#tablaDeProcesados_texto_div"
                    data-page-size="5"
                    data-page-list="[2,5,10]"
                    data-undefined-text="Sin información"
                    data-minimum-count-columns="0">
                <thead class="thead-green">
                    <tr>
                        <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:2%;" class="text-center">Clave del Procesado</th>
                        <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:25%;" class="text-center">Juzgado</th>
                        <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:4%;" class="text-center">Materia</th>
                        <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:25%;" class="text-center">Tipo de documento</th>
                        <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:2%;" class="text-center">Consecutivo</th>                                        
                        <th v-if="AccionesMostrar.mostrardelitos" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:2%;" class="text-center">Delito/os</th>

                        <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:15%;" class="text-center">Fecha de alta</th>

                        <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:15%;" class="text-center">Fecha de baja</th>

                        <!-- <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:15%;" class="text-center">Estatus Procesado</th> -->
                        
                        <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:20%;" class="text-center">Nombre</th>
                        <th v-if="!AccionesMostrar.reportes" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:12%;" class="text-center">Acciones</th>
                    </tr>
                </thead>
                <tbody class="text-dark">
                    
                        <tr v-for="(procesado, indexImp4) in TablaReporteDeCatalogoDeFirmantesDadosDeBaja" :key="indexImp4" >

                            <td class="text-center align-middle" style="width:2%;">{{ procesado.ClaveDelProcesado }}</td>




                            <td class="text-center align-middle"  style="width:25%;">




                                <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:center;">
                                    <li v-for="(area,index) in (procesado.ExpedientesProcesados)" :key="index" style="height: auto;" >
                                        {{area.Area.Nombre}}
                                    </li>
                                </ul>
                                
                            </td>


                            <td class="text-center align-middle"  style="width:4%;">

                                <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:center;">
                                    <li v-for="(materia,index) in (procesado.ExpedientesProcesados)" :key="index" style="height: auto;">
                                        {{materia.Materia.Nombre}}
                                    </li>
                                </ul>
                                
                            </td>




                            <td class="text-center align-middle"  style="width:25%;">

                                <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:center;">
                                    <li v-for="(tipodocumento,index) in (procesado.ExpedientesProcesados)" :key="index" style="height: auto;">
                                        {{tipodocumento.TipoDocumento.Nombre}}
                                    </li>
                                </ul>
                                
                            </td>



                            <td class="text-center align-middle"  style="width:2%;">

                                <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:center;">
                                    <li v-for="(consecutivo,index) in (procesado.ExpedientesProcesados)" :key="index" style="height: auto;">
                                        {{ (consecutivo.Expediente.NumeroRomano ? (consecutivo.Expediente.Consecutivo + '-' + consecutivo.Expediente.NumeroRomano) : consecutivo.Expediente.Consecutivo) }}
                                    </li>
                                </ul>
                                
                            </td>





                            
                            <!-- <td class="text-center align-middle" style="width:15%;">{{ delito.DelitoDBPJ.Nombre }}</td> -->
                            <td v-if="AccionesMostrar.mostrardelitos" class="text-center align-middle"  style="width:17%;">

                                <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:center;">
                                    <li v-for="(procesado,index) in (procesado.DelitosProcesados)" :key="index">
                                        {{procesado.Delito.Nombre}}
                                    </li>
                                </ul>
                                
                            </td>
                            <td class="text-center align-middle" style="width:10%;">{{ procesado.FechaDeAlta ? obtenerFechaConFormato(procesado.FechaDeAlta) : ""}}</td>
                            <td class="text-center align-middle" style="width:10%;">{{ procesado.FechaDeBaja ? obtenerFechaConFormato(procesado.FechaDeBaja) : ""}}</td>
                            <!-- <td class="text-center align-middle" style="width:15%;">{{ procesado.TipoEstatusProcesado.Nombre }}</td> -->

                            
                            <td class="text-center align-middle" style="width:20%;">{{ procesado.Nombre + ' ' +  (procesado.ApellidoPaterno || "") + ' ' +(procesado.ApellidoMaterno || "") }}</td>
                        
                            <td v-if="!AccionesMostrar.reportes" class="text-center align-middle" style="width:12%;">


                                

                                <i v-show="AccionesMostrar.visualizacion" class="fas fa-eye fa-lg p-1 iconoHabilitado" title="Visualizar toda la información" @click="limpiarAccionesParaPadre4(); informacionParaPadre4.Accion.Visualizar = true; eventoValorParaElPadre4(indexImp4)"></i>

                                <i v-show="AccionesMostrar.reactivacion" class="fas fa-redo fa-lg p-1 iconoHabilitado" title="Rectivar procesado" @click="limpiarAccionesParaPadre4(); informacionParaPadre4.Accion.Reactivar = true; eventoValorParaElPadre4(indexImp4)"></i>

                                
                            </td>

                        </tr>
                    
                </tbody>
            </table>
            
            <div v-if="TablaReporteDeCatalogoDeFirmantesDadosDeBaja.length>=10"  class="d-flex" style="height: 40px;">

            </div>

            <!-- <div v-else="TablaReporteDeCatalogoDeFirmantesDadosDeBaja.length<=1"  class="d-flex" style="height: 1px;">

            </div> -->

            <hr />

            <h6 >Total de numero firmantes dados de baja por reporte: {{TablaReporteDeCatalogoDeFirmantesDadosDeBaja.length}}</h6>

            <div  class="d-flex" style="height: 5px;">
            </div>


            <div v-if="(TablaReporteDeCatalogoDeFirmantesDadosDeBaja) && (!AccionesMostrar.consulta)">
                        
                        <button type="button" class="btn btn-success overwrapDeBotones mr-3"  @click="ImprimirReporteCatalogoDeFirmantesDadosDeBaja()"><i class="fas fa-print fa-lg"></i>&nbsp;&nbsp;Imprimir</button>

                        <button type="button" class="btn btn-success overwrapDeBotones mr-3"  @click="DescargarExcelCatalogoDeFirmantesDadosDeBaja()"><i class="fas fa-download fa-lg"></i>&nbsp;&nbsp;Descargar excel</button>
                        
                        <div  class="d-flex" style="height: 5px;">
                            </div>
                </div>




            </div>


       


            </div >



         <!-- ////////////////////////////////////////////////////////////// reporte impreso de catalogo de firmantes dados de baja-->



         <div  id="printMe6" hidden v-if="TablaReporteDeCatalogoDeFirmantesDadosDeBaja">

            <!-- <h5 v-if="(TablaReporteDeCatalogoDeFirmantesDadosDeBaja) &&(AccionesMostrar.reportes)">Reporte de catalogo de firmantes dados de baja</h5> -->


            <div v-if="TablaReporteDeCatalogoDeFirmantesDadosDeBaja" id="logo_div"> 


            <div class="table-responsive">

            <table >

            <tr >


            <td> <img style="width: 40%" src="../../../assets/Logotipo_Positivo_Vertical-recibo.png" alt="Logo de Poder Judicial del Estado de Aguascalientes"  />  </td>
            <td class="text-center"><h5>H. Supremo Tribunal de Justicia del Estado de Aguascalientes</h5></td>
                                


            </tr>
                            

            </table>

            </div>

        



                        

            </div>


            <h5 v-if="(TablaReporteDeCatalogoDeFirmantesDadosDeBaja) &&(AccionesMostrar.reportes)">{{ obtenerTituloBusquedaReporteDeCatalogoDeFirmantesDadosDeBaja() }}</h5>


            <div v-if="(TablaReporteDeCatalogoDeFirmantesDadosDeBaja) &&(AccionesMostrar.reportes)" class="d-flex" style="height: 20px;">
            <div class="vr"></div>
            </div>



            <div class="table-responsive">


            
            <table v-if="TablaReporteDeCatalogoDeFirmantesDadosDeBaja" class="table table-striped table-light table-hover table-bordered table-condensed " id="tablaDeReporteDeCatalogoDeFirmantesDadosDeBaja_reporte_table"
                    data-search="false" 
                    data-toggle="tablaDeReporteDeCatalogoDeFirmantesDadosDeBaja_reporte_table" 
                    data-pagination="false" 
                    data-toolbar="#tablaDeReporteDeCatalogoDeFirmantesDadosDeBaja_reporte_texto_div"
                    data-page-size="5"
                    data-page-list="[2,5,10]"
                    data-undefined-text="Sin información"
                    data-minimum-count-columns="0">
                <thead class="thead-light">
                    <tr>
                        <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:7%;" class="text-center">Clave del Procesado</th>
                        <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:15%;" class="text-center">Juzgado</th>
                        <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Materia</th>
                        <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Tipo de documento</th>
                        <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Consecutivo</th>                                        
                        <!-- <th v-if="AccionesMostrar.mostrardelitos" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:15%;" class="text-center">Delito/os</th> -->
                        
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:7%;" class="text-center">Temporalidad</th>
                        <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:15%;" class="text-center">Fecha de alta</th>

                        <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:15%;" class="text-center">Fecha de baja</th> 
                    
                        <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:20%;" class="text-center">Nombre</th>
                        
                    </tr>
                </thead>
                <tbody class="text-dark">
                    <template v-for="(procesado, indexImp4) in TablaReporteDeCatalogoDeFirmantesDadosDeBaja"  > 

                        <tr v-for="(delito, indexDel8) in procesado.ExpedientesProcesados" :key="'procesado' + delito.ProcesadoId + procesado.PersonaId  + delito.ExpedienteId + indexDel8" >

                            <td v-if="indexDel8 === 0" v-bind:rowspan = "procesado.ExpedientesProcesados.length"  class="text-center align-middle" style="width:7%;">{{ procesado.ClaveDelProcesado }}</td>


                            <!-- <td  class="text-center align-middle"  style="width:17%;">




                                <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:left;">
                                    <li v-for="area in (procesado.ExpedientesProcesados)">
                                        {{area.Area.Nombre}}
                                    </li>
                                </ul>
                                
                            </td> -->


                            <td class="text-center align-middle" style="width:7%;">{{ delito.Area.Nombre }}</td>





                            <!-- <td class="text-center align-middle"  style="width:17%;">

                                <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:left;">
                                    <li v-for="materia in (procesado.ExpedientesProcesados)">
                                        {{materia.Materia.Nombre}}
                                    </li>
                                </ul>
                                
                            </td> -->


                            <td class="text-center align-middle" style="width:7%;">{{ delito.Materia.Nombre }}</td>




                            <!-- <td class="text-center align-middle"  style="width:17%;">

                                <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:left;">
                                    <li v-for="tipodocumento in (procesado.ExpedientesProcesados)">
                                        {{tipodocumento.TipoDocumento.Nombre}}
                                    </li>
                                </ul>
                                
                            </td> -->


                            <td class="text-center align-middle" style="width:7%;">{{ delito.TipoDocumento.Nombre }}</td>



                            <!-- <td  class="text-center align-middle"  style="width:17%;">

                                <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:left;">
                                    <li v-for="consecutivo in (procesado.ExpedientesProcesados)">
                                        {{consecutivo.Expediente.Consecutivo}}
                                    </li>
                                </ul>
                                
                            </td> -->


                            <!-- <td class="text-center align-middle" style="width:7%;">{{ delito.Expediente.Consecutivo }}</td> -->
                            <td class="text-center align-middle" style="width:7%;">{{ (delito.Expediente.NumeroRomano ? (delito.Expediente.Consecutivo + '-' + delito.Expediente.NumeroRomano) : delito.Expediente.Consecutivo) }}</td>




                            <!-- //////////////////////////////////////////////// -->
                            <!-- <td class="text-center align-middle" style="width:10%;">{{ delito.Expediente.Consecutivo }}</td> -->


                            <!-- <td class="text-center align-middle" style="width:15%;">{{ delito.DelitoDBPJ.Nombre }}</td> -->
                            <!-- //////////////////////////////////////////////////// -->





                            <!-- <td v-if="AccionesMostrar.mostrardelitos" class="text-center align-middle"  style="width:17%;">

                                <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:left;">
                                    <li v-for="procesado in (procesado.DelitosProcesados)">
                                        {{procesado.Delito.Nombre}}
                                    </li>
                                </ul>
                                
                            </td> -->





                        <td v-if="indexDel8 === 0" v-bind:rowspan = "procesado.ExpedientesProcesados.length" class="text-center align-middle" style="width:7%;">{{  procesado.TipoTemporalidad.Temporalidad }} días</td>

                            <td v-if="indexDel8 === 0" v-bind:rowspan = "procesado.ExpedientesProcesados.length" class="text-center align-middle" style="width:10%;">{{ procesado.FechaDeAlta ? obtenerFechaConFormato(procesado.FechaDeAlta) : ""}}</td>

                            <td v-if="indexDel8 === 0" v-bind:rowspan = "procesado.ExpedientesProcesados.length" class="text-center align-middle" style="width:10%;">{{ procesado.FechaDeBaja ? obtenerFechaConFormato(procesado.FechaDeBaja) : ""}}</td> 

                            
                            <td v-if="indexDel8 === 0" v-bind:rowspan = "procesado.ExpedientesProcesados.length" class="text-center align-middle" style="width:20%;">{{ procesado.Nombre + ' ' +  (procesado.ApellidoPaterno || "") + ' ' +(procesado.ApellidoMaterno || "") }}</td>
                        
                        
                        </tr>
                    </template>
                </tbody>
            </table>


            <div v-if="TablaReporteDeCatalogoDeFirmantesDadosDeBaja" class="d-flex" style="height: 5px;">

            </div>

            <h6 v-if="TablaReporteDeCatalogoDeFirmantesDadosDeBaja">Total de numero firmantes dados de baja por reporte: {{TablaReporteDeCatalogoDeFirmantesDadosDeBaja.length}}</h6>

            </div>





         </div >



         <!-- //////////////////////////////////////////////////////////// -->



         <!-- ////////////////////////////////////////////////////////////// reporte excel de catalogo de firmantes dados de baja-->



         <div id="TablaReporteDeCatalogoDeFirmantesDadosDeBajaExcel"  hidden v-if="TablaReporteDeCatalogoDeFirmantesDadosDeBaja">

            <!-- <h5 v-if="(TablaReporteDeCatalogoDeFirmantesDadosDeBaja) &&(AccionesMostrar.reportes)">Reporte de catalogo de firmantes dados de baja</h5> -->


            <div v-if="TablaReporteDeCatalogoDeFirmantesDadosDeBaja" id="logo_div"> 

            <div class="table-responsive">

            <table >

            <tr >


            <td> <img style="width: 40%" src="../../../assets/Logotipo_Positivo_Vertical-recibo.png" alt="Logo de Poder Judicial del Estado de Aguascalientes"  />  </td>
            <td class="text-center"><h5>H. Supremo Tribunal de Justicia del Estado de Aguascalientes</h5></td>
                        


            </tr>
                        

            </table>

         </div>






                

            </div>


            <h5 v-if="(TablaReporteDeCatalogoDeFirmantesDadosDeBaja) &&(AccionesMostrar.reportes)">{{ obtenerTituloBusquedaReporteDeCatalogoDeFirmantesDadosDeBaja() }}</h5>
                

            <div v-if="(TablaReporteDeCatalogoDeFirmantesDadosDeBaja) &&(AccionesMostrar.reportes)" class="d-flex" style="height: 20px;">
            <div class="vr"></div>
            </div>



            <div class="table-responsive">
    
            <table v-if="TablaReporteDeCatalogoDeFirmantesDadosDeBaja" class="table table-striped table-light table-hover table-bordered table-condensed " id="tablaDeReporteDeCatalogoDeFirmantesDadosDeBaja_reporte_excel_table"
                data-search="false" 
                data-toggle="tablaDeReporteDeCatalogoDeFirmantesDadosDeBaja_reporte_excel_table" 
                data-pagination="false" 
                data-toolbar="#tablaDeReporteDeCatalogoDeFirmantesDadosDeBaja_reporte_excel_texto_div"
                data-page-size="5"
                data-page-list="[2,5,10]"
                data-undefined-text="Sin información"
                data-minimum-count-columns="0">
            <thead class="thead-green">
                <tr>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:7%;" class="text-center">Clave del Procesado</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:15%;" class="text-center">Juzgado</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Materia</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Tipo de documento</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Consecutivo</th>                                        
                    <!-- <th v-if="AccionesMostrar.mostrardelitos" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:15%;" class="text-center">Delito/os</th> -->
                    
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:7%;" class="text-center">Temporalidad</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:15%;" class="text-center">Fecha de alta</th>

                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:15%;" class="text-center">Fecha de baja</th> 
                
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:20%;" class="text-center">Nombre</th>
                    
                </tr>
            </thead>
            <tbody class="text-dark">
                <template v-for="(procesado, indexImp4) in TablaReporteDeCatalogoDeFirmantesDadosDeBaja"  > 

                    <tr v-for="(delito, indexDel8) in procesado.ExpedientesProcesados" :key="'procesado' + delito.ProcesadoId + procesado.PersonaId  + delito.ExpedienteId + indexDel8" >

                        <td  class="text-center align-middle" style="width:7%;">{{ procesado.ClaveDelProcesado }}</td>


                    

                        <td class="text-center align-middle" style="width:7%;">{{ delito.Area.Nombre }}</td>






                        <td class="text-center align-middle" style="width:7%;">{{ delito.Materia.Nombre }}</td>




                    
                        <td class="text-center align-middle" style="width:7%;">{{ delito.TipoDocumento.Nombre }}</td>





                        <!-- <td class="text-center align-middle" style="width:7%;">{{ delito.Expediente.Consecutivo }}</td> -->
                        <td class="text-center align-middle" style="width:7%;">{{ (delito.Expediente.NumeroRomano ? (delito.Expediente.Consecutivo + '-' + delito.Expediente.NumeroRomano) : delito.Expediente.Consecutivo) }}</td>








                    <td  class="text-center align-middle" style="width:7%;">{{  procesado.TipoTemporalidad.Temporalidad }} días</td>

                        <td  class="text-center align-middle" style="width:10%;">{{ procesado.FechaDeAlta ? obtenerFechaConFormato4(procesado.FechaDeAlta) : ""}}</td>

                        <td  class="text-center align-middle" style="width:10%;">{{ procesado.FechaDeBaja ? obtenerFechaConFormato4(procesado.FechaDeBaja) : ""}}</td> 

                        
                        <td  class="text-center align-middle" style="width:20%;">{{ procesado.Nombre + ' ' +  (procesado.ApellidoPaterno || "") + ' ' +(procesado.ApellidoMaterno || "") }}</td>
                    
                    
                    </tr>
                </template>
            </tbody>
         </table>


         <div v-if="TablaReporteDeCatalogoDeFirmantesDadosDeBaja" class="d-flex" style="height: 5px;">

         </div>

         <h6 v-if="TablaReporteDeCatalogoDeFirmantesDadosDeBaja">Total de numero firmantes dados de baja por reporte: {{TablaReporteDeCatalogoDeFirmantesDadosDeBaja.length}}</h6>

         </div>





         </div >



         <!-- //////////////////////////////////////////////////////////// -->



         <div class="div" v-if="TablaReporteFirmasNoVigentes" id="TablaReporteFirmasNoVigentes" >




            <h5 >{{ obtenerTituloBusquedaFirmasNoVigentes() }}</h5>

            <!-- <div  class="d-flex" style="height: 20px;">
            <div class="vr"></div>
            </div>   --> 


            <hr />



            <div class="table-responsive">

            <table  class="table table-striped table-light table-hover table-bordered table-condensed " id="tablaReporteFirmasNoVigentesPaginacion_table"
            
            data-search="false" 
            data-toggle="tablaReporteFirmasNoVigentesPaginacion_table" 
            data-pagination="false" 
            data-toolbar="#tablaReporteFirmasNoVigentesPaginacion_texto_div"
            data-page-size="5"
            data-page-list="[2,5,10]"
            data-undefined-text="Sin información"
            data-minimum-count-columns="0">

                <thead class="thead-green">
                <tr>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Clave del Procesado</th>
                <!-- <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:20%;" class="text-center">Delito/os</th> -->
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:20%;" class="text-center">Juzgado</th>
                <!-- <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:35%;" class="text-center">Tipo de documento</th> -->
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:5%;" class="text-center">Consecutivo</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:2%;" class="text-center">Temporalidad de la Firma</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:7%;" class="text-center">Días en firmar</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Fecha Última Firma</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Fecha Próxima Firma</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Fecha En Que Firmó</th>
                <!-- <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Estatus de Firma</th> -->
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Firmó en Tiempo</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Firmó en Dispositivo</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:20%;" class="text-center">Nombre</th>

                <th v-if="!AccionesMostrar.reportes" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:1%;" class="text-center">Acciones</th>
                </tr>

                </thead>

                <tbody class="text-dark">



                <tr v-for="(firma, indexImp7) in TablaReporteFirmasNoVigentes" :key="indexImp7">

                <td class="text-center align-middle " style="width:10%;">{{ firma.ClaveDelProcesado }}</td>
                <!-- <td class="text-center align-middle " style="width:15%;">{{ firma.Procesado.DelitoDBPJ.Nombre }}</td> -->



                <!-- <td class="text-center align-middle"  style="width:17%;">

                <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:left;">
                    <li v-for="delito in (firma.Procesado.DelitosProcesados)">
                        {{delito.Delito.Nombre}}
                    </li>
                </ul>

                </td> -->


                <td class="text-center align-middle"  style="width:20%;">
                <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:center;"  >
                <li v-for="(area,index) in (firma.ExpedientesProcesados)" :key="index" style="height: auto;" >
                {{area.Area.Nombre}}
                </li>
                </ul>
                </td>



                <!-- <td class="text-center align-middle"  style="width:25%;">

                <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:center;"  >
                <li v-for="(tipodocumento,index) in (firma.ExpedientesProcesados)" :key="index" style="height: auto;">
                            {{tipodocumento.TipoDocumento.Nombre}}
                </li>
                </ul>
                
                </td> -->



                <td  class="text-center align-middle"  style="width:5%;">

                <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:center;"  >
                <li v-for="(consecutivo,index) in (firma.ExpedientesProcesados)" :key="index" style="height: auto;">
                <!-- {{consecutivo.Expediente.Consecutivo+((consecutivo.Expediente.NumeroRomano) || "")}} -->
                             {{ (consecutivo.Expediente.NumeroRomano ? (consecutivo.Expediente.Consecutivo + '-' + consecutivo.Expediente.NumeroRomano) : consecutivo.Expediente.Consecutivo) }}
                </li>
                </ul>
                
                </td>


                <td class="text-center align-middle " style="width:2%;">{{ firma.TemporalidadFirma }} días</td>
                <td class="text-center align-middle " style="width:7%;">{{ firma.DiasEnFirmar==1 ? firma.DiasEnFirmar+' día' : firma.DiasEnFirmar+' días' }}</td>
                <td class="text-center align-middle" style="width:10%;">{{ firma.FechaUltimaFirma ? obtenerFechaConFormato(firma.FechaUltimaFirma) : ""}}</td>
                <td class="text-center align-middle" style="width:10%;">{{ firma.FechaProximaFirma ? obtenerFechaConFormato(firma.FechaProximaFirma) : ""}}</td>

            <td class="text-center align-middle" style="width:10%;">{{ firma.FechaDeRegistroEnQueFirmo ? obtenerFechaConFormato7(firma.FechaDeRegistroEnQueFirmo) : ""}}</td>

            <!-- <td class="text-center align-middle" style="width:10%;">{{ firma.TipoEstatusFirma.Nombre }}</td> -->

            <td class="text-center align-middle" style="width:10%;">{{ firma.TipoFirmoEnTiempo.Nombre }}</td>

            <td class="text-center align-middle" style="width:10%;">{{ firma.TipoFirmoEnDispositivo.Nombre }}</td>


            <td class="text-center align-middle" style="width:20%;">{{ firma.Nombre + ' ' +  (firma.ApellidoPaterno || "") + ' ' +(firma.ApellidoMaterno || "") }}</td>


            </tr>






            </tbody>



            </table>



            <div v-if="TablaReporteFirmasNoVigentes.length>=10"  class="d-flex" style="height: 40px;">

            </div>

            <!-- <div v-else="TablaReporteFirmasNoVigentes.length<=1"  class="d-flex" style="height: 1px;">

            </div> -->

            


            <hr />




            <h6 >Total de numero de firmas por reporte: {{TablaReporteFirmasNoVigentes.length}}</h6>

            <div  class="d-flex" style="height: 5px;">
            </div>

            <div id="botones reportefirmasnovigentes" >

            <button type="button" class="btn btn-success overwrapDeBotones mr-3"  @click="ImprimirReporteFirmasNoVigentes()"><i class="fas fa-print fa-lg"></i>&nbsp;&nbsp;Imprimir</button>

            <button type="button" class="btn btn-success overwrapDeBotones mr-3"  @click="DescargarExcelFirmasNoVigentes()"><i class="fas fa-download fa-lg"></i>&nbsp;&nbsp;Descargar excel</button>

            <div  class="d-flex" style="height: 5px;">
            </div>
        
            </div>

















            
            </div>
    
    

    




         </div >

         <!-- /////////////////////////////////////////////////////// Reporte Impreso de Firmas NoVigentes-->


         <div id="printMe" v-if="TablaReporteFirmasNoVigentes" hidden>



         <div  id="logo_div"> 


         <div class="table-responsive">

         <table>

         <tr >


         <td> <img style="width: 40%" src="../../../assets/Logotipo_Positivo_Vertical-recibo.png" alt="Logo de Poder Judicial del Estado de Aguascalientes"  />  </td>
         <td class="text-center"><h5>H. Supremo Tribunal de Justicia del Estado de Aguascalientes</h5></td>



         </tr>


         </table>





            </div>


         <h5 >{{ obtenerTituloBusquedaFirmasNoVigentes() }}</h5>

         <div  class="d-flex" style="height: 20px;">
         <div class="vr"></div>
         </div>


            <div class="table-responsive">


            <table  class="table table-striped table-light table-hover table-bordered table-condensed " id="tablaDeReporteFirmasNoVigentes_reporte_table"
            data-search="false" 
            data-toggle="tablaDeReporteFirmasNoVigentes_reporte_table" 
            data-pagination="false" 
            data-toolbar="#tablaDeReporteFirmasNoVigentes_reporte_texto_div"
            data-page-size="5"
            data-page-list="[2,5,10]"
            data-undefined-text="Sin información"
            data-minimum-count-columns="0">
            <thead class="thead-light">
            <tr>
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Clave del Procesado</th>
            <!-- <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:20%;" class="text-center">Delito/os</th> -->
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Juzgado</th>
            <!-- <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:35%;" class="text-center">Tipo de documento</th> -->
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:5%;" class="text-center">Consecutivo</th>
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:7%;" class="text-center">Temporalidad de la Firma</th>
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:5%;" class="text-center">Días en firmar</th>
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Fecha Última Firma</th>
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Fecha Próxima Firma</th>
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Fecha En Que Firmó</th>
            <!-- <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Estatus de Firma</th> -->
            <!-- <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:5%;" class="text-center">Firmo en Tiempo</th>
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:5%;" class="text-center">Firmo en Dispositivo</th> -->
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:20%;" class="text-center">Nombre</th>

            <th v-if="!AccionesMostrar.reportes" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:1%;" class="text-center">Acciones</th>
            </tr>
            </thead>
            <tbody class="text-dark">

            <tr v-for="(firma, indexImp7) in TablaReporteFirmasNoVigentes" :key="indexImp7">

            <td class="text-center align-middle " style="width:10%;">{{ firma.ClaveDelProcesado }}</td>
            <!-- <td class="text-center align-middle " style="width:15%;">{{ firma.Procesado.DelitoDBPJ.Nombre }}</td> -->



            <!-- <td class="text-center align-middle"  style="width:17%;">

            <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:left;">
                <li v-for="delito in (firma.Procesado.DelitosProcesados)">
                    {{delito.Delito.Nombre}}
                </li>
            </ul>

            </td> -->

            <td class="text-center align-middle"  style="width:10%;">
            <ul id="listado_delitos" class="mb-10 pl-4" style="text-align:center;   padding-left: 0.0rem!important; text-align: center"  >
            <li v-for="(area,index) in (firma.ExpedientesProcesados)" :key="index" style="height: auto; list-style-type: none;" >
            {{area.Area.Nombre}}
            </li>
            </ul>
            </td>



            <!-- <td class="text-center align-middle"  style="width:25%;">

            <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:center; padding-left: 0.0rem!important;"  >
            <li v-for="(tipodocumento,index) in (firma.ExpedientesProcesados)" :key="index" style="height: auto; list-style-type: none;">
                            {{tipodocumento.TipoDocumento.Nombre}}
            </li>
            </ul>
                
            </td> -->



            <td  class="text-center align-middle"  style="width:5%;">

            <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:center; padding-left: 0.0rem!important;"   >
            <li v-for="(consecutivo,index) in (firma.ExpedientesProcesados)" :key="index" style="height: auto; list-style-type: none;">
            <!-- {{consecutivo.Expediente.Consecutivo+((consecutivo.Expediente.NumeroRomano) || "")}} -->
                             {{ (consecutivo.Expediente.NumeroRomano ? (consecutivo.Expediente.Consecutivo + '-' + consecutivo.Expediente.NumeroRomano) : consecutivo.Expediente.Consecutivo) }}
            </li>
            </ul>
                
            </td>


            <td class="text-center align-middle " style="width:5%;">{{ firma.TemporalidadFirma }} días</td>
            <td class="text-center align-middle " style="width:7%;">{{ firma.DiasEnFirmar==1 ? firma.DiasEnFirmar+' día' : firma.DiasEnFirmar+' días' }}</td>
            <td class="text-center align-middle" style="width:10%;">{{ firma.FechaUltimaFirma ? obtenerFechaConFormato4(firma.FechaUltimaFirma) : ""}}</td>
            <td class="text-center align-middle" style="width:10%;">{{ firma.FechaProximaFirma ? obtenerFechaConFormato4(firma.FechaProximaFirma) : ""}}</td>

            <td class="text-center align-middle" style="width:10%;">{{ firma.FechaDeRegistroEnQueFirmo ? obtenerFechaConFormato9(firma.FechaDeRegistroEnQueFirmo) : ""}}</td>

            <!-- <td class="text-center align-middle" style="width:10%;">{{ firma.TipoEstatusFirma.Nombre }}</td> -->

            <!-- <td class="text-center align-middle" style="width:5%;">{{ firma.TipoFirmoEnTiempo.Nombre }}</td>

            <td class="text-center align-middle" style="width:5%;">{{ firma.TipoFirmoEnDispositivo.Nombre }}</td> -->


            <td class="text-center align-middle" style="width:20%;">{{ firma.Nombre + ' ' +  (firma.ApellidoPaterno || "") + ' ' +(firma.ApellidoMaterno || "") }}</td>


            </tr>



            </tbody>



            </table>


            <div  class="d-flex" style="height: 5px;">

            </div>


            <h6 >Total de numero de firmas por reporte: {{TablaReporteFirmasNoVigentes.length}}</h6>


            </div>           






            </div>







            </div >

            <!-- //////////////////////////////////////////////////////////// -->



            <div class="div" id="TablaReporteFirmasVigentes" v-if="TablaReporteFirmasVigentes" >






            <div  id="logo_div">              

            </div>


            


            <h5>{{ obtenerTituloBusquedaFirmasVigentes() }}</h5>

            

            <hr />

            <div class="table-responsive">

            <table class="table table-striped table-light table-hover table-bordered table-condensed " id="tablaDeReporteFirmasVigentesPaginacion_table"
                data-search="false" 
                data-toggle="tablaDeReporteFirmasVigentesPaginacion_table" 
                data-pagination="false" 
                data-toolbar="#tablaDeReporteFirmasVigentesPaginacion_texto_div"
                data-page-size="5"
                data-page-list="[2,5,10]"
                data-undefined-text="Sin información"
                data-minimum-count-columns="0">
                <thead class="thead-green">
                <tr>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Clave del Procesado</th>
                    <!-- <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:20%;" class="text-center">Delito</th> -->
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:20%;" class="text-center">Juzgado</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:20%;" class="text-center">Tipo de documento</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:5%;" class="text-center">Consecutivo</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:7%;" class="text-center">Temporalidad de la Firma</th>
                    <th v-if="numeroTablaReporteFirmasVigentes==2" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:5%;" class="text-center">Días de retraso</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Fecha Última Firma</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Fecha Próxima Firma</th>
                    
                    <!-- <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Estatus de Firma</th> -->
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:20%;" class="text-center">Nombre</th>

                    <th v-if="!AccionesMostrar.reportes" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:1%;" class="text-center">Acciones</th>
                </tr>
                </thead>
                <tbody class="text-dark">

                    <tr v-for="(firma, indexImp8) in TablaReporteFirmasVigentes" :key="indexImp8"  >
                        
                        <td class="text-center align-middle" style="width:10%;">{{ firma.ClaveDelProcesado }}</td>

                        <td class="text-center align-middle"  style="width:20%;">
                        <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:center;"  >
                        <li v-for="(area,index) in (firma.ExpedientesProcesados)" :key="index" style="height: auto;" >
                        {{area.Area.Nombre}}
                        </li>
                        </ul>
                        </td>



                       <td class="text-center align-middle"  style="width:20%;">

                       <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:center;"  >
                       <li v-for="(tipodocumento,index) in (firma.ExpedientesProcesados)" :key="index" style="height: auto;">
                            {{tipodocumento.TipoDocumento.Nombre}}
                       </li>
                       </ul>
                
                       </td>



                        <td  class="text-center align-middle"  style="width:5%;">

                        <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:center;"  >
                        <li v-for="(consecutivo,index) in (firma.ExpedientesProcesados)" :key="index" style="height: auto;">
                        <!-- {{consecutivo.Expediente.Consecutivo+((consecutivo.Expediente.NumeroRomano) || "")}} -->
                             {{ (consecutivo.Expediente.NumeroRomano ? (consecutivo.Expediente.Consecutivo + '-' + consecutivo.Expediente.NumeroRomano) : consecutivo.Expediente.Consecutivo) }}
                        </li>
                        </ul>
                
                        </td>


                        <!-- <td class="text-center align-middle" style="width:15%;">{{ firma.Procesado.DelitoDBPJ.Nombre }}</td> -->
                        <td class="text-center align-middle" style="width:7%;">{{ firma.TemporalidadFirma }} días</td>
                        <td v-if="numeroTablaReporteFirmasVigentes==2" class="text-center align-middle " style="width:5%;">{{ firma.DiasDeRetraso==1 ? firma.DiasDeRetraso+' día' : firma.DiasDeRetraso+' días' }}</td>
                        <td class="text-center align-middle" style="width:10%;">{{ firma.FechaUltimaFirma ? obtenerFechaConFormato(firma.FechaUltimaFirma) : ""}}</td>
                        <td class="text-center align-middle" style="width:10%;">{{ firma.FechaProximaFirma ? obtenerFechaConFormato(firma.FechaProximaFirma) : ""}}</td>

                        <!-- <td class="text-center align-middle" style="width:10%;">{{ firma.TipoEstatusFirma.Nombre }}</td> -->
                        

                        <td class="text-center align-middle" style="width:20%;">{{ firma.Nombre + ' ' +  (firma.ApellidoPaterno || "") + ' ' +(firma.ApellidoMaterno || "") }}</td>
                        
                        
                    </tr>

                </tbody>
                        
                        </table>


                        <div v-if="TablaReporteFirmasVigentes.length>=10" class="d-flex" style="height: 40px;">

                        </div>

                        <!-- <div v-else="TablaReporteFirmasVigentes.length<=1"  class="d-flex" style="height: 5px;">
                        </div> -->

                        


                        <hr />



                        <h6 >Total de numero de firmas por reporte: {{TablaReporteFirmasVigentes.length}}</h6>


                        <div  class="d-flex" style="height: 5px;">
                        </div>



            <div class="div" id="botonesreportefirmasvigentes">
                
                <button type="button" class="btn btn-success overwrapDeBotones mr-3"  @click="ImprimirReporteFirmasVigentes()"><i class="fas fa-print fa-lg"></i>&nbsp;&nbsp;Imprimir</button>

                <button type="button" class="btn btn-success overwrapDeBotones mr-3"  @click="DescargarExcelFirmasVigentes()"><i class="fas fa-download fa-lg"></i>&nbsp;&nbsp;Descargar excel</button>

                <div  class="d-flex" style="height: 5px;">
                </div>

            </div>




         </div >


        



         



            </div>
    
    

            <!-- /////////////////////////////////////////////////////////////////  reporte impreso de Firmas Vigentes-->



         <div  id="printMe2" v-if="TablaReporteFirmasVigentes" hidden>




            <!--  <h5 v-if="(tituloDeInformacionprueba)">{{tituloDeInformacionprueba}}</h5> -->

            <!-- <h5>{{ tituloTablaReporteFirmasVigentes }}</h5> -->


            <div  id="logo_div">
            


                <div class="table-responsive">

                
                <table>

        <tr >


            <td> <img style="width: 40%" src="../../../assets/Logotipo_Positivo_Vertical-recibo.png" alt="Logo de Poder Judicial del Estado de Aguascalientes"  />  </td>
            <td class="text-center"><h5>H. Supremo Tribunal de Justicia del Estado de Aguascalientes</h5></td>
                            


            </tr>
                        

                    </table>


                    </div>





                        

            </div>


                <h5>{{ obtenerTituloBusquedaFirmasVigentes() }}</h5>

                <div  class="d-flex" style="height: 20px;">
                <div class="vr"></div>
                </div>


                    <div class="table-responsive">

                    <table  class="table table-striped table-light table-hover table-bordered table-condensed " id="tablaDeReportesFirmasVigentes_reporte_table"
                data-search="false" 
                data-toggle="tablaDeReportesFirmasVigentes_reporte_table" 
                data-pagination="false" 
                data-toolbar="#tablaDeReportesFirmasVigentes_reporte_texto_div"
                data-page-size="5"
                data-page-list="[2,5,10]"
                data-undefined-text="Sin información"
                data-minimum-count-columns="0">
                <thead class="thead-light">
                <tr>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Clave del Procesado</th>
                    <!-- <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:20%;" class="text-center">Delito</th> -->
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:35%;" class="text-center">Juzgado</th>
                    <!-- <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:35%;" class="text-center">Tipo de documento</th> -->
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:5%;" class="text-center">Consecutivo</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:7%;" class="text-center">Temporalidad de la Firma</th>
                    <th v-if="numeroTablaReporteFirmasVigentes==2" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:5%;" class="text-center">Días de retraso</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Fecha Última Firma</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Fecha Próxima Firma</th>
                    
                    <!-- <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Estatus de Firma</th> -->
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:20%;" class="text-center">Nombre</th>

                    <th v-if="!AccionesMostrar.reportes" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:1%;" class="text-center">Acciones</th>
                </tr>
                </thead>
                <tbody class="text-dark">

                    <tr v-for="(firma, indexImp8) in TablaReporteFirmasVigentes" :key="indexImp8"  >
                        
                        <td class="text-center align-middle" style="width:10%;">{{ firma.ClaveDelProcesado }}</td>


                        <td class="text-center align-middle"  style="width:25%;">
                        <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:center; padding-left: 0.0rem!important"  >
                        <li v-for="(area,index) in (firma.ExpedientesProcesados)" :key="index" style="height: auto; list-style-type: none;" >
                        {{area.Area.Nombre}}
                        </li>
                        </ul>
                        </td>



                        <!-- <td class="text-center align-middle"  style="width:25%;">

                        <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:center; padding-left: 0.0rem!important"  >
                        <li v-for="(tipodocumento,index) in (firma.ExpedientesProcesados)" :key="index" style="height: auto; list-style-type: none;">
                            {{tipodocumento.TipoDocumento.Nombre}}
                        </li>
                        </ul>
                
                        </td> -->



                        <td  class="text-center align-middle"  style="width:5%;">

                        <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:center; padding-left: 0.0rem!important"  >
                        <li v-for="(consecutivo,index) in (firma.ExpedientesProcesados)" :key="index" style="height: auto; list-style-type: none;">
                        <!-- {{consecutivo.Expediente.Consecutivo+((consecutivo.Expediente.NumeroRomano) || "")}} -->
                             {{ (consecutivo.Expediente.NumeroRomano ? (consecutivo.Expediente.Consecutivo + '-' + consecutivo.Expediente.NumeroRomano) : consecutivo.Expediente.Consecutivo) }}
                        </li>
                        </ul>
                
                        </td>


                        <!-- <td class="text-center align-middle" style="width:15%;">{{ firma.Procesado.DelitoDBPJ.Nombre }}</td> -->
                        <td class="text-center align-middle" style="width:7%;">{{ firma.TemporalidadFirma }} días</td>
                        <td v-if="numeroTablaReporteFirmasVigentes==2" class="text-center align-middle " style="width:5%;">{{ firma.DiasDeRetraso==1 ? firma.DiasDeRetraso+' día' : firma.DiasDeRetraso+' días' }}</td>
                        <td class="text-center align-middle" style="width:10%;">{{ firma.FechaUltimaFirma ? obtenerFechaConFormato4(firma.FechaUltimaFirma) : ""}}</td>
                        <td class="text-center align-middle" style="width:10%;">{{ firma.FechaProximaFirma ? obtenerFechaConFormato4(firma.FechaProximaFirma) : ""}}</td>

                        <!-- <td class="text-center align-middle" style="width:10%;">{{ firma.TipoEstatusFirma.Nombre }}</td> -->
                        

                        <td class="text-center align-middle" style="width:20%;">{{ firma.Nombre + ' ' +  (firma.ApellidoPaterno || "") + ' ' +(firma.ApellidoMaterno || "") }}</td>
                        
                        
                    </tr>

                </tbody>
                    </table>



                    <div  class="d-flex" style="height: 5px;">

                    </div>


                    <h6 >Total de numero de firmas por reporte: {{TablaReporteFirmasVigentes.length}}</h6>

                    </div>






         </div >




          <!-- //////////////////////////////////////////////////////////////// -->

    


         <div class="div" id="TablaReporteDeMensajesRecibidos" v-if="TablaReporteDeMensajesRecibidos" >

   

            <h5>{{ obtenerTituloBusquedaMensajes() }}</h5>

            <hr />


            <!-- <div class="d-flex" style="height: 20px;">
            <div class="vr"></div>
            </div> --> 



            <div class="table-responsive" >

            <table class="table table-striped table-light table-hover table-bordered table-condensed " id="tablaDeReporteDeMensajesRecibidosPaginacion_table"
            data-search="false" 
            data-toggle="tablaDeReporteDeMensajesRecibidosPaginacion_reporte_table" 
            data-pagination="false" 
            data-toolbar="#tablaDeReporteDeMensajesRecibidosPaginacion_reporte_texto_div"
            data-page-size="5"
            data-page-list="[2,5,10]"
            data-undefined-text="Sin información"
            data-minimum-count-columns="0">
            <thead class="thead-green">
            <tr>
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Clave del Procesado</th>
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:20%;" class="text-center">Juzgado</th>
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:5%;" class="text-center">Consecutivo</th>
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:7%;" class="text-center">Temporalidad de la Firma</th>
            <!-- <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Estatus del Mensaje</th> -->
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Fecha Última Firma</th>
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Fecha Próxima Firma</th>
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Fecha de Mensaje Enviado</th>
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Fecha de Mensaje Recibido</th>
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:7%;" class="text-center">Mensaje Próxima Firma</th>
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:20%;" class="text-center">Nombre</th>

            <th v-if="!AccionesMostrar.reportes"  data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:1%;" class="text-center">Acciones</th>
            </tr>
            </thead>
            <tbody class="text-dark">

            <tr v-for="(firma, indexImp9) in TablaReporteDeMensajesRecibidos" :key="indexImp9" >
                
                <td class="text-center align-middle" style="width:10%;">{{ firma.ClaveDelProcesado }}</td>
                


                <td class="text-center align-middle"  style="width:25%;">
                <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:center;"  >
                <li v-for="(area,index) in (firma.ExpedientesProcesados)" :key="index" style="height: auto;" >
                {{area.Area.Nombre}}
                </li>
                </ul>
                </td>



                



                <td  class="text-center align-middle"  style="width:5%;">

                <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:center;"  >
                <li v-for="(consecutivo,index) in (firma.ExpedientesProcesados)" :key="index" style="height: auto;">
                <!-- {{consecutivo.Expediente.Consecutivo+((consecutivo.Expediente.NumeroRomano) || "")}} -->
                             {{ (consecutivo.Expediente.NumeroRomano ? (consecutivo.Expediente.Consecutivo + '-' + consecutivo.Expediente.NumeroRomano) : consecutivo.Expediente.Consecutivo) }}
                </li>
                </ul>
                
                </td>


                <td class="text-center align-middle" style="width:7%;">{{ firma.TemporalidadFirma }} días</td>
                
                
                <!-- <td class="text-center align-middle" style="width:10%;">{{ firma.TipoEstatusMensaje.Nombre }}</td> -->

                <td class="text-center align-middle" style="width:10%;">{{ firma.FechaUltimaFirma ? obtenerFechaConFormato(firma.FechaUltimaFirma) : ""}}</td>
                <td class="text-center align-middle" style="width:10%;">{{ firma.FechaProximaFirma ? obtenerFechaConFormato(firma.FechaProximaFirma) : ""}}</td>

                <td class="text-center align-middle" style="width:10%;">{{ firma.FechaMensajeProximaFirma ? obtenerFechaConFormato(firma.FechaMensajeProximaFirma) : ""}}</td>
                <td class="text-center align-middle" style="width:10%;">{{ firma.FechaDeRegistroEnQueFirmo ? obtenerFechaConFormato7(firma.FechaDeRegistroEnQueFirmo) : ""}}</td>

                <td class="text-center align-middle" style="width:7%;">{{ firma.MensajeProximaFirma }}</td>
                

                <td class="text-center align-middle" style="width:20%;">{{ firma.Nombre + ' ' +  (firma.ApellidoPaterno || "") + ' ' +(firma.ApellidoMaterno || "") }}</td>
            
                
            </tr>

            </tbody>
                </table>


            <div v-if="TablaReporteDeMensajesRecibidos.length>=10"  class="d-flex" style="height: 40px;">

            </div>


            <!-- <div v-else="TablaReporteDeMensajesRecibidos.length<=1"  class="d-flex" style="height: 5px;">

            </div> -->



            

            <hr />


            <h6 >Total de numero de mensajes recibidos por reporte: {{TablaReporteDeMensajesRecibidos.length}}</h6>

            <div  class="d-flex" style="height: 5px;">
                </div>


                <div class="div" id="botonesreportemensajesrecibidos" >
                    
                    <button type="button" class="btn btn-success overwrapDeBotones mr-3"  @click="ImprimirReporteMensajesRecibidos()"><i class="fas fa-print fa-lg"></i>&nbsp;&nbsp;Imprimir</button>

                    <button type="button" class="btn btn-success overwrapDeBotones mr-3"  @click="DescargarExcelMensajesRecibidos()"><i class="fas fa-download fa-lg"></i>&nbsp;&nbsp;Descargar excel</button>
                    
                    <div  class="d-flex" style="height: 5px;">
                    </div>
                
                </div>







            </div>


    







            </div>



            <!-- //////////////////////////////////////////////////////////  reporte impreso de mensajes recibidos-->



         <div  id="printMe3" hidden v-if="TablaReporteDeMensajesRecibidos">

            <!-- <h5 v-if="TablaReporteDeMensajesRecibidos">Reporte de mensajes recibidos</h5> -->


            <!-- <h5>{{ tituloTablaReporteDeMensajesRecibidos }}</h5> -->


         <div v-if="TablaReporteDeMensajesRecibidos" id="logo_div"> 


            <div class="table-responsive" >


            

            <table>

            <tr >


            <td> <img style="width: 40%" src="../../../assets/Logotipo_Positivo_Vertical-recibo.png" alt="Logo de Poder Judicial del Estado de Aguascalientes"  />  </td>
            <td class="text-center"><h5>H. Supremo Tribunal de Justicia del Estado de Aguascalientes</h5></td>
                        


            </tr>
                    

            </table>

            </div>




                    

         </div>



         <h5>{{ obtenerTituloBusquedaMensajes() }}</h5>




            <div v-if="TablaReporteDeMensajesRecibidos" class="d-flex" style="height: 20px;">
            <div class="vr"></div>
            </div>



            <div class="table-responsive">




            <table v-if="TablaReporteDeMensajesRecibidos" class="table table-striped table-light table-hover table-bordered table-condensed " id="tablaDeReporteDeMensajesRecibidos_reporte_table"
            data-search="false" 
            data-toggle="tablaDeReporteDeMensajesRecibidos_reporte_table" 
            data-pagination="false" 
            data-toolbar="#tablaDeReporteDeMensajesRecibidos_reporte_texto_div"
            data-page-size="5"
            data-page-list="[2,5,10]"
            data-undefined-text="Sin información"
            data-minimum-count-columns="0">
            <thead class="thead-light">
            <tr>
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Clave del Procesado</th>
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:35%;" class="text-center">Juzgado</th>
            <!-- <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:35%;" class="text-center">Tipo de documento</th> -->
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:5%;" class="text-center">Consecutivo</th>
            <!-- <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:2%;" class="text-center">Temporalidad de la Firma</th> -->
            <!-- <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Estatus del Mensaje</th> -->
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Fecha Última Firma</th>
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Fecha Próxima Firma</th>
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Fecha de Mensaje Enviado</th>
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Fecha de Mensaje Recibido</th>
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:7%;" class="text-center">Mensaje Próxima Firma</th>
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:20%;" class="text-center">Nombre</th>

            <th v-if="!AccionesMostrar.reportes"  data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:1%;" class="text-center">Acciones</th>
            </tr>
            </thead>
            <tbody class="text-dark">

            <tr v-for="(firma, indexImp9) in TablaReporteDeMensajesRecibidos" :key="indexImp9" >
                
                <td class="text-center align-middle" style="width:10%;">{{ firma.ClaveDelProcesado }}</td>


                <td class="text-center align-middle"  style="width:25%;">
                <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:center; padding-left: 0.0rem!important;"  >
                <li v-for="(area,index) in (firma.ExpedientesProcesados)" :key="index" style="height: auto; list-style-type: none;" >
                {{area.Area.Nombre}}
                </li>
                </ul>
                </td>



                <!-- <td class="text-center align-middle"  style="width:25%;">

                <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:center; padding-left: 0.0rem!important;"  >
                <li v-for="(tipodocumento,index) in (firma.ExpedientesProcesados)" :key="index" style="height: auto;">
                            {{tipodocumento.TipoDocumento.Nombre}}
                </li>
                </ul>
                
                </td> -->



                <td  class="text-center align-middle"  style="width:5%;">

                <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:center; padding-left: 0.0rem!important;"  >
                <li v-for="(consecutivo,index) in (firma.ExpedientesProcesados)" :key="index" style="height: auto; list-style-type: none;">
                <!-- {{consecutivo.Expediente.Consecutivo+((consecutivo.Expediente.NumeroRomano) || "")}} -->
                             {{ (consecutivo.Expediente.NumeroRomano ? (consecutivo.Expediente.Consecutivo + '-' + consecutivo.Expediente.NumeroRomano) : consecutivo.Expediente.Consecutivo) }}
                </li>
                </ul>
                
                </td>




                <!-- <td class="text-center align-middle" style="width:2%;">{{ firma.TemporalidadFirma }} días</td> -->
                
                
                <!-- <td class="text-center align-middle" style="width:10%;">{{ firma.TipoEstatusMensaje.Nombre }}</td> -->

                <td class="text-center align-middle" style="width:10%;">{{ firma.FechaUltimaFirma ? obtenerFechaConFormato4(firma.FechaUltimaFirma) : ""}}</td>
                <td class="text-center align-middle" style="width:10%;">{{ firma.FechaProximaFirma ? obtenerFechaConFormato4(firma.FechaProximaFirma) : ""}}</td>

                <td class="text-center align-middle" style="width:10%;">{{ firma.FechaMensajeProximaFirma ? obtenerFechaConFormato4(firma.FechaMensajeProximaFirma) : ""}}</td>
                <td class="text-center align-middle" style="width:10%;">{{ firma.FechaDeRegistroEnQueFirmo ? obtenerFechaConFormato9(firma.FechaDeRegistroEnQueFirmo) : ""}}</td>

                <td class="text-center align-middle" style="width:7%;">{{ firma.MensajeProximaFirma }}</td>
                

                <td class="text-center align-middle" style="width:20%;">{{ firma.Nombre + ' ' +  (firma.ApellidoPaterno || "") + ' ' +(firma.ApellidoMaterno || "") }}</td>
            
                
            </tr>

            </tbody>
            </table>


            <div v-if="TablaReporteDeMensajesRecibidos" class="d-flex" style="height: 5px;">

            </div>


            <h6 v-if="TablaReporteDeMensajesRecibidos">Total de numero de mensajes recibidos por reporte: {{TablaReporteDeMensajesRecibidos.length}}</h6>

            </div>


    



            </div>




           <!-- /////////////////////////////////////////////////////////// -->



            <div class="div" id="TablaReporteDeMensajesNoRecibidos" v-if="TablaReporteDeMensajesNoRecibidos">

        

            <h5>{{ obtenerTituloBusquedaMensajesNoRecibidos() }}</h5>

            <hr />

            <!-- <div class="d-flex" style="height: 20px;">
            <div class="vr"></div>
            </div> -->

        



         <div class="table-responsive">

          <table class="table table-striped table-light table-hover table-bordered table-condensed " id="tablaDeReporteDeMensajesNoRecibidosPaginacion_table"
            data-search="false" 
            data-toggle="tablaDeReporteDeMensajesNoRecibidosPaginacion_table_table" 
            data-pagination="false" 
            data-toolbar="#tablaDeReporteDeMensajesNoRecibidosPaginacion_table_texto_div"
            data-page-size="5"
            data-page-list="[2,5,10]"
            data-undefined-text="Sin información"
            data-minimum-count-columns="0">
            <thead class="thead-green">
                <tr>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Clave del Procesado</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:35%;" class="text-center">Juzgado</th>
                    <!-- <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:35%;" class="text-center">Tipo de documento</th> -->
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:5%;" class="text-center">Consecutivo</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:7%;" class="text-center">Temporalidad de la Firma</th>
                    <!-- <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Estatus del Mensaje</th> -->
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Fecha Última Firma</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Fecha Próxima Firma</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Fecha de Mensaje Enviado</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:7%;" class="text-center">Mensaje Próxima Firma</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:20%;" class="text-center">Nombre</th>

                    <th v-if="!AccionesMostrar.reportes" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:1%;" class="text-center">Acciones</th>
                </tr>
            </thead>
            <tbody class="text-dark">
        
            <tr v-for="(firma, indexImp10) in TablaReporteDeMensajesNoRecibidos" :key="indexImp10"  >
                
                <td class="text-center align-middle" style="width:10%;">{{ firma.ClaveDelProcesado }}</td>

                <td class="text-center align-middle"  style="width:25%;">
                <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:center;"  >
                <li v-for="(area,index) in (firma.ExpedientesProcesados)" :key="index" style="height: auto;" >
                {{area.Area.Nombre}}
                </li>
                </ul>
                </td>



                <!-- <td class="text-center align-middle"  style="width:25%;">

                <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:center;"  >
                <li v-for="(tipodocumento,index) in (firma.ExpedientesProcesados)" :key="index" style="height: auto;">
                            {{tipodocumento.TipoDocumento.Nombre}}
                </li>
                </ul>
                
                </td> -->



                <td  class="text-center align-middle"  style="width:5%;">

                <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:center;"  >
                <li v-for="(consecutivo,index) in (firma.ExpedientesProcesados)" :key="index" style="height: auto;">
                <!-- {{consecutivo.Expediente.Consecutivo+((consecutivo.Expediente.NumeroRomano) || "")}} -->
                             {{ (consecutivo.Expediente.NumeroRomano ? (consecutivo.Expediente.Consecutivo + '-' + consecutivo.Expediente.NumeroRomano) : consecutivo.Expediente.Consecutivo) }}
                </li>
                </ul>
                
                </td>



                <td class="text-center align-middle" style="width:7%;">{{ firma.TemporalidadFirma }} días</td>

                <!-- <td class="text-center align-middle" style="width:10%;">{{ firma.TipoEstatusMensaje.Nombre }}</td> -->

                <td class="text-center align-middle" style="width:10%;">{{ firma.FechaUltimaFirma ? obtenerFechaConFormato(firma.FechaUltimaFirma) : ""}}</td>
                <td class="text-center align-middle" style="width:10%;">{{ firma.FechaProximaFirma ? obtenerFechaConFormato(firma.FechaProximaFirma) : ""}}</td>

                <td class="text-center align-middle" style="width:10%;">{{ firma.FechaDeRegistroMensajeProximaFirma ? obtenerFechaConFormato7(firma.FechaDeRegistroMensajeProximaFirma) : ""}}</td>

                <td class="text-center align-middle" style="width:7%;">{{ firma.MensajeProximaFirma }}</td>
                
                <td class="text-center align-middle" style="width:20%;">{{ firma.Nombre + ' ' +  (firma.ApellidoPaterno || "") + ' ' +(firma.ApellidoMaterno || "") }}</td>
            
                
            </tr>
        
            </tbody>
                    </table>
                    
                    <div v-if="TablaReporteDeMensajesNoRecibidos.length>=10"  class="d-flex" style="height: 40px;">

                    </div>


                    <!-- <div v-else="TablaReporteDeMensajesNoRecibidos.length<=1"  class="d-flex" style="height: 5px;">

                    </div> -->



            <hr />

            <h6 >Total de numero de mensajes no recibidos por reporte: {{TablaReporteDeMensajesNoRecibidos.length}}</h6>

            <div  class="d-flex" style="height: 5px;">
            </div>


            <div class="div" id="botonesreportedemensajesnorecibidos">
                    
                    <button type="button" class="btn btn-success overwrapDeBotones mr-3"  @click="ImprimirReporteMensajesNoRecibidos()"><i class="fas fa-print fa-lg"></i>&nbsp;&nbsp;Imprimir</button>

                    <button type="button" class="btn btn-success overwrapDeBotones mr-3"  @click="DescargarExcelMensajesNoRecibidos()"><i class="fas fa-download fa-lg"></i>&nbsp;&nbsp;Descargar excel</button>
                    
                    <div  class="d-flex" style="height: 5px;">
                    </div>
            </div>


        
            </div>


        








            </div>


            <!-- //////////////////////////////////////////////////////////////  impresión de reporte de mensajes no recibidos-->


            <div v-if="TablaReporteDeMensajesNoRecibidos"  id="printMe4" hidden>


            <!-- <h5 v-if="TablaReporteDeMensajesNoRecibidos">Reporte de mensajes no recibidos</h5> -->

        <!-- <h5>{{ tituloTablaReporteDeMensajesNoRecibidos }}</h5> -->


     <div id="logo_div"> 


        <div class="table-responsive">


        <table>

     <tr >


        <td> <img style="width: 40%" src="../../../assets/Logotipo_Positivo_Vertical-recibo.png" alt="Logo de Poder Judicial del Estado de Aguascalientes"  />  </td>
        <td class="text-center"><h5>H. Supremo Tribunal de Justicia del Estado de Aguascalientes</h5></td>
                            


        </tr>
                        

            </table>

            </div>




                    

        </div>


        <h5>{{ obtenerTituloBusquedaMensajesNoRecibidos() }}</h5>


            <div class="d-flex" style="height: 20px;">
            <div class="vr"></div>
            </div>



        <div class="table-responsive">

        <table class="table table-striped table-light table-hover table-bordered table-condensed " id="tablaDeReporteDeMensajesNoRecibidos_reporte_table"
        data-search="false" 
        data-toggle="tablaDeReporteDeMensajesNoRecibidos_reporte_table" 
        data-pagination="false" 
        data-toolbar="#tablaDeReporteDeMensajesNoRecibidos_reporte_texto_div"
        data-page-size="5"
        data-page-list="[2,5,10]"
        data-undefined-text="Sin información"
        data-minimum-count-columns="0">
     <thead class="thead-light">
        <tr>
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Clave del Procesado</th>
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:35%;" class="text-center">Juzgado</th>
            <!-- <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:35%;" class="text-center">Tipo de documento</th> -->
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:5%;" class="text-center">Consecutivo</th>
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:7%;" class="text-center">Temporalidad de la Firma</th>
            <!-- <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Estatus del Mensaje</th> -->
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Fecha Última Firma</th>
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Fecha Próxima Firma</th>
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Fecha de Mensaje Enviado</th>
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:7%;" class="text-center">Mensaje Próxima Firma</th>
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:20%;" class="text-center">Nombre</th>

            <th v-if="!AccionesMostrar.reportes" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:1%;" class="text-center">Acciones</th>
        </tr>
     </thead>
     <tbody class="text-dark">
        
            <tr v-for="(firma, indexImp10) in TablaReporteDeMensajesNoRecibidos" :key="indexImp10"  >
                
                <td class="text-center align-middle" style="width:10%;">{{ firma.ClaveDelProcesado }}</td>

                <td class="text-center align-middle"  style="width:25%;">
                <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:center; padding-left: 0.0rem!important"  >
                <li v-for="(area,index) in (firma.ExpedientesProcesados)" :key="index" style="height: auto; list-style-type: none;" >
                {{area.Area.Nombre}}
                </li>
                </ul>
                </td>



                <!-- <td class="text-center align-middle"  style="width:25%;">

                <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:center; padding-left: 0.0rem!important"  >
                <li v-for="(tipodocumento,index) in (firma.ExpedientesProcesados)" :key="index" style="height: auto; list-style-type: none;">
                            {{tipodocumento.TipoDocumento.Nombre}}
                </li>
                </ul>
                
                </td> -->



                <td  class="text-center align-middle"  style="width:5%;">

                <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:center; padding-left: 0.0rem!important"  >
                <li v-for="(consecutivo,index) in (firma.ExpedientesProcesados)" :key="index" style="height: auto; list-style-type: none;">
                <!-- {{consecutivo.Expediente.Consecutivo+((consecutivo.Expediente.NumeroRomano) || "")}} -->
                             {{ (consecutivo.Expediente.NumeroRomano ? (consecutivo.Expediente.Consecutivo + '-' + consecutivo.Expediente.NumeroRomano) : consecutivo.Expediente.Consecutivo) }}
                </li>
                </ul>
                
                </td>




                <td class="text-center align-middle" style="width:7%;">{{ firma.TemporalidadFirma }} días</td>

                <!-- <td class="text-center align-middle" style="width:10%;">{{ firma.TipoEstatusMensaje.Nombre }}</td> -->

                <td class="text-center align-middle" style="width:10%;">{{ firma.FechaUltimaFirma ? obtenerFechaConFormato4(firma.FechaUltimaFirma) : ""}}</td>
                <td class="text-center align-middle" style="width:10%;">{{ firma.FechaProximaFirma ? obtenerFechaConFormato4(firma.FechaProximaFirma) : ""}}</td>

                <td class="text-center align-middle" style="width:10%;">{{ firma.FechaDeRegistroMensajeProximaFirma ? obtenerFechaConFormato9(firma.FechaDeRegistroMensajeProximaFirma) : ""}}</td>

                <td class="text-center align-middle" style="width:7%;">{{ firma.MensajeProximaFirma }}</td>
                
                <td class="text-center align-middle" style="width:20%;">{{ firma.Nombre + ' ' +  (firma.ApellidoPaterno || "") + ' ' +(firma.ApellidoMaterno || "") }}</td>
            
                
            </tr>
        
     </tbody>
        </table>

        <div  class="d-flex" style="height: 5px;">

        </div>

        <h6 >Total de numero de mensajes no recibidos por reporte: {{TablaReporteDeMensajesNoRecibidos.length}}</h6>




        </div>


            </div>

            <!-- ////////////////////////////////////////////////////////////// -->







            <div class="div" id="TablaReporteDeBitacoraDeMovimientos" v-if="TablaReporteDeBitacoraDeMovimientos" >

                            
                        


            <h5 v-if="TablaReporteDeBitacoraDeMovimientos">{{ obtenerTituloBusquedaMovimientos() }}</h5>

            <!-- <div v-if="TablaReporteDeBitacoraDeMovimientos" class="d-flex" style="height: 20px;">
            <div class="vr"></div>
            </div> -->



            <hr />

            <div class="table-responsive">

            <table v-if="TablaReporteDeBitacoraDeMovimientos" class="table table-striped table-light table-hover table-bordered table-condensed " id="tablaReporteDeBitacoraDeMovimientosPaginacion_table"
            data-search="false" 
            data-toggle="tablaReporteDeBitacoraDeMovimientosPaginacion_table" 
            data-pagination="false" 
            data-toolbar="#tablaReporteDeBitacoraDeMovimientosPaginacion_texto_div"
            data-page-size="5"
            data-page-list="[2,5,10]"
            data-undefined-text="Sin información"
            data-minimum-count-columns="0">

            <thead class="thead-green">
            <tr>
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:5%;" class="text-center">Clave del Procesado</th>
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:20%;" class="text-center">Nombre del Procesado</th>
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Correo electronico del usuario</th>
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Fecha Del Movimiento</th>
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Tipo de Movimiento</th>
            <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Motivo del movimiento</th>



            </tr>
            </thead>
            <tbody class="text-dark">

            <tr v-for="(movimiento, indexImp11) in TablaReporteDeBitacoraDeMovimientos" :key="indexImp11">

            <td class="text-center align-middle " style="width:5%;">{{ movimiento.ClaveDelProcesado }}</td>

            <td class="text-center align-middle" style="width:20%;">{{ movimiento.Nombre + ' ' +  (movimiento.ApellidoPaterno || "") + ' ' +(movimiento.ApellidoMaterno || "") }}</td>

            <td class="text-center align-middle" style="width:10%;">{{ movimiento.Correoelectronico.Nombre }}</td>


            <td class="text-center align-middle" style="width:10%;">{{ movimiento.FechayHoraDeMovimiento ? obtenerFechaConFormato7(movimiento.FechayHoraDeMovimiento) : ""}}</td>

            <td class="text-center align-middle" style="width:10%;">{{ movimiento.TipoMovimiento.Nombre }}</td>

            <td class="text-center align-middle" style="width:10%;">{{ movimiento.MotivoMovimiento }}</td>





            </tr>



            </tbody>



            </table>


            <div v-if="TablaReporteDeBitacoraDeMovimientos.length>=10"  class="d-flex" style="height: 40px;">

            </div>

            <!-- <div v-else="TablaReporteDeBitacoraDeMovimientos.length<=1"  class="d-flex" style="height: 5px;">

            </div> -->


            <hr />


            <h6 >Total de numero de movimientos realizados por reporte: {{TablaReporteDeBitacoraDeMovimientos.length}}</h6>

            <div  class="d-flex" style="height: 5px;">
            </div>


            <div class="div" id="botonesreportebitacorademovimientos">
                        
                        <button type="button" class="btn btn-success overwrapDeBotones mr-3"  @click="ImprimirReporteDeBitacoraDeMovimientos()"><i class="fas fa-print fa-lg"></i>&nbsp;&nbsp;Imprimir</button>

                        <button type="button" class="btn btn-success overwrapDeBotones mr-3"  @click="DescargarExcelBitacoraDeMovimientos()"><i class="fas fa-download fa-lg"></i>&nbsp;&nbsp;Descargar excel</button>

                    </div>


            <div  class="d-flex" style="height: 1px;">

            </div>

            </div>










            </div >





            <!-- /////////////////////////////////////////////////////// Reporte Impreso de bitacora de movimientos-->


            <div  id="printMe7" hidden v-if="TablaReporteDeBitacoraDeMovimientos">

                            




            <div v-if="TablaReporteDeBitacoraDeMovimientos" id="logo_div"> 

                <div class="table-responsive">


            <table>

            <tr >


            <td> <img style="width: 40%" src="../../../assets/Logotipo_Positivo_Vertical-recibo.png" alt="Logo de Poder Judicial del Estado de Aguascalientes"  />  </td>
            <td class="text-center"><h5>H. Supremo Tribunal de Justicia del Estado de Aguascalientes</h5></td>
                                


            </tr>
                            

            </table> 

                </div>

                            

            </div>


            


                <h5 v-if="TablaReporteDeBitacoraDeMovimientos">{{ obtenerTituloBusquedaMovimientos() }}</h5>

                <div v-if="TablaReporteDeBitacoraDeMovimientos" class="d-flex" style="height: 20px;">
                <div class="vr"></div>
                </div>


                
                <div class="table-responsive">

                <table v-if="TablaReporteDeBitacoraDeMovimientos" class="table table-striped table-light table-hover table-bordered table-condensed " id="tablaReporteDeBitacoraDeMovimientos_reporte_table"
                        data-search="false" 
                        data-toggle="tablaReporteDeBitacoraDeMovimientos_reporte_table" 
                        data-pagination="false" 
                        data-toolbar="#tablaReporteDeBitacoraDeMovimientos_reporte_texto_div"
                        data-page-size="5"
                        data-page-list="[2,5,10]"
                        data-undefined-text="Sin información"
                        data-minimum-count-columns="0">

            <thead class="thead-light">
            <tr>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:5%;" class="text-center">Clave del Procesado</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:20%;" class="text-center">Nombre del Procesado</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Correo electronico del usuario</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Fecha Del Movimiento</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Tipo de Movimiento</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Motivo del movimiento</th>

                
            </tr>
            </thead>
            <tbody class="text-dark">
        
            <tr v-for="(movimiento, indexImp11) in TablaReporteDeBitacoraDeMovimientos" :key="indexImp11">
                
                <td class="text-center align-middle " style="width:5%;">{{ movimiento.ClaveDelProcesado }}</td>

                <td class="text-center align-middle" style="width:20%;">{{ movimiento.Nombre + ' ' +  (movimiento.ApellidoPaterno || "") + ' ' +(movimiento.ApellidoMaterno || "") }}</td>

                <td class="text-center align-middle" style="width:10%;">{{ movimiento.Correoelectronico.Nombre }}</td>


                <td class="text-center align-middle" style="width:10%;">{{ movimiento.FechayHoraDeMovimiento ? obtenerFechaConFormato9(movimiento.FechayHoraDeMovimiento) : ""}}</td>

                <td class="text-center align-middle" style="width:10%;">{{ movimiento.TipoMovimiento.Nombre }}</td>

                <td class="text-center align-middle" style="width:10%;">{{ movimiento.MotivoMovimiento }}</td>


            
            

            </tr>


        
            </tbody>



                </table>


                <div v-if="TablaReporteDeBitacoraDeMovimientos" class="d-flex" style="height: 5px;">

                </div>


            <h6 v-if="TablaReporteDeBitacoraDeMovimientos">Total de numero de movimientos realizados por reporte: {{TablaReporteDeBitacoraDeMovimientos.length}}</h6>

            </div>







            </div >



           <!-- //////////////////////////////////////////////////////////// -->



    


            <div class="div" id="TablaVerificacionReciboDeFirmas" v-if="TablaVerificacionReciboDeFirmas" >


                <hr />        


            <h5 class="div-verificacion" v-if="(AccionesMostrar.verificacion && TablaVerificacionReciboDeFirmas)"></h5>    
        
            <h5 v-else-if="TablaVerificacionReciboDeFirmas">{{ obtenerTituloBusquedaVerificacionReciboDeFirmas() }}</h5>



            <!-- <div v-if="TablaVerificacionReciboDeFirmas" class="d-flex" style="height: 20px;">
            <div class="vr"></div>
            </div> -->




                    
            <div class="table-responsive">

            <table v-if="TablaVerificacionReciboDeFirmas" class="table table-striped table-light table-hover table-bordered table-condensed " id="tablaVerificacionReciboDeFirmasPaginacion_table"
                            data-search="false" 
                            data-toggle="tablaVerificacionReciboDeFirmasPaginacion_table" 
                            data-pagination="false" 
                            data-toolbar="#tablaVerificacionReciboDeFirmasPaginacion_texto_div"
                            data-page-size="5"
                            data-page-list="[2,5,10]"
                            data-undefined-text="Sin información"
                            data-minimum-count-columns="0">
                <thead class="thead-green">
            <tr>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Clave del Procesado</th>
                <!-- <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:20%;" class="text-center">Delito/os</th> -->
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:7%;" class="text-center">Temporalidad de la Firma</th>
                <th v-if="TablaVerificacionReciboDeFirmasFirmaNoVigente == true" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:7%;" class="text-center">Dias en firmar</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Fecha Última Firma</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Fecha Próxima Firma</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Estatus de Firma</th>
                <th v-if="TablaVerificacionReciboDeFirmasFirmaNoVigente == true" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Fecha En Que Firmó</th>
                <!-- <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Estatus de Firma</th> -->
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Firmó en Tiempo</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Firmó en Dispositivo</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:20%;" class="text-center">Nombre</th>

                <th v-if="!AccionesMostrar.reportes" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:1%;" class="text-center">Acciones</th>
            </tr>
            </thead>
            <tbody class="text-dark">
            
                <tr v-for="(firma, indexImp12) in TablaVerificacionReciboDeFirmas" :key="indexImp12">
                    
                    <td class="text-center align-middle " style="width:10%;">{{ firma.ClaveDelProcesado }}</td>
                    <!-- <td class="text-center align-middle " style="width:15%;">{{ firma.Procesado.DelitoDBPJ.Nombre }}</td> -->



                    <!-- <td class="text-center align-middle"  style="width:17%;">

                        <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:left;">
                            <li v-for="delito in (firma.Procesado.DelitosProcesados)">
                                {{delito.Delito.Nombre}}
                            </li>
                        </ul>
                        
                    </td> -->


                    <td class="text-center align-middle " style="width:7%;">{{ firma.TemporalidadFirma }} días</td>
                    <td v-if="TablaVerificacionReciboDeFirmasFirmaNoVigente == true" class="text-center align-middle " style="width:7%;">{{ firma.DiasEnFirmar }} días</td>
                    <td class="text-center align-middle" style="width:10%;">{{ firma.FechaUltimaFirma ? obtenerFechaConFormato(firma.FechaUltimaFirma) : ""}}</td>
                    <td class="text-center align-middle" style="width:10%;">{{ firma.FechaProximaFirma ? obtenerFechaConFormato(firma.FechaProximaFirma) : ""}}</td>
                    <td class="text-center align-middle" style="width:10%;">{{ firma.TipoEstatusFirma.Nombre }}</td>

                    <td v-if="TablaVerificacionReciboDeFirmasFirmaNoVigente == true" class="text-center align-middle" style="width:10%;">{{ firma.FechaEnQueFirmo ? obtenerFechaConFormato(firma.FechaEnQueFirmo) : ""}}</td>

                    <!-- <td class="text-center align-middle" style="width:10%;">{{ firma.TipoEstatusFirma.Nombre }}</td> -->

                    <td class="text-center align-middle" style="width:10%;">{{ firma.TipoFirmoEnTiempo.Nombre }}</td>

                    <td class="text-center align-middle" style="width:10%;">{{ firma.TipoFirmoEnDispositivo.Nombre }}</td>
                    

                    <td class="text-center align-middle" style="width:20%;">{{ firma.Nombre + ' ' +  (firma.ApellidoPaterno || "") + ' ' +(firma.ApellidoMaterno || "") }}</td>
                
                    
                </tr>


            
            </tbody>



            </table>


            <div v-if="TablaVerificacionReciboDeFirmas" class="d-flex" style="height: 5px;">

            </div>

            <hr />


            <h6 v-if="TablaVerificacionReciboDeFirmas"> </h6>


            <div v-if="(TablaVerificacionReciboDeFirmas && !AccionesMostrar.verificacion)">
                
                <button type="button" class="btn btn-success overwrapDeBotones mr-3"  @click="ImprimirVerificacionReciboDeFirmas()"><i class="fas fa-print fa-lg"></i>&nbsp;&nbsp;Imprimir</button>

            </div>





         </div>








            </div >



         <!-- /////////////////////////////////////////////////////// Reporte Impreso de Verificacion de recibo de firmas-->


            <div  id="printMe8" hidden v-if="TablaVerificacionReciboDeFirmas">

                    




            <div v-if="TablaVerificacionReciboDeFirmas" id="logo_div"> 

                <div class="table-responsive">

            <table>

            <tr >


            <td> <img style="width: 40%" src="../../../assets/Logotipo_Positivo_Vertical-recibo.png" alt="Logo de Poder Judicial del Estado de Aguascalientes"  />  </td>
            <td class="text-center"><h5>H. Supremo Tribunal de Justicia del Estado de Aguascalientes</h5></td>
                            


            </tr>
                            

            </table> 

                </div>

                            

            </div>


                


                    <h5 v-if="TablaVerificacionReciboDeFirmas">{{ obtenerTituloBusquedaVerificacionReciboDeFirmas() }}</h5>

                    <div v-if="TablaVerificacionReciboDeFirmas" class="d-flex" style="height: 20px;">
                    <div class="vr"></div>
                    </div>


                    
                    <div class="table-responsive">

                    <table v-if="TablaVerificacionReciboDeFirmas" class="table table-striped table-light table-hover table-bordered table-condensed " id="tablaDeReporteFirmasNoVigentes_reporte_table"
                    data-search="false" 
                    data-toggle="tablaDeReporteFirmasNoVigentes_reporte_table" 
                    data-pagination="false" 
                    data-toolbar="#tablaDeReporteFirmasNoVigentes_reporte_texto_div"
                    data-page-size="5"
                    data-page-list="[2,5,10]"
                    data-undefined-text="Sin información"
                    data-minimum-count-columns="0">
            <thead class="thead-light">
                <tr>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Clave del Procesado</th>
                    <!-- <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:20%;" class="text-center">Delito/os</th> -->
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:7%;" class="text-center">Temporalidad de la Firma</th>
                    <th v-if="TablaVerificacionReciboDeFirmasFirmaNoVigente == true" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:7%;" class="text-center">Dias en firmar</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Fecha Última Firma</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Fecha Próxima Firma</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Estatus de Firma</th>
                    <th v-if="TablaVerificacionReciboDeFirmasFirmaNoVigente == true" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Fecha En Que Firmó</th>
                    <!-- <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Estatus de Firma</th> -->
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Firmó en Tiempo</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Firmó en Dispositivo</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:20%;" class="text-center">Nombre</th>

                    <th v-if="!AccionesMostrar.reportes" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:1%;" class="text-center">Acciones</th>
                </tr>
            </thead>
            <tbody class="text-dark">
            
                <tr v-for="(firma, indexImp12) in TablaVerificacionReciboDeFirmas" :key="indexImp12">
                    
                    <td class="text-center align-middle " style="width:10%;">{{ firma.ClaveDelProcesado }}</td>
                    <!-- <td class="text-center align-middle " style="width:15%;">{{ firma.Procesado.DelitoDBPJ.Nombre }}</td> -->



                    <!-- <td class="text-center align-middle"  style="width:17%;">

                        <ul id="listado_delitos" class="mb-0 pl-4" style="text-align:left;">
                            <li v-for="delito in (firma.Procesado.DelitosProcesados)">
                                {{delito.Delito.Nombre}}
                            </li>
                        </ul>
                        
                    </td> -->


                    <td class="text-center align-middle " style="width:7%;">{{ firma.TemporalidadFirma }} días</td>
                    <td v-if="TablaVerificacionReciboDeFirmasFirmaNoVigente == true" class="text-center align-middle " style="width:7%;">{{ firma.DiasEnFirmar }} días</td>
                    <td class="text-center align-middle" style="width:10%;">{{ firma.FechaUltimaFirma ? obtenerFechaConFormato(firma.FechaUltimaFirma) : ""}}</td>
                    <td class="text-center align-middle" style="width:10%;">{{ firma.FechaProximaFirma ? obtenerFechaConFormato(firma.FechaProximaFirma) : ""}}</td>
                    <td class="text-center align-middle" style="width:10%;">{{ firma.TipoEstatusFirma.Nombre }}</td>

                    <td v-if="TablaVerificacionReciboDeFirmasFirmaNoVigente == true" class="text-center align-middle" style="width:10%;">{{ firma.FechaEnQueFirmo ? obtenerFechaConFormato(firma.FechaEnQueFirmo) : ""}}</td>

                    <!-- <td class="text-center align-middle" style="width:10%;">{{ firma.TipoEstatusFirma.Nombre }}</td> -->

                    <td class="text-center align-middle" style="width:10%;">{{ firma.TipoFirmoEnTiempo.Nombre }}</td>

                    <td class="text-center align-middle" style="width:10%;">{{ firma.TipoFirmoEnDispositivo.Nombre }}</td>
                    

                    <td class="text-center align-middle" style="width:20%;">{{ firma.Nombre + ' ' +  (firma.ApellidoPaterno || "") + ' ' +(firma.ApellidoMaterno || "") }}</td>
                
                    
                </tr>


            
            </tbody>



                    </table>


                    <div v-if="TablaVerificacionReciboDeFirmas" class="d-flex" style="height: 5px;">

            </div>


            <h6 v-if="TablaVerificacionReciboDeFirmas">Se comprueba que existe el registro de la firma en la base de datos del SIVAC</h6>

                            </div>







            </div >



         <!-- //////////////////////////////////////////////////////////// -->



         <div class="div" v-if="TablaReporteDeRelacionDeCertificadosCobrados" id="TablaReporteDeRelacionDeCertificadosCobrados" >




            <h5 >{{ obtenerTituloBusquedaCertificadosCobrados() }}</h5>

            <!-- <div  class="d-flex" style="height: 20px;">
            <div class="vr"></div>
            </div>   --> 


            <hr />



            <div class="table-responsive">

            <table  class="table table-striped table-light table-hover table-bordered table-condensed " id="tablaReporteDeRelacionDeCertificadosCobradosPaginacion_table"
            
            data-search="false" 
            data-toggle="tablaReporteDeRelacionDeCertificadosCobradosPaginacion_table" 
            data-pagination="false" 
            data-toolbar="#tablaReporteDeRelacionDeCertificadosCobradosPaginacion_texto_div"
            data-page-size="5"
            data-page-list="[2,5,10]"
            data-undefined-text="Sin información"
            data-minimum-count-columns="0">

                <thead class="thead-green">
                <tr>
                
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:5%;" class="text-center">N°</th>

                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:12%;" class="text-center">Juzgado</th>
                
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:5%;" class="text-center">Expediente</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:7%;" class="text-center">N° de Certificado</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Concepto del Endoso</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Importe Depósito</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Importe Certificado</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Fecha de Cobro en Oficialía</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Fecha de Pago a Oficialía</th>


                

                <th v-if="!AccionesMostrar.reportes" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:1%;" class="text-center">Acciones</th>
                </tr>

                </thead>

                <tbody class="text-dark">



                <tr v-for="(firma, indexImp7) in TablaReporteDeRelacionDeCertificadosCobrados" :key="indexImp7">

                <td class="text-center align-middle " style="width:5%;">{{indexImp7+1}}</td>

                <td class="text-center align-middle " style="width:12%;">{{ firma.Billetes.Areas.Des_area }}</td>

                <td class="text-center align-middle " style="width:5%;">{{ firma.Billetes.Consecutivo }}</td>

                <td class="text-center align-middle " style="width:10%;">{{ firma.Num_bole }}</td> 

                <td class="text-center align-middle" style="width:10%;">{{ firma.TipoEndoso.Des_endo }}</td>

                <td class="text-center align-middle" style="width:10%;">${{agregarCeros(firma.Billetes.Deposito.Can_tida)}}</td>

                <td class="text-center align-middle" style="width:10%;">${{agregarCeros(firma.Billetes.Can_tida)}}</td>

                <td class="text-center align-middle" style="width:10%;">{{ firma.Fec_ofic ? obtenerFechaConFormato(firma.Fec_ofic) : "" }}</td>

                <td class="text-center align-middle" style="width:10%;">{{ firma.Fec_cobr ? obtenerFechaConFormato(firma.Fec_cobr) : "" }}</td>

                </tr>






            </tbody>



            <!-- <tfoot>
             <td align="right" class="suma_total" scope="col" colspan="6">Suma Total</td>
             <td align="center">${{TablaReporteDeRelacionDeCertificadosCobradosFecha.SumaTotal}}</td>
            </tfoot> -->    



            </table>









            <div v-if="TablaReporteDeRelacionDeCertificadosCobrados.length>=10"  class="d-flex" style="height: 40px;">

            </div>

            <!-- <div v-else="TablaReporteDeRelacionDeCertificadosCobrados.length<=1"  class="d-flex" style="height: 1px;">

            </div> -->

            


            <hr />




            

            <h6 v-if="this.TablaReporteDeRelacionDeCertificadosCobradosFecha != null && this.TablaReporteDeRelacionDeCertificadosCobradosFecha != undefined" >Importe total depósito por reporte: $ {{agregarCeros(TablaReporteDeRelacionDeCertificadosCobradosFecha.SumaTotalDeposito)}}</h6>

            <h6 v-if="this.TablaReporteDeRelacionDeCertificadosCobradosFechaActual != null && this.TablaReporteDeRelacionDeCertificadosCobradosFechaActual != undefined" >Importe total depósito por reporte: $ {{agregarCeros(TablaReporteDeRelacionDeCertificadosCobradosFechaActual.SumaTotalDeposito)}}</h6>

            <h6 v-if="this.TablaReporteDeRelacionDeCertificadosCobradosFecha != null && this.TablaReporteDeRelacionDeCertificadosCobradosFecha != undefined" >Importe total certificado por reporte: $ {{agregarCeros(TablaReporteDeRelacionDeCertificadosCobradosFecha.SumaTotal)}}</h6>

            <h6 v-if="this.TablaReporteDeRelacionDeCertificadosCobradosFechaActual != null && this.TablaReporteDeRelacionDeCertificadosCobradosFechaActual != undefined" >Importe total certificado por reporte: $ {{agregarCeros(TablaReporteDeRelacionDeCertificadosCobradosFechaActual.SumaTotal)}}</h6>

            <div  class="d-flex" style="height: 5px;">
            </div>

            <div id="botones reportecertficadoscobrados" >

            <button v-if="AccionesMostrar.reportecobrados" type="button" class="btn btn-success overwrapDeBotones mr-3"  @click="ImprimirReporteDeRelacionDeCertificadosCobrados()"><i class="fas fa-print fa-lg"></i>&nbsp;&nbsp;Imprimir</button>

            <button v-if="AccionesMostrar.reportecobrados" type="button" class="btn btn-success overwrapDeBotones mr-3"  @click="DescargarExcelCertificadosCobrados()"><i class="fas fa-download fa-lg"></i>&nbsp;&nbsp;Descargar excel</button>


            <button v-if="AccionesMostrar.reportepagados" type="button" class="btn btn-success overwrapDeBotones mr-3"  @click="ImprimirReporteDeRelacionDeCertificadosPagados()"><i class="fas fa-print fa-lg"></i>&nbsp;&nbsp;Imprimir</button>

            <button v-if="AccionesMostrar.reportepagados" type="button" class="btn btn-success overwrapDeBotones mr-3"  @click="DescargarExcelCertificadosPagados()"><i class="fas fa-download fa-lg"></i>&nbsp;&nbsp;Descargar excel</button>



            <div  class="d-flex" style="height: 5px;">
            </div>
        
            </div>

















            
            </div>
    
    

    




         </div >

         <!-- /////////////////////////////////////////////////////// Reporte Impreso de Reporte de certificados cobrados-->


         <div id="printMe9" v-if="TablaReporteDeRelacionDeCertificadosCobrados" hidden>



         <div  id="logo_div"> 


         <div class="table-responsive">

         <table>

         <tr >


         <td> <img style="width: 40%" src="../../../assets/Logotipo_Positivo_Vertical-recibo.png" alt="Logo de Poder Judicial del Estado de Aguascalientes"  />  </td>
         <td class="text-center"><h5>Poder Judicial del Estado de Aguascalientes</h5></td>
         <td class="text-center"><h5>Dirección de Contabilidad y Control Presupuestal</h5></td>



         </tr>


         </table>





            </div>


         <h5 >{{ obtenerTituloBusquedaCertificadosCobrados() }}</h5>

         <div  class="d-flex" style="height: 20px;">
         <div class="vr"></div>
         </div>


            <div class="table-responsive">


            <table  class="table table-striped table-light table-hover table-bordered table-condensed " id="tablaDeReporteDeRelacionDeCertificadosCobrados_reporte_table"
            data-search="false" 
            data-toggle="tablaDeReporteDeRelacionDeCertificadosCobrados_reporte_table" 
            data-pagination="false" 
            data-toolbar="#tablaDeReporteDeRelacionDeCertificadosCobrados_reporte_texto_div"
            data-page-size="5"
            data-page-list="[2,5,10]"
            data-undefined-text="Sin información"
            data-minimum-count-columns="0">
            <thead class="thead-light">
                <tr>
                
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:5%;" class="text-center">N°</th>

                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:12%;" class="text-center">Juzgado</th>
                
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:5%;" class="text-center">Expediente</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:7%;" class="text-center">N° de Certificado</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Concepto del Endoso</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Importe</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Fecha de Cobro en Oficialía</th>
                <th v-if="AccionesMostrar.reportepagados" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Fecha de Pago a Oficialía</th>
                


                

                <th v-if="!AccionesMostrar.reportes" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:1%;" class="text-center">Acciones</th>
                </tr>

                </thead>


            <tbody class="text-dark">



                <tr v-for="(firma, indexImp7) in TablaReporteDeRelacionDeCertificadosCobrados" :key="indexImp7">


                <td class="text-center align-middle " style="width:5%;">{{indexImp7+1}}</td>

                <td class="text-center align-middle " style="width:12%;">{{ firma.Billetes.Areas.Des_area }}</td>

                <td class="text-center align-middle " style="width:5%;">{{ firma.Billetes.Consecutivo }}</td>

                <td class="text-center align-middle " style="width:10%;">{{ firma.Num_bole }}</td>

                <td class="text-center align-middle" style="width:10%;">{{ firma.TipoEndoso.Des_endo }}</td>

                <td class="text-center align-middle" style="width:10%;">${{agregarCeros(firma.Billetes.Deposito.Can_tida)}}</td>

                <td class="text-center align-middle" style="width:10%;">{{ firma.Fec_ofic ? obtenerFechaConFormato(firma.Fec_ofic) : "" }}</td>

                <td v-if="AccionesMostrar.reportepagados" class="text-center align-middle" style="width:10%;">{{ firma.Fec_cobr ? obtenerFechaConFormato(firma.Fec_cobr) : "" }}</td>


                </tr>






            </tbody>

            <tr>
             <td align="right" class="suma_total" scope="col" colspan="5">Importe Total</td>



             <td v-if="this.TablaReporteDeRelacionDeCertificadosCobradosFecha != null && this.TablaReporteDeRelacionDeCertificadosCobradosFecha != undefined" align="center">${{agregarCeros(TablaReporteDeRelacionDeCertificadosCobradosFecha.SumaTotalDeposito) }}</td>

             <td v-if="this.TablaReporteDeRelacionDeCertificadosCobradosFechaActual != null && this.TablaReporteDeRelacionDeCertificadosCobradosFechaActual != undefined" align="center">${{agregarCeros(TablaReporteDeRelacionDeCertificadosCobradosFechaActual.SumaTotalDeposito) }}</td>


            </tr>





            </table>







            <!-- <div  class="d-flex" style="height: 5px;">

            </div>


            <h6 >Suma total del numero de certificados de deposito por reporte: {{TablaReporteDeRelacionDeCertificadosCobradosFecha.SumaTotal}}</h6> -->


            </div>           






            </div>







            </div >



            <!-- //////////////////////////////////////////////////////////// -->



         <!-- /////////////////////////////////////////////////////// Reporte Excel de Reporte de certificados cobrados-->


             <div id="TablaReporteDeRelacionDeCertificadosCobradosExcel" v-if="TablaReporteDeRelacionDeCertificadosCobrados" hidden>



         <div  id="logo_div"> 


         <div class="table-responsive">

         <table>

         <tr >


         <td> <img style="width: 40%" src="../../../assets/Logotipo_Positivo_Vertical-recibo.png" alt="Logo de Poder Judicial del Estado de Aguascalientes"  />  </td>
         <td class="text-center"><h5>Poder Judicial del Estado de Aguascalientes</h5></td>
         <td class="text-center"><h5>Dirección de Contabilidad y Control Presupuestal</h5></td>



         </tr>


         </table>





            </div>


         <h5 >{{ obtenerTituloBusquedaCertificadosCobrados() }}</h5>

         <div  class="d-flex" style="height: 20px;">
         <div class="vr"></div>
         </div>


            <div class="table-responsive">


            <table  class="table table-striped table-light table-hover table-bordered table-condensed " id="tablaDeReporteDeRelacionDeCertificadosCobrados_reporte_excel_table"
            data-search="false" 
            data-toggle="tablaDeReporteDeRelacionDeCertificadosCobrados_reporte_excel_table" 
            data-pagination="false" 
            data-toolbar="#tablaDeReporteDeRelacionDeCertificadosCobrados_reporte_excel_texto_div"
            data-page-size="5"
            data-page-list="[2,5,10]"
            data-undefined-text="Sin información"
            data-minimum-count-columns="0">
            <thead class="thead-green">
                <tr>
                
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:5%;" class="text-center">N°</th>              
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:7%;" class="text-center">N° de Certificado</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Importe</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:12%;" class="text-center">Juzgado</th>             
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:5%;" class="text-center">Expediente</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Concepto del Endoso</th>             
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Fecha de Cobro en Oficialía</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Fecha de Pago a Oficialía</th>


                

                <th v-if="!AccionesMostrar.reportes" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:1%;" class="text-center">Acciones</th>
                </tr>

                </thead>


            <tbody class="text-dark">



                <tr v-for="(firma, indexImp7) in TablaReporteDeRelacionDeCertificadosCobrados" :key="indexImp7">


                <td class="text-center align-middle " style="width:5%;">{{indexImp7+1}}</td>

                <td class="text-center align-middle " style="width:10%;">{{ firma.Num_bole }}</td>

                <td class="text-center align-middle" style="width:10%;">{{ firma.Billetes.Deposito.Can_tida}}</td>

                <td class="text-center align-middle " style="width:12%;">{{ firma.Billetes.Areas.Des_area }}</td>

                <td class="text-center align-middle " style="width:5%;">{{ firma.Billetes.Consecutivo }}</td>
    
                <td class="text-center align-middle" style="width:10%;">{{ firma.TipoEndoso.Des_endo }}</td>

                

                <td class="text-center align-middle" style="width:10%;">{{ firma.Fec_ofic ? obtenerFechaConFormato4(firma.Fec_ofic) : "" }}</td>

                <td class="text-center align-middle" style="width:10%;">{{ firma.Fec_cobr ? obtenerFechaConFormato4(firma.Fec_cobr) : "" }}</td>

                </tr>






            </tbody>

            <tr>
             <td align="right" class="suma_total" scope="col" colspan="2"></td>
             <td v-if="this.TablaReporteDeRelacionDeCertificadosCobradosFecha != null && this.TablaReporteDeRelacionDeCertificadosCobradosFecha != undefined" align="center">{{TablaReporteDeRelacionDeCertificadosCobradosFecha.SumaTotalDeposito}}</td>

             <td v-if="this.TablaReporteDeRelacionDeCertificadosCobradosFechaActual != null && this.TablaReporteDeRelacionDeCertificadosCobradosFechaActual != undefined" align="center">{{TablaReporteDeRelacionDeCertificadosCobradosFechaActual.SumaTotalDeposito}}</td>
            </tr>





            </table>







            <!-- <div  class="d-flex" style="height: 5px;">

            </div>


            <h6 >Suma total del numero de certificados de deposito por reporte: {{TablaReporteDeRelacionDeCertificadosCobradosFecha.SumaTotal}}</h6> -->


            </div>           






            </div>







            </div >

            

            <!-- //////////////////////////////////////////////////////////// -->





         <div class="div" v-if="TablaReporteDeRelacionDeChequesCobrados" id="TablaReporteDeRelacionDeChequesCobrados" >




            <h5 >{{ obtenerTituloBusquedaChequesCobrados() }}</h5>

            <!-- <div  class="d-flex" style="height: 20px;">
            <div class="vr"></div>
            </div>   --> 


            <hr />



            <div class="table-responsive">

            <table  class="table table-striped table-light table-hover table-bordered table-condensed " id="tablaReporteDeRelacionDeChequesCobradosPaginacion_table"
            
            data-search="false" 
            data-toggle="tablaReporteDeRelacionDeChequesCobradosPaginacion_table" 
            data-pagination="false" 
            data-toolbar="#tablaReporteDeRelacionDeChequesCobradosPaginacion_texto_div"
            data-page-size="5"
            data-page-list="[2,5,10]"
            data-undefined-text="Sin información"
            data-minimum-count-columns="0">

                <thead class="thead-green">
                <tr>
                
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:5%;" class="text-center">N°</th>

                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Juzgado</th>
                
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:4%;" class="text-center">Expediente</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:7%;" class="text-center">N° de Certificado</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">N° de Cheque</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:12%;" class="text-center">Nombre Cheque</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Fecha Cheque</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Monto para el Cheque</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Monto Poder Judicial</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:7%;" class="text-center">Observación</th>
                


                

                <th v-if="!AccionesMostrar.reportes" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:1%;" class="text-center">Acciones</th>
                </tr>

                </thead>

                <tbody class="text-dark">



                <tr v-for="(firma, indexImp7) in TablaReporteDeRelacionDeChequesCobrados" :key="indexImp7">

                <td class="text-center align-middle " style="width:5%;">{{indexImp7+1}}</td>

                <td class="text-center align-middle " style="width:10%;">{{ firma.Billetes.Areas.Des_area }}</td>

                <td class="text-center align-middle " style="width:4%;">{{ firma.Billetes.Consecutivo }}</td>

                <td class="text-center align-middle " style="width:10%;">{{ firma.Num_bole }}</td>

                <td class="text-center align-middle " style="width:10%;">{{ firma.Num_cheque }}</td>

                <td class="text-center align-middle " style="width:12%;">{{ firma.Nom_cobra }}</td> 

                <td class="text-center align-middle" style="width:10%;">{{ firma.Fec_cheque ? obtenerFechaConFormato(firma.Fec_cheque) : "" }}</td>

                <td class="text-center align-middle" style="width:10%;">${{agregarCeros(firma.Monto_cheque) }}</td>

                <td class="text-center align-middle" style="width:10%;">${{agregarCeros(firma.Monto_pojud) }}</td>

                <td class="text-center align-middle " style="width:5%;">{{ firma.Obs_erva }}</td>

                </tr>






            </tbody>



            <!-- <tfoot>
             <td align="right" class="suma_total" scope="col" colspan="6">Suma Total</td>
             <td align="center">${{TablaReporteDeRelacionDeChequesCobradosFecha.SumaTotal}}</td>
            </tfoot> -->    



            </table>









            <div v-if="TablaReporteDeRelacionDeChequesCobrados.length>=10"  class="d-flex" style="height: 40px;">

            </div>

            <!-- <div v-else="TablaReporteDeRelacionDeChequesCobrados.length<=1"  class="d-flex" style="height: 1px;">

            </div> -->

            


            <hr />




            




            <h6 v-if="this.TablaReporteDeRelacionDeChequesCobradosFecha != null && this.TablaReporteDeRelacionDeChequesCobradosFecha != undefined" >Importe total monto cheque por reporte: $ {{agregarCeros(TablaReporteDeRelacionDeChequesCobradosFecha.SumaTotalMontoCheque)}}</h6>

            <h6 v-if="this.TablaReporteDeRelacionDeChequesCobradosFechaActual != null && this.TablaReporteDeRelacionDeChequesCobradosFechaActual != undefined" >Importe total monto cheque por reporte: ${{agregarCeros(TablaReporteDeRelacionDeChequesCobradosFechaActual.SumaTotalMontoCheque)}}</h6>


            <h6 v-if="this.TablaReporteDeRelacionDeChequesCobradosFechaActual2 != null && this.TablaReporteDeRelacionDeChequesCobradosFechaActual2 != undefined" >Importe total monto cheque por reporte: ${{agregarCeros(TablaReporteDeRelacionDeChequesCobradosFechaActual2.SumaTotalMontoCheque)}}</h6>





            <h6 v-if="this.TablaReporteDeRelacionDeChequesCobradosFecha != null && this.TablaReporteDeRelacionDeChequesCobradosFecha != undefined" >Importe total monto poder judicial por reporte: ${{agregarCeros(TablaReporteDeRelacionDeChequesCobradosFecha.SumaTotalMontoPodJud)}}</h6>

            <h6 v-if="this.TablaReporteDeRelacionDeChequesCobradosFechaActual != null && this.TablaReporteDeRelacionDeChequesCobradosFechaActual != undefined" >Importe total monto poder judicial por reporte: $ {{agregarCeros(TablaReporteDeRelacionDeChequesCobradosFechaActual.SumaTotalMontoPodJud)}}</h6>


            <h6 v-if="this.TablaReporteDeRelacionDeChequesCobradosFechaActual2 != null && this.TablaReporteDeRelacionDeChequesCobradosFechaActual2 != undefined" >Importe total monto poder judicial por reporte: $ {{agregarCeros(TablaReporteDeRelacionDeChequesCobradosFechaActual2.SumaTotalMontoPodJud)}}</h6>



            <div v-if="this.TablaReporteDeRelacionDeChequesCobradosFechaActual2 != null && this.TablaReporteDeRelacionDeChequesCobradosFechaActual2 != undefined"  class="d-flex" style="height: 35px;">
            <div class="vr"></div>
            </div>



            

            <h6 v-if="this.TablaReporteDeRelacionDeChequesCobradosFechaActual2 != null && this.TablaReporteDeRelacionDeChequesCobradosFechaActual2 != undefined" >Importe total del certificado de deposito: ${{agregarCeros(TablaReporteDeRelacionDeChequesCobradosFechaActual2.SumaTotalDeposito)}}</h6>


            <h6 v-if="this.TablaReporteDeRelacionDeChequesCobradosFechaActual2 != null && this.TablaReporteDeRelacionDeChequesCobradosFechaActual2 != undefined" >Monto restante por pagar del certificado de deposito: ${{agregarCeros(TablaReporteDeRelacionDeChequesCobradosFechaActual2.MontoPorPagar)}}</h6>





            <div  class="d-flex" style="height: 5px;">
            </div>

            <div id="botones reportecertficadoscobrados" >

            <button type="button" class="btn btn-success overwrapDeBotones mr-3"  @click="ImprimirReporteDeRelacionDeChequesCobrados()"><i class="fas fa-print fa-lg"></i>&nbsp;&nbsp;Imprimir</button>

            <button type="button" class="btn btn-success overwrapDeBotones mr-3"  @click="DescargarExcelChequesCobrados()"><i class="fas fa-download fa-lg"></i>&nbsp;&nbsp;Descargar excel</button>

            <div  class="d-flex" style="height: 5px;">
            </div>
        
            </div>

















            
            </div>
    
    

    




         </div >

         <!-- /////////////////////////////////////////////////////// Reporte Impreso de Reporte de cheques cobrados-->


         <div id="printMe10" v-if="TablaReporteDeRelacionDeChequesCobrados" hidden>



         <div  id="logo_div"> 


         <div class="table-responsive">

         <table>

         <tr >


         <td> <img style="width: 40%" src="../../../assets/Logotipo_Positivo_Vertical-recibo.png" alt="Logo de Poder Judicial del Estado de Aguascalientes"  />  </td>
         <td class="text-center"><h5>Poder Judicial del Estado de Aguascalientes</h5></td>
         <td class="text-center"><h5>Dirección de Contabilidad y Control Presupuestal</h5></td>



         </tr>


         </table>





            </div>


         <h5 >{{ obtenerTituloBusquedaChequesCobrados() }}</h5>

         <div  class="d-flex" style="height: 20px;">
         <div class="vr"></div>
         </div>


            <div class="table-responsive">


            <table  class="table table-striped table-light table-hover table-bordered table-condensed " id="tablaDeReporteDeRelacionDeChequesCobrados_reporte_table"
            data-search="false" 
            data-toggle="tablaDeReporteDeRelacionDeChequesCobrados_reporte_table" 
            data-pagination="false" 
            data-toolbar="#tablaDeReporteDeRelacionDeChequesCobrados_reporte_texto_div"
            data-page-size="5"
            data-page-list="[2,5,10]"
            data-undefined-text="Sin información"
            data-minimum-count-columns="0">
                            <thead class="thead-light">
                <tr>
                
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:5%;" class="text-center">N°</th>

                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Juzgado</th>
                
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:4%;" class="text-center">Expediente</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:7%;" class="text-center">N° de Certificado</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">N° de Cheque</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:12%;" class="text-center">Nombre Cheque</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Fecha Cheque</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Monto para el Cheque</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Monto Poder Judicial</th>
                


                

                <th v-if="!AccionesMostrar.reportes" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:1%;" class="text-center">Acciones</th>
                </tr>

                </thead>

                <tbody class="text-dark">



                <tr v-for="(firma, indexImp7) in TablaReporteDeRelacionDeChequesCobrados" :key="indexImp7">

                <td class="text-center align-middle " style="width:5%;">{{indexImp7+1}}</td>

                <td class="text-center align-middle " style="width:10%;">{{ firma.Billetes.Areas.Des_area }}</td>

                <td class="text-center align-middle " style="width:4%;">{{ firma.Billetes.Consecutivo }}</td>

                <td class="text-center align-middle " style="width:10%;">{{ firma.Num_bole }}</td>

                <td class="text-center align-middle " style="width:10%;">{{ firma.Num_cheque }}</td>

                <td class="text-center align-middle " style="width:12%;">{{ firma.Nom_cobra }}</td> 

                <td class="text-center align-middle" style="width:10%;">{{ firma.Fec_cheque ? obtenerFechaConFormato(firma.Fec_cheque) : "" }}</td>

                <td class="text-center align-middle" style="width:10%;">${{agregarCeros(firma.Monto_cheque) }}</td>

                <td class="text-center align-middle" style="width:10%;">${{agregarCeros(firma.Monto_pojud) }}</td>

                </tr>






            </tbody>

            <tr>
             <td align="right" class="suma_total" scope="col" colspan="7">Importe</td>


            


            <td align="center" v-if="this.TablaReporteDeRelacionDeChequesCobradosFecha != null && this.TablaReporteDeRelacionDeChequesCobradosFecha != undefined" >${{agregarCeros(TablaReporteDeRelacionDeChequesCobradosFecha.SumaTotalMontoCheque)}}</td>

            <td align="center" v-if="this.TablaReporteDeRelacionDeChequesCobradosFechaActual != null && this.TablaReporteDeRelacionDeChequesCobradosFechaActual != undefined" >${{agregarCeros(TablaReporteDeRelacionDeChequesCobradosFechaActual.SumaTotalMontoCheque)}}</td>


            <td align="center" v-if="this.TablaReporteDeRelacionDeChequesCobradosFechaActual2 != null && this.TablaReporteDeRelacionDeChequesCobradosFechaActual2 != undefined" >${{agregarCeros(TablaReporteDeRelacionDeChequesCobradosFechaActual2.SumaTotalMontoCheque)}}</td>





            <td align="center" v-if="this.TablaReporteDeRelacionDeChequesCobradosFecha != null && this.TablaReporteDeRelacionDeChequesCobradosFecha != undefined" >${{agregarCeros(TablaReporteDeRelacionDeChequesCobradosFecha.SumaTotalMontoPodJud)}}</td>

            <td align="center" v-if="this.TablaReporteDeRelacionDeChequesCobradosFechaActual != null && this.TablaReporteDeRelacionDeChequesCobradosFechaActual != undefined" >${{agregarCeros(TablaReporteDeRelacionDeChequesCobradosFechaActual.SumaTotalMontoPodJud)}}</td>


            <td align="center" v-if="this.TablaReporteDeRelacionDeChequesCobradosFechaActual2 != null && this.TablaReporteDeRelacionDeChequesCobradosFechaActual2 != undefined" >${{agregarCeros(TablaReporteDeRelacionDeChequesCobradosFechaActual2.SumaTotalMontoPodJud)}}</td>

            


            




            </tr>





            </table>







            <!-- <div  class="d-flex" style="height: 5px;">

            </div>


            <h6 >Suma total del numero de certificados de deposito por reporte: {{TablaReporteDeRelacionDeChequesCobradosFecha.SumaTotalDeposito}}</h6> -->


            
            <h6 v-if="this.TablaReporteDeRelacionDeChequesCobradosFechaActual2 != null && this.TablaReporteDeRelacionDeChequesCobradosFechaActual2 != undefined" > Importe total del certificado de deposito ${{agregarCeros(TablaReporteDeRelacionDeChequesCobradosFechaActual2.SumaTotalDeposito)}}</h6>



            <h6 v-if="this.TablaReporteDeRelacionDeChequesCobradosFechaActual2 != null && this.TablaReporteDeRelacionDeChequesCobradosFechaActual2 != undefined" >Monto restante por pagar del certificado de deposito ${{agregarCeros(TablaReporteDeRelacionDeChequesCobradosFechaActual2.MontoPorPagar)}}</h6>




            </div>           






            </div>







            </div >



            <!-- //////////////////////////////////////////////////////////// -->



         <!-- /////////////////////////////////////////////////////// Reporte Excel de Reporte de cheques cobrados-->


             <div id="TablaReporteDeRelacionDeChequesCobradosExcel" v-if="TablaReporteDeRelacionDeChequesCobrados" hidden>



         <div  id="logo_div"> 


         <div class="table-responsive">

         <table>

         <tr >


         <td> <img style="width: 40%" src="../../../assets/Logotipo_Positivo_Vertical-recibo.png" alt="Logo de Poder Judicial del Estado de Aguascalientes"  />  </td>
         <td class="text-center"><h5>Poder Judicial del Estado de Aguascalientes</h5></td>
         <td class="text-center"><h5>Dirección de Contabilidad y Control Presupuestal</h5></td>



         </tr>


         </table>





            </div>


         <h5 >{{ obtenerTituloBusquedaChequesCobrados() }}</h5>

         <div  class="d-flex" style="height: 20px;">
         <div class="vr"></div>
         </div>


            <div class="table-responsive">


            <table  class="table table-striped table-light table-hover table-bordered table-condensed " id="tablaDeReporteDeRelacionDeChequesCobrados_reporte_excel_table"
            data-search="false" 
            data-toggle="tablaDeReporteDeRelacionDeChequesCobrados_reporte_excel_table" 
            data-pagination="false" 
            data-toolbar="#tablaDeReporteDeRelacionDeChequesCobrados_reporte_excel_texto_div"
            data-page-size="5"
            data-page-list="[2,5,10]"
            data-undefined-text="Sin información"
            data-minimum-count-columns="0">
                            <thead class="thead-green">
                <tr>
                
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:5%;" class="text-center">N°</th>

                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Juzgado</th>
                
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:4%;" class="text-center">Expediente</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:7%;" class="text-center">N° de Certificado</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">N° de Cheque</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:12%;" class="text-center">Nombre Cheque</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Fecha Cheque</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Monto para el Cheque</th>
                <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Monto Poder Judicial</th>
                


                

                <th v-if="!AccionesMostrar.reportes" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:1%;" class="text-center">Acciones</th>
                </tr>

                </thead>

                <tbody class="text-dark">



                <tr v-for="(firma, indexImp7) in TablaReporteDeRelacionDeChequesCobrados" :key="indexImp7">

                <td class="text-center align-middle " style="width:5%;">{{indexImp7+1}}</td>

                <td class="text-center align-middle " style="width:10%;">{{ firma.Billetes.Areas.Des_area }}</td>

                <td class="text-center align-middle " style="width:4%;">{{ firma.Billetes.Consecutivo }}</td>

                <td class="text-center align-middle " style="width:10%;">{{ firma.Num_bole }}</td>

                <td class="text-center align-middle " style="width:10%;">{{ firma.Num_cheque }}</td>

                <td class="text-center align-middle " style="width:10%;">{{ firma.Nom_cobra }}</td> 

                <td class="text-center align-middle" style="width:10%;">{{ firma.Fec_cheque ? obtenerFechaConFormato4(firma.Fec_cheque) : "" }}</td>

                <td class="text-center align-middle" style="width:10%;">{{firma.Monto_cheque}}</td>

                <td class="text-center align-middle" style="width:10%;">{{firma.Monto_pojud}}</td>

                </tr>






            </tbody>

            <tr>
             <td align="right" class="suma_total" scope="col" colspan="7"></td>

             <td v-if="this.TablaReporteDeRelacionDeChequesCobradosFecha != null && this.TablaReporteDeRelacionDeChequesCobradosFecha != undefined" align="center">{{TablaReporteDeRelacionDeChequesCobradosFecha.SumaTotalMontoCheque}}</td>

             <td v-if="this.TablaReporteDeRelacionDeChequesCobradosFechaActual != null && this.TablaReporteDeRelacionDeChequesCobradosFechaActual != undefined" align="center">{{TablaReporteDeRelacionDeChequesCobradosFechaActual.SumaTotalMontoCheque}}</td>

             <td v-if="this.TablaReporteDeRelacionDeChequesCobradosFechaActual2 != null && this.TablaReporteDeRelacionDeChequesCobradosFechaActual2 != undefined" align="center">{{TablaReporteDeRelacionDeChequesCobradosFechaActual2.SumaTotalMontoCheque}}</td>



             <td v-if="this.TablaReporteDeRelacionDeChequesCobradosFecha != null && this.TablaReporteDeRelacionDeChequesCobradosFecha != undefined" align="center">{{TablaReporteDeRelacionDeChequesCobradosFecha.SumaTotalMontoPodJud}}</td>

             <td v-if="this.TablaReporteDeRelacionDeChequesCobradosFechaActual != null && this.TablaReporteDeRelacionDeChequesCobradosFechaActual != undefined" align="center">{{TablaReporteDeRelacionDeChequesCobradosFechaActual.SumaTotalMontoPodJud}}</td>

             <td v-if="this.TablaReporteDeRelacionDeChequesCobradosFechaActual2 != null && this.TablaReporteDeRelacionDeChequesCobradosFechaActual2 != undefined" align="center">{{TablaReporteDeRelacionDeChequesCobradosFechaActual2.SumaTotalMontoPodJud}}</td>




            </tr>





            </table>







            <!-- <div  class="d-flex" style="height: 5px;">

            </div>


            <h6 >Suma total del numero de certificados de deposito por reporte: {{TablaReporteDeRelacionDeChequesCobradosFecha.SumaTotalDeposito}}</h6> -->


            </div>           






            </div>







            </div >

            

            <!-- //////////////////////////////////////////////////////////// -->







    
     </div >



</template>


<script>
    import Vue from 'vue'
    import comun from "@/../static/js/comun"
    import enumeraciones from '@/../static/js/enumeraciones'
    import catalogos from '@/../static/js/catalogos'
    import moment from 'moment'
    import { tooltipF } from '@/../static/js/tooltip/ToolTipDirective.js'
    import VueHtmlToPaper from 'vue-html-to-paper';
    import VueMask from 'v-mask'
    import func from '../Comun/Funciones/comun.js'

    import * as XLSX from 'xlsx/xlsx.mjs'

    //     const options = {
    //   "name": "_blank",
    //   "specs": [
    //     "fullscreen=yes",
    //     "titlebar=yes",
    //     "scrollbars=yes"
    //   ],
    //   "styles": [

    //     "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
    //     "https://unpkg.com/kidlat-css/css/kidlat.css",
    //   ],
    //   "timeout": 4000,
    //   "autoClose": true,
    //   "windowTitle": ""
    // }


  

  Vue.use(VueMask);
  //Vue.use(VueHtmlToPaper, opciones);
  Vue.use(VueHtmlToPaper);


    export default {
        data() {
            return {
                opciones: {
                    "name": "_blank",
                    "specs": [
                    "fullscreen=yes",
                    "titlebar=yes",
                    "scrollbars=yes"
                    ],
                    "styles": [

                    // "https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/js/bootstrap.min.js",
                    // "https://cdn.jsdelivr.net/npm/bootstrap@5.2.3/dist/css/bootstrap.min.css",


                    // "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
                    // "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/js/bootstrap.min.js",

                    "/static/js/bootstrap@4.0.0.min.js",
                    "/static/css/bootstrap@4.0.0.min.css",


                    //  "https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css",
                    // "https://unpkg.com/kidlat-css/css/kidlat.css",
            
                    ],
                    "timeout": 4000,
                    "autoClose": true,
                    "windowTitle": ""
                },
                enumeraciones,
                informacionParaPadre1: {
                
                    Procesado: Object,
                    Accion:
                    {
                        Alta: false,
                        Baja:false,
                        Cambios: false,
                        Visualizar: false,
                        CambiosTemporalidad: false,
                    }
                },
                informacionParaPadre2: {

                    Firma: Object,
                    

                    Accion:
                    {
                        Alta: false,
                        Impresion:false,
                        Cambios: false,
                        Visualizar: false,
                        AltaManual: false,
                        BajaPersona: false,
                        Mensaje: false,
                        VerificarRegistro: false,
                    }
                },
                
                informacionParaPadre3: {
                
                    Procesado: Object,
                    Accion:
                    {
                        
                        Visualizar: false
                    }
                },

                informacionParaPadre4: {
                
                    Procesado: Object,
                    Accion:
                    {
                        
                        Visualizar: false,
                        Reactivar: false,
                    }
                },

                informacionParaPadre5: {

                    Firma: Object,
                    

                    Accion:
                    {
                        
                        Mensaje: false,
                        
                    }
                },

                informacionParaPadre6: {
                
                    Expediente: Object,
                    Procesado: Object,
                    Accion:
                    {
                        
                        Baja:false,
                        Cambios: false,
                        Visualizar: false,
                        
                    }
                },

                mostrarsolonumeros: false




            }
         },
         directives: {
            tooltipF
         },
         props: {
            AccionesMostrar:{
                alta: false,
                impresion: false,
                cambios: false,
                cambiostemporalidad: false,
                consulta: false,
                visualizacion: false,
                altamanual: false,
                bajapersona: false,
                mensaje: false,
                verificarregistro: false,
                mostrardelitos: false,
                mostrartituloreporte: false,
                mostrartipodocumento: true,
                verificacion: false,
                reactivacion: false, 
            },
            TablaProcesados: {},
            TablaFirmas: {},
            TablaFirmasMensajes: {},
            TablaReporteFirmasNoVigentes: {},
            TablaReporteFirmasNoVigentesFecha: {},
            TablaReporteFirmasNoVigentesFechaActual: {},
            TablaReporteFirmasVigentes: {},
            TablaReporteFirmasVigentesFechaActual: {},
            TablaReporteDeMensajesRecibidos:{},
            TablaReporteDeMensajesRecibidosFecha:{},
            TablaReporteDeMensajesRecibidosFechaActual:{},
            TablaReporteDeMensajesNoRecibidos:{},
            TablaReporteDeMensajesNoRecibidosFechaActual:{},
            TablaReporteDeCatalogoDeFirmantes:{},
            TablaReporteDeCatalogoDeFirmantesFechaActual:{},
            TablaReporteDeCatalogoDeFirmantesDadosDeBaja:{},
            TablaReporteDeCatalogoDeFirmantesDadosDeBajaFechaActual:{},
            TablaReporteDeBitacoraDeMovimientos:{},
            TablaReporteDeBitacoraDeMovimientosFecha:{},
            TablaReporteDeBitacoraDeMovimientosFechaActual:{},
            TablaProcesadosExpedientes:{},
            TablaVerificacionReciboDeFirmas: {},
            TablaVerificacionReciboDeFirmasFecha: {},
            TablaVerificacionReciboDeFirmasFechaActual: {},
            TablaVerificacionReciboDeFirmasFirmaNoVigente: {},
            TablaReporteDeRelacionDeCertificadosCobrados: {},
            TablaReporteDeRelacionDeCertificadosCobradosFecha: {},
            TablaReporteDeRelacionDeCertificadosCobradosFechaActual: {},
            TablaReporteDeRelacionDeChequesCobrados: {},
            TablaReporteDeRelacionDeChequesCobradosFecha: {},
            TablaReporteDeRelacionDeChequesCobradosFechaActual: {},
            TablaReporteDeRelacionDeChequesCobradosFechaActual2: {},
            tituloDeInformacionprueba: String,
            tituloTablaReporteFirmasVigentes: {
                default: '',
                type: String
            },
            tituloTablaReporteFirmasNoVigentes: {
                default: '',
                type: String
            },
            tituloTablaReporteDeMensajesRecibidos: {
                default: '',
                type: String
            },
            tituloTablaReporteDeMensajesNoRecibidos: {
                default: '',
                type: String
            },
            tituloTablaReporteDeCatalogoDeFirmantes: {
                default: '',
                type: String
            },
            tituloTablaReporteDeCatalogoDeFirmantesDadosDeBaja: {
                default: '',
                type: String
            },
            tituloTablaReporteDeBitacoraDeMovimientos: {
                default: '',
                type: String
            },
            tituloTablaVerificacionReciboDeFirmas: {
                default: '',
                type: String
            },
            tituloTablaReporteDeRelacionDeCertificadosCobrados: {
                default: '',
                type: String
            },
            tituloTablaReporteDeRelacionDeChequesCobrados: {
                default: '',
                type: String
            },
            numeroTablaReporteFirmasVigentes: {
                default: 0,
                type: Number
            },
         },
         mounted() {


        
         },
         created() {
            
         },
         methods: {          
            obtenerTituloBusquedaFirmasNoVigentes: function() { 
                let titulo = this.tituloTablaReporteFirmasNoVigentes;


                const OBJETO_FECHA_NOT_NULL = (this.TablaReporteFirmasNoVigentesFecha != null && this.TablaReporteFirmasNoVigentesFecha != undefined);

                const OBJETO_FECHA_ACTUAL_NOT_NULL = (this.TablaReporteFirmasNoVigentesFechaActual != null && this.TablaReporteFirmasNoVigentesFechaActual != undefined);


                if(OBJETO_FECHA_NOT_NULL) {
                    const OBJ_FECHA_VALUE = (this.TablaReporteFirmasNoVigentesFecha.FechaInicial != null && this.TablaReporteFirmasNoVigentesFecha.FechaInicial != undefined);
                    if(OBJ_FECHA_VALUE) {
                        let fechaInicial = this.TablaReporteFirmasNoVigentesFecha.FechaInicial != null ? this.obtenerFechaConFormato2(this.TablaReporteFirmasNoVigentesFecha.FechaInicial) : ''; 
                        let fechaFinal = this.TablaReporteFirmasNoVigentesFecha.FechaFinal != null ? this.obtenerFechaConFormato2(this.TablaReporteFirmasNoVigentesFecha.FechaFinal) : ''; 
                        titulo = `${ titulo } ${ fechaInicial } al ${ fechaFinal }`;
                    }
                }

                else if(OBJETO_FECHA_ACTUAL_NOT_NULL) {
                    const OBJ_FECHA_ACTUAL_VALUE = (this.TablaReporteFirmasNoVigentesFechaActual.FechaActual != null && this.TablaReporteFirmasNoVigentesFechaActual.FechaActual != undefined);
                    if(OBJ_FECHA_ACTUAL_VALUE) {

                        let fechaActual = this.TablaReporteFirmasNoVigentesFechaActual.FechaActual != null ? this.obtenerFechaConFormato2(this.TablaReporteFirmasNoVigentesFechaActual.FechaActual) : ''; 

                        titulo = `${ titulo } al ${ fechaActual }`;
                    }
                }




                return titulo;







            }  ,


            obtenerTituloBusquedaMensajes: function() { 
                let titulo = this.tituloTablaReporteDeMensajesRecibidos;


                const OBJETO_FECHA_NOT_NULL = (this.TablaReporteDeMensajesRecibidosFecha != null && this.TablaReporteDeMensajesRecibidosFecha != undefined);

                const OBJETO_FECHA_ACTUAL_NOT_NULL = (this.TablaReporteDeMensajesRecibidosFechaActual != null && this.TablaReporteDeMensajesRecibidosFechaActual != undefined);



                if(OBJETO_FECHA_NOT_NULL) {
                    const OBJ_FECHA_VALUE = (this.TablaReporteDeMensajesRecibidosFecha.FechaInicial != null && this.TablaReporteDeMensajesRecibidosFecha.FechaInicial != undefined);
                    if(OBJ_FECHA_VALUE) {
                        let fechaInicial = this.TablaReporteDeMensajesRecibidosFecha.FechaInicial != null ? this.obtenerFechaConFormato2(this.TablaReporteDeMensajesRecibidosFecha.FechaInicial) : ''; 
                        let fechaFinal = this.TablaReporteDeMensajesRecibidosFecha.FechaFinal != null ? this.obtenerFechaConFormato2(this.TablaReporteDeMensajesRecibidosFecha.FechaFinal) : ''; 
                        titulo = `${ titulo } ${ fechaInicial } al ${ fechaFinal }`;
                    }
                }


                else if(OBJETO_FECHA_ACTUAL_NOT_NULL) {
                    const OBJ_FECHA_ACTUAL_VALUE = (this.TablaReporteDeMensajesRecibidosFechaActual.FechaActual != null && this.TablaReporteDeMensajesRecibidosFechaActual.FechaActual != undefined);
                    if(OBJ_FECHA_ACTUAL_VALUE) {

                        let fechaActual = this.TablaReporteDeMensajesRecibidosFechaActual.FechaActual != null ? this.obtenerFechaConFormato2(this.TablaReporteDeMensajesRecibidosFechaActual.FechaActual) : ''; 

                        titulo = `${ titulo } al ${ fechaActual }`;
                    }
                }





                return titulo;
            }  ,






            obtenerTituloBusquedaMensajesNoRecibidos: function() { 
                let titulo = this.tituloTablaReporteDeMensajesNoRecibidos;


                const OBJETO_FECHA_ACTUAL_NOT_NULL = (this.TablaReporteDeMensajesNoRecibidosFechaActual != null && this.TablaReporteDeMensajesNoRecibidosFechaActual != undefined);



                if(OBJETO_FECHA_ACTUAL_NOT_NULL) {
                    const OBJ_FECHA_ACTUAL_VALUE = (this.TablaReporteDeMensajesNoRecibidosFechaActual.FechaActual != null && this.TablaReporteDeMensajesNoRecibidosFechaActual.FechaActual != undefined);
                    if(OBJ_FECHA_ACTUAL_VALUE) {

                        let fechaActual = this.TablaReporteDeMensajesNoRecibidosFechaActual.FechaActual != null ? this.obtenerFechaConFormato2(this.TablaReporteDeMensajesNoRecibidosFechaActual.FechaActual) : ''; 

                        titulo = `${ titulo } al ${ fechaActual }`;
                    }
                }





                return titulo;
            }  ,



            obtenerTituloBusquedaFirmasVigentes: function() { 
                let titulo = this.tituloTablaReporteFirmasVigentes;


                const OBJETO_FECHA_ACTUAL_NOT_NULL = (this.TablaReporteFirmasVigentesFechaActual != null && this.TablaReporteFirmasVigentesFechaActual != undefined);



                if(OBJETO_FECHA_ACTUAL_NOT_NULL) {
                    const OBJ_FECHA_ACTUAL_VALUE = (this.TablaReporteFirmasVigentesFechaActual.FechaActual != null && this.TablaReporteFirmasVigentesFechaActual.FechaActual != undefined);
                    if(OBJ_FECHA_ACTUAL_VALUE) {

                        let fechaActual = this.TablaReporteFirmasVigentesFechaActual.FechaActual != null ? this.obtenerFechaConFormato2(this.TablaReporteFirmasVigentesFechaActual.FechaActual) : ''; 

                        titulo = `${ titulo } al ${ fechaActual }`;
                    }
                }





                return titulo;
            }  ,


            obtenerTituloBusquedaReporteDeCatalogoDeFirmantes: function() { 
                let titulo = this.tituloTablaReporteDeCatalogoDeFirmantes;


                const OBJETO_FECHA_ACTUAL_NOT_NULL = (this.TablaReporteDeCatalogoDeFirmantesFechaActual != null && this.TablaReporteDeCatalogoDeFirmantesFechaActual != undefined);



                if(OBJETO_FECHA_ACTUAL_NOT_NULL) {
                    const OBJ_FECHA_ACTUAL_VALUE = (this.TablaReporteDeCatalogoDeFirmantesFechaActual.FechaActual != null && this.TablaReporteDeCatalogoDeFirmantesFechaActual.FechaActual != undefined);
                    if(OBJ_FECHA_ACTUAL_VALUE) {

                        let fechaActual = this.TablaReporteDeCatalogoDeFirmantesFechaActual.FechaActual != null ? this.obtenerFechaConFormato2(this.TablaReporteDeCatalogoDeFirmantesFechaActual.FechaActual) : ''; 

                        titulo = `${ titulo } al ${ fechaActual }`;
                    }
                }





                return titulo;
            }  ,



            obtenerTituloBusquedaReporteDeCatalogoDeFirmantesDadosDeBaja: function() { 
                let titulo = this.tituloTablaReporteDeCatalogoDeFirmantesDadosDeBaja;


                const OBJETO_FECHA_ACTUAL_NOT_NULL = (this.TablaReporteDeCatalogoDeFirmantesDadosDeBajaFechaActual != null && this.TablaReporteDeCatalogoDeFirmantesDadosDeBajaFechaActual != undefined);



                if(OBJETO_FECHA_ACTUAL_NOT_NULL) {
                    const OBJ_FECHA_ACTUAL_VALUE = (this.TablaReporteDeCatalogoDeFirmantesDadosDeBajaFechaActual.FechaActual != null && this.TablaReporteDeCatalogoDeFirmantesDadosDeBajaFechaActual.FechaActual != undefined);
                    if(OBJ_FECHA_ACTUAL_VALUE) {

                        let fechaActual = this.TablaReporteDeCatalogoDeFirmantesDadosDeBajaFechaActual.FechaActual != null ? this.obtenerFechaConFormato2(this.TablaReporteDeCatalogoDeFirmantesDadosDeBajaFechaActual.FechaActual) : ''; 

                        titulo = `${ titulo } al ${ fechaActual }`;
                    }
                }





                return titulo;
            }  ,




                        obtenerTituloBusquedaMovimientos: function() { 
                let titulo = this.tituloTablaReporteDeBitacoraDeMovimientos;


                const OBJETO_FECHA_NOT_NULL = (this.TablaReporteDeBitacoraDeMovimientosFecha != null && this.TablaReporteDeBitacoraDeMovimientosFecha != undefined);

                const OBJETO_FECHA_ACTUAL_NOT_NULL = (this.TablaReporteDeBitacoraDeMovimientosFechaActual != null && this.TablaReporteDeBitacoraDeMovimientosFechaActual != undefined);


                if(OBJETO_FECHA_NOT_NULL) {
                    const OBJ_FECHA_VALUE = (this.TablaReporteDeBitacoraDeMovimientosFecha.FechaInicial != null && this.TablaReporteDeBitacoraDeMovimientosFecha.FechaInicial != undefined);
                    if(OBJ_FECHA_VALUE) {
                        let fechaInicial = this.TablaReporteDeBitacoraDeMovimientosFecha.FechaInicial != null ? this.obtenerFechaConFormato2(this.TablaReporteDeBitacoraDeMovimientosFecha.FechaInicial) : ''; 
                        let fechaFinal = this.TablaReporteDeBitacoraDeMovimientosFecha.FechaFinal != null ? this.obtenerFechaConFormato2(this.TablaReporteDeBitacoraDeMovimientosFecha.FechaFinal) : ''; 
                        titulo = `${ titulo } ${ fechaInicial } al ${ fechaFinal }`;
                    }
                }

                else if(OBJETO_FECHA_ACTUAL_NOT_NULL) {
                    const OBJ_FECHA_ACTUAL_VALUE = (this.TablaReporteDeBitacoraDeMovimientosFechaActual.FechaActual != null && this.TablaReporteDeBitacoraDeMovimientosFechaActual.FechaActual != undefined);
                    if(OBJ_FECHA_ACTUAL_VALUE) {

                        let fechaActual = this.TablaReporteDeBitacoraDeMovimientosFechaActual.FechaActual != null ? this.obtenerFechaConFormato2(this.TablaReporteDeBitacoraDeMovimientosFechaActual.FechaActual) : ''; 

                        titulo = `${ titulo } al ${ fechaActual }`;
                    }
                }




                return titulo;







            }  ,



                        obtenerTituloBusquedaVerificacionReciboDeFirmas: function() { 
                let titulo = this.tituloTablaVerificacionReciboDeFirmas;


                const OBJETO_FECHA_NOT_NULL = (this.TablaVerificacionReciboDeFirmasFecha != null && this.TablaVerificacionReciboDeFirmasFecha != undefined);

                const OBJETO_FECHA_ACTUAL_NOT_NULL = (this.TablaVerificacionReciboDeFirmasFechaActual != null && this.TablaVerificacionReciboDeFirmasFechaActual != undefined);


                if(OBJETO_FECHA_NOT_NULL) {
                    const OBJ_FECHA_VALUE = (this.TablaVerificacionReciboDeFirmasFecha.FechaInicial != null && this.TablaVerificacionReciboDeFirmasFecha.FechaInicial != undefined);
                    if(OBJ_FECHA_VALUE) {
                        let fechaInicial = this.TablaVerificacionReciboDeFirmasFecha.FechaInicial != null ? this.obtenerFechaConFormato2(this.TablaVerificacionReciboDeFirmasFecha.FechaInicial) : ''; 
                        let fechaFinal = this.TablaVerificacionReciboDeFirmasFecha.FechaFinal != null ? this.obtenerFechaConFormato2(this.TablaVerificacionReciboDeFirmasFecha.FechaFinal) : ''; 
                        titulo = `${ titulo } ${ fechaInicial } al ${ fechaFinal }`;
                    }
                }

                else if(OBJETO_FECHA_ACTUAL_NOT_NULL) {
                    const OBJ_FECHA_ACTUAL_VALUE = (this.TablaVerificacionReciboDeFirmasFechaActual.FechaActual != null && this.TablaVerificacionReciboDeFirmasFechaActual.FechaActual != undefined);
                    if(OBJ_FECHA_ACTUAL_VALUE) {

                        let fechaActual = this.TablaVerificacionReciboDeFirmasFechaActual.FechaActual != null ? this.obtenerFechaConFormato2(this.TablaVerificacionReciboDeFirmasFechaActual.FechaActual) : ''; 

                        titulo = `${ titulo } al ${ fechaActual }`;
                    }
                }




                return titulo;







            }  ,




            obtenerTituloBusquedaCertificadosCobrados: function() { 
                let titulo = this.tituloTablaReporteDeRelacionDeCertificadosCobrados;


                const OBJETO_FECHA_NOT_NULL = (this.TablaReporteDeRelacionDeCertificadosCobradosFecha != null && this.TablaReporteDeRelacionDeCertificadosCobradosFecha != undefined);

                const OBJETO_FECHA_ACTUAL_NOT_NULL = (this.TablaReporteDeRelacionDeCertificadosCobradosFechaActual != null && this.TablaReporteDeRelacionDeCertificadosCobradosFechaActual != undefined);


                if(OBJETO_FECHA_NOT_NULL) {
                    const OBJ_FECHA_VALUE = (this.TablaReporteDeRelacionDeCertificadosCobradosFecha.FechaInicial != null && this.TablaReporteDeRelacionDeCertificadosCobradosFecha.FechaInicial != undefined);
                    if(OBJ_FECHA_VALUE) {
                        let fechaInicial = this.TablaReporteDeRelacionDeCertificadosCobradosFecha.FechaInicial != null ? this.obtenerFechaConFormato2(this.TablaReporteDeRelacionDeCertificadosCobradosFecha.FechaInicial) : ''; 
                        let fechaFinal = this.TablaReporteDeRelacionDeCertificadosCobradosFecha.FechaFinal != null ? this.obtenerFechaConFormato2(this.TablaReporteDeRelacionDeCertificadosCobradosFecha.FechaFinal) : ''; 
                        titulo = `${ titulo } ${ fechaInicial } al ${ fechaFinal }`;
                    }
                }

                else if(OBJETO_FECHA_ACTUAL_NOT_NULL) {
                    const OBJ_FECHA_ACTUAL_VALUE = (this.TablaReporteDeRelacionDeCertificadosCobradosFechaActual.FechaActual != null && this.TablaReporteDeRelacionDeCertificadosCobradosFechaActual.FechaActual != undefined);
                    if(OBJ_FECHA_ACTUAL_VALUE) {

                        let fechaActual = this.TablaReporteDeRelacionDeCertificadosCobradosFechaActual.FechaActual != null ? this.obtenerFechaConFormato2(this.TablaReporteDeRelacionDeCertificadosCobradosFechaActual.FechaActual) : ''; 

                        titulo = `${ titulo } al ${ fechaActual }`;
                    }
                }




                return titulo;







            }  ,



            obtenerTituloBusquedaChequesCobrados: function() { 
                let titulo = this.tituloTablaReporteDeRelacionDeChequesCobrados;


                const OBJETO_FECHA_NOT_NULL = (this.TablaReporteDeRelacionDeChequesCobradosFecha != null && this.TablaReporteDeRelacionDeChequesCobradosFecha != undefined);

                const OBJETO_FECHA_ACTUAL_NOT_NULL = (this.TablaReporteDeRelacionDeChequesCobradosFechaActual != null && this.TablaReporteDeRelacionDeChequesCobradosFechaActual != undefined);

                const OBJETO_FECHA_ACTUAL2_NOT_NULL = (this.TablaReporteDeRelacionDeChequesCobradosFechaActual2 != null && this.TablaReporteDeRelacionDeChequesCobradosFechaActual2 != undefined);


                if(OBJETO_FECHA_NOT_NULL) {
                    const OBJ_FECHA_VALUE = (this.TablaReporteDeRelacionDeChequesCobradosFecha.FechaInicial != null && this.TablaReporteDeRelacionDeChequesCobradosFecha.FechaInicial != undefined);
                    if(OBJ_FECHA_VALUE) {
                        let fechaInicial = this.TablaReporteDeRelacionDeChequesCobradosFecha.FechaInicial != null ? this.obtenerFechaConFormato2(this.TablaReporteDeRelacionDeChequesCobradosFecha.FechaInicial) : ''; 
                        let fechaFinal = this.TablaReporteDeRelacionDeChequesCobradosFecha.FechaFinal != null ? this.obtenerFechaConFormato2(this.TablaReporteDeRelacionDeChequesCobradosFecha.FechaFinal) : ''; 
                        titulo = `${ titulo } ${ fechaInicial } al ${ fechaFinal }`;
                    }
                }

                else if(OBJETO_FECHA_ACTUAL_NOT_NULL) {
                    const OBJ_FECHA_ACTUAL_VALUE = (this.TablaReporteDeRelacionDeChequesCobradosFechaActual.FechaActual != null && this.TablaReporteDeRelacionDeChequesCobradosFechaActual.FechaActual != undefined);
                    if(OBJ_FECHA_ACTUAL_VALUE) {

                        let fechaActual = this.TablaReporteDeRelacionDeChequesCobradosFechaActual.FechaActual != null ? this.obtenerFechaConFormato2(this.TablaReporteDeRelacionDeChequesCobradosFechaActual.FechaActual) : ''; 

                        titulo = `${ titulo } al ${ fechaActual }`;
                    }
                }


                else if(OBJETO_FECHA_ACTUAL2_NOT_NULL) {
                    const OBJ_FECHA_ACTUAL_VALUE = (this.TablaReporteDeRelacionDeChequesCobradosFechaActual2.FechaActual != null && this.TablaReporteDeRelacionDeChequesCobradosFechaActual2.FechaActual != undefined);
                    if(OBJ_FECHA_ACTUAL_VALUE) {

                        let fechaActual = this.TablaReporteDeRelacionDeChequesCobradosFechaActual2.FechaActual != null ? this.obtenerFechaConFormato2(this.TablaReporteDeRelacionDeChequesCobradosFechaActual2.FechaActual) : ''; 

                        titulo = `${ titulo } al ${ fechaActual }`;
                    }
                }




                return titulo;







            }  ,





            /**
             * Método encargado de limpiar acciones que que transfieren al padre para realizar una acción.
             */
            limpiarAccionesParaPadre1:function()
            {
                this.informacionParaPadre1.Accion = {                    
                }
            },

            limpiarAccionesParaPadre2:function()
            {
                this.informacionParaPadre2.Accion = {                    
                }
            },

            limpiarAccionesParaPadre3:function()
            {
                this.informacionParaPadre3.Accion = {                    
                }
            },

            limpiarAccionesParaPadre4:function()
            {
                this.informacionParaPadre4.Accion = {                    
                }
            },

            limpiarAccionesParaPadre5:function()
            {
                this.informacionParaPadre5.Accion = {                    
                }
            },

            limpiarAccionesParaPadre6:function()
            {
                this.informacionParaPadre6.Accion = {                    
                }
            },


            




            /**
             * Método encargado de enviar la información necesaria para trabajar a componente padre, se manda
             * un objeto procesado, así como la acción a realizar.
             */
            eventoValorParaElPadre1:function(indexDeElementoPadre)
            {
                if(indexDeElementoPadre > -1) 
                {
                    
                    this.informacionParaPadre1.Procesado = this.TablaProcesados[indexDeElementoPadre];
                    this.$emit("valorParaElPadreAccion", this.informacionParaPadre1);

                   


                } 
                else comun.mensajeDeAlerta("Ha sucedido un error con el elemento seleccionado.", null, null);
            },


            eventoValorParaElPadre2:function(indexDeElementoPadre)
            {
                if(indexDeElementoPadre > -1) 
                {
                    this.informacionParaPadre2.Firma = this.TablaFirmas[indexDeElementoPadre];

                    this.$emit("valorParaElPadreAccion", this.informacionParaPadre2);

                   
                    // Nota: .Firmas viene del API lo que esta en visual studio
                } 
                else comun.mensajeDeAlerta("Ha sucedido un error con el elemento seleccionado.", null, null);
            },


            eventoValorParaElPadre3:function(indexDeElementoPadre)
            {
                if(indexDeElementoPadre > -1) 
                {
                    
                    this.informacionParaPadre3.Procesado = this.TablaReporteDeCatalogoDeFirmantes[indexDeElementoPadre];
                    this.$emit("valorParaElPadreAccion", this.informacionParaPadre3);

                   


                } 
                else comun.mensajeDeAlerta("Ha sucedido un error con el elemento seleccionado.", null, null);
            },


            eventoValorParaElPadre4:function(indexDeElementoPadre)
            {
                if(indexDeElementoPadre > -1) 
                {
                    
                    this.informacionParaPadre4.Procesado = this.TablaReporteDeCatalogoDeFirmantesDadosDeBaja[indexDeElementoPadre];

                    this.$emit("valorParaElPadreAccion", this.informacionParaPadre4);

                   


                } 
                else comun.mensajeDeAlerta("Ha sucedido un error con el elemento seleccionado.", null, null);
            },

            eventoValorParaElPadre5:function(indexDeElementoPadre)
            {
                if(indexDeElementoPadre > -1) 
                {
                    this.informacionParaPadre5.Firma = this.TablaFirmasMensajes[indexDeElementoPadre];

                    this.$emit("valorParaElPadreAccion", this.informacionParaPadre5);

                   
                    // Nota: .Firmas viene del API lo que esta en visual studio
                } 
                else comun.mensajeDeAlerta("Ha sucedido un error con el elemento seleccionado.", null, null);
            },


            eventoValorParaElPadre6:function(indexDeElementoPadre, indexDeElemento)
            {
                if(indexDeElemento > -1) 
                {
                    this.informacionParaPadre6.Expediente = this.TablaProcesadosExpedientes[indexDeElementoPadre].ExpedientesProcesados[indexDeElemento];

                    this.informacionParaPadre6.Procesado = this.TablaProcesadosExpedientes[indexDeElementoPadre];

                    this.$emit("valorParaElPadreAccion", this.informacionParaPadre6);

                   
                    // Nota: .Firmas viene del API lo que esta en visual studio
                } 
                else comun.mensajeDeAlerta("Ha sucedido un error con el elemento seleccionado.", null, null);
            },



             /**
             * Método encargado de obtener la fecha con un formato específico.
             */
            obtenerFechaConFormato:function(fecha)
            {
                return moment(fecha).format("DD-MM-YYYY");
            },




            /**
             * Método encargado de obtener la fecha con un formato específico.
             */
            obtenerFechaConFormato2:function(fecha)
            {
                return moment(fecha).format("LL");
            },


             /**
             * Método encargado de obtener la fecha con un formato específico.
             */
            obtenerFechaConFormato4:function(fecha)
            {
                return moment(fecha).format("DD/MM/YYYY");
            },


             /**
             * Método encargado de obtener la fecha con un formato específico.
             */
            obtenerFechaConFormato7:function(fecha)
            {
                return moment(fecha).locale('es').format("DD-MM-YYYY, h:mm:ss a");
            },


            /**
             * Método encargado de obtener la fecha con un formato específico.
             */
            obtenerFechaConFormato9:function(fecha)
            {
                return moment(fecha).format("DD/MM/YYYY h:mm:ss a");
            },

            agregarCeros : function(monto){
            return func.agregarCeros(monto)
            },




            /**
             * Función encargada de imprimir el reporte de firmas no vigentes
             */
            ImprimirReporteFirmasNoVigentes:function()
            {

            
                // bootbox.confirm({
                //     title: "Mensaje del sistema",
                //     message: "Está por generar el reporte de firmas no vigentes. <br />¿Desea continuar?",
                //     buttons: {
                //     cancel: {
                //         label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                //     },
                //     confirm: {
                //         label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Imprimir Reporte'
                //     }
                //     },
                //     callback: (respuestaContinuar) => {
                //     if (respuestaContinuar) {

                //         this.$htmlToPaper('printMe',this.opciones);


                //         if(respuestaContinuar){

                //         this.$emit("restablecervalores");


                //         }

                        
                //     }
                //     }
                // });


                
                        this.$htmlToPaper('printMe',this.opciones);

                        this.$emit("restablecervalores");


                   

            },



            /**
             * Función encargada de imprimir el reporte de firmas vigentes
             */
            ImprimirReporteFirmasVigentes:function()
            {

            
                // bootbox.confirm({
                //     title: "Mensaje del sistema",
                //     message: "Está por generar el reporte de firmas vigentes. <br />¿Desea continuar?",
                //     buttons: {
                //     cancel: {
                //         label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                //     },
                //     confirm: {
                //         label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Imprimir Reporte'
                //     }
                //     },
                //     callback: (respuestaContinuar) => {
                //     if (respuestaContinuar) {

                //         this.$htmlToPaper('printMe2',this.opciones);


                //         if(respuestaContinuar){

                //         this.$emit("restablecervalores");


                //         }

                        
                //     }
                //     }
                // });



                        this.$htmlToPaper('printMe2',this.opciones);

                        this.$emit("restablecervalores");


                




            },



            /**
             * Función encargada de imprimir el reporte de mensajes recibidos
             */
            ImprimirReporteMensajesRecibidos:function()
            {

            
                // bootbox.confirm({
                //     title: "Mensaje del sistema",
                //     message: "Está por generar el reporte de mensajes recibidos. <br />¿Desea continuar?",
                //     buttons: {
                //     cancel: {
                //         label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                //     },
                //     confirm: {
                //         label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Imprimir Reporte'
                //     }
                //     },
                //     callback: (respuestaContinuar) => {
                //     if (respuestaContinuar) {

                //         this.$htmlToPaper('printMe3',this.opciones);


                //         if(respuestaContinuar){

                //         this.$emit("restablecervalores");


                //         }

                        
                //     }
                //     }
                // });


                         this.$htmlToPaper('printMe3',this.opciones);
                         this.$emit("restablecervalores");


                   

            },



            /**
             * Función encargada de imprimir el reporte de mensajes no recibidos
             */
            ImprimirReporteMensajesNoRecibidos:function()
            {

            
                // bootbox.confirm({
                //     title: "Mensaje del sistema",
                //     message: "Está por generar el reporte de mensajes no recibidos. <br />¿Desea continuar?",
                //     buttons: {
                //     cancel: {
                //         label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                //     },
                //     confirm: {
                //         label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Imprimir Reporte'
                //     }
                //     },
                //     callback: (respuestaContinuar) => {
                //     if (respuestaContinuar) {

                //         this.$htmlToPaper('printMe4',this.opciones);


                //         if(respuestaContinuar){

                //         this.$emit("restablecervalores");


                //         }

                        
                //     }
                //     }
                // });


                         this.$htmlToPaper('printMe4',this.opciones);
                         this.$emit("restablecervalores");


            },



            /**
             * Función encargada de imprimir el reporte del catalogo de firmantes
             */
            ImprimirReporteCatalogoDeFirmantes:function()
            {

            
                // bootbox.confirm({
                //     title: "Mensaje del sistema",
                //     message: "Está por generar el reporte del catalogo de firmantes. <br />¿Desea continuar?",
                //     buttons: {
                //     cancel: {
                //         label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                //     },
                //     confirm: {
                //         label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Imprimir Reporte'
                //     }
                //     },
                //     callback: (respuestaContinuar) => {
                //     if (respuestaContinuar) {

                //         this.$htmlToPaper('printMe5',this.opciones);


                //         if(respuestaContinuar){

                //         this.$emit("restablecervalores");


                //         }

                        
                //     }
                //     }
                // });


                         this.$htmlToPaper('printMe5',this.opciones);

                         this.$emit("restablecervalores");

            },



            /**
             * Función encargada de imprimir el reporte del catalogo de firmantes dados de baja
             */
            ImprimirReporteCatalogoDeFirmantesDadosDeBaja:function()
            {

            
                // bootbox.confirm({
                //     title: "Mensaje del sistema",
                //     message: "Está por generar el reporte del catalogo de firmantes dados de baja. <br />¿Desea continuar?",
                //     buttons: {
                //     cancel: {
                //         label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                //     },
                //     confirm: {
                //         label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Imprimir Reporte'
                //     }
                //     },
                //     callback: (respuestaContinuar) => {
                //     if (respuestaContinuar) {

                //         this.$htmlToPaper('printMe6',this.opciones);


                //         if(respuestaContinuar){

                //         this.$emit("restablecervalores");


                //         }

                        
                //     }
                //     }
                // });


                        this.$htmlToPaper('printMe6',this.opciones);
             
                        this.$emit("restablecervalores");


            },



            /**
             * Función encargada de imprimir el reporte del catalogo de firmantes dados de baja
             */
            ImprimirReporteDeBitacoraDeMovimientos:function()
            {

            
                // bootbox.confirm({
                //     title: "Mensaje del sistema",
                //     message: "Está por generar el reporte la bitacora de movimientos. <br />¿Desea continuar?",
                //     buttons: {
                //     cancel: {
                //         label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                //     },
                //     confirm: {
                //         label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Imprimir Reporte'
                //     }
                //     },
                //     callback: (respuestaContinuar) => {
                //     if (respuestaContinuar) {

                //         this.$htmlToPaper('printMe7',this.opciones);


                //         if(respuestaContinuar){

                //         this.$emit("restablecervalores");


                //         }

                        
                //     }
                //     }
                // });


                        this.$htmlToPaper('printMe7',this.opciones);

                        this.$emit("restablecervalores");

            },



            /**
             * Función encargada de imprimir la verificacion del recibo de firmas
             */
            ImprimirVerificacionReciboDeFirmas:function()
            {

            
                // bootbox.confirm({
                //     title: "Mensaje del sistema",
                //     message: "Está imprimir el comprobante de recibo de firmas. <br />¿Desea continuar?",
                //     buttons: {
                //     cancel: {
                //         label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                //     },
                //     confirm: {
                //         label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Imprimir Comprobante'
                //     }
                //     },
                //     callback: (respuestaContinuar) => {
                //     if (respuestaContinuar) {

                //         this.$htmlToPaper('printMe8',this.opciones);


                //         if(respuestaContinuar){

                //         this.$emit("restablecervalores");


                //         }

                        
                //     }
                //     }
                // });


                        this.$htmlToPaper('printMe8',this.opciones);

                        this.$emit("restablecervalores");




            },


            /**
             * Función encargada de imprimir el reporte de relacion de certificados cobrados
             */
            ImprimirReporteDeRelacionDeCertificadosCobrados:function()
            {

            
                // bootbox.confirm({
                //     title: "Mensaje del sistema",
                //     message: "Está por generar el reporte de certificados cobrados. <br />¿Desea continuar?",
                //     buttons: {
                //     cancel: {
                //         label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                //     },
                //     confirm: {
                //         label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Imprimir Reporte'
                //     }
                //     },
                //     callback: (respuestaContinuar) => {
                //     if (respuestaContinuar) {

                //         this.$htmlToPaper('printMe9',this.opciones);


                //         if(respuestaContinuar){

                //         this.$emit("restablecervalores");


                //         }

                        
                //     }
                //     }
                // });

                        this.$htmlToPaper('printMe9',this.opciones);

                        this.$emit("restablecervalores");

            },



            /**
             * Función encargada de imprimir el reporte de relacion de certificados pagados
             */
            ImprimirReporteDeRelacionDeCertificadosPagados:function()
            {

            
                // bootbox.confirm({
                //     title: "Mensaje del sistema",
                //     message: "Está por generar el reporte de certificados pagados. <br />¿Desea continuar?",
                //     buttons: {
                //     cancel: {
                //         label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                //     },
                //     confirm: {
                //         label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Imprimir Reporte'
                //     }
                //     },
                //     callback: (respuestaContinuar) => {
                //     if (respuestaContinuar) {

                //         this.$htmlToPaper('printMe9',this.opciones);


                //         if(respuestaContinuar){

                //         this.$emit("restablecervalores");


                //         }

                        
                //     }
                //     }
                // });

                        this.$htmlToPaper('printMe9',this.opciones);

                        this.$emit("restablecervalores");

            },



            /**
             * Función encargada de imprimir el reporte de relacion de cheques cobrados
             */
            ImprimirReporteDeRelacionDeChequesCobrados:function()
            {

            
                // bootbox.confirm({
                //     title: "Mensaje del sistema",
                //     message: "Está por generar el reporte de cheques cobrados. <br />¿Desea continuar?",
                //     buttons: {
                //     cancel: {
                //         label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                //     },
                //     confirm: {
                //         label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Imprimir Reporte'
                //     }
                //     },
                //     callback: (respuestaContinuar) => {
                //     if (respuestaContinuar) {

                //         this.$htmlToPaper('printMe10',this.opciones);


                //         if(respuestaContinuar){

                //         this.$emit("restablecervalores");


                //         }

                        
                //     }
                //     }
                // });


                        this.$htmlToPaper('printMe10',this.opciones);

                        this.$emit("restablecervalores");




            },





            /**
             * Función encargada de imprimir el reporte de firmas no vigentes
             */
            DescargarExcelFirmasNoVigentes:function()
            {

            
                // bootbox.confirm({
                //     title: "Mensaje del sistema",
                //     message: "Está por descargar en excel el reporte de firmas no vigentes. <br />¿Desea continuar?",
                //     buttons: {
                //     cancel: {
                //         label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                //     },
                //     confirm: {
                //         label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Descargar reporte en excel'
                //     }
                //     },
                //     callback: (respuestaContinuar) => {
                //     if (respuestaContinuar) {

                        
                //             var tabla = document.getElementById("tablaDeReporteFirmasNoVigentes_reporte_table")
                //             var libro = XLSX.utils.table_to_book(tabla, {raw : true})

                //             var titulo = (this.obtenerTituloBusquedaFirmasNoVigentes())
                //             XLSX.writeFile(libro, titulo + ".xlsx")
                        


                //         if(respuestaContinuar){

                //         this.$emit("restablecervalores");


                //         }

                        
                //     }
                //     }
                // });


                            var tabla = document.getElementById("tablaDeReporteFirmasNoVigentes_reporte_table")
                            var libro = XLSX.utils.table_to_book(tabla, {raw : true})

                            var titulo = (this.obtenerTituloBusquedaFirmasNoVigentes())
                            XLSX.writeFile(libro, titulo + ".xlsx")
                        
                            this.$emit("restablecervalores");



            },


            /**
             * Función encargada de imprimir el reporte de firmas vigentes
             */
            DescargarExcelFirmasVigentes:function()
            {

            
                // bootbox.confirm({
                //     title: "Mensaje del sistema",
                //     message: "Está por descargar en excel el reporte de firmas vigentes. <br />¿Desea continuar?",
                //     buttons: {
                //     cancel: {
                //         label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                //     },
                //     confirm: {
                //         label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Descargar reporte en excel'
                //     }
                //     },
                //     callback: (respuestaContinuar) => {
                //     if (respuestaContinuar) {

                        
                //             var tabla = document.getElementById("tablaDeReportesFirmasVigentes_reporte_table")
                //             var libro = XLSX.utils.table_to_book(tabla, {raw : true})

                //             var titulo = (this.obtenerTituloBusquedaFirmasVigentes())
                //             XLSX.writeFile(libro, titulo + ".xlsx")
                        


                //         if(respuestaContinuar){

                //         this.$emit("restablecervalores");


                //         }

                        
                //     }
                //     }
                // });


                            var tabla = document.getElementById("tablaDeReportesFirmasVigentes_reporte_table")
                            var libro = XLSX.utils.table_to_book(tabla, {raw : true})

                            var titulo = (this.obtenerTituloBusquedaFirmasVigentes())
                            XLSX.writeFile(libro, titulo + ".xlsx")  

                            this.$emit("restablecervalores");

            },


            /**
             * Función encargada de imprimir el reporte de mensajes recibidos
             */
            DescargarExcelMensajesRecibidos:function()
            {

            
                // bootbox.confirm({
                //     title: "Mensaje del sistema",
                //     message: "Está por descargar en excel el reporte de mensajes recibidos. <br />¿Desea continuar?",
                //     buttons: {
                //     cancel: {
                //         label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                //     },
                //     confirm: {
                //         label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Descargar reporte en excel'
                //     }
                //     },
                //     callback: (respuestaContinuar) => {
                //     if (respuestaContinuar) {

                        
                //             var tabla = document.getElementById("tablaDeReporteDeMensajesRecibidos_reporte_table")
                //             var libro = XLSX.utils.table_to_book(tabla, {raw : true})

                //             var titulo = (this.obtenerTituloBusquedaMensajes())
                //             XLSX.writeFile(libro, titulo + ".xlsx")
                        


                //         if(respuestaContinuar){

                //         this.$emit("restablecervalores");


                //         }

                        
                //     }
                //     }
                // });



                            var tabla = document.getElementById("tablaDeReporteDeMensajesRecibidos_reporte_table")
                            var libro = XLSX.utils.table_to_book(tabla, {raw : true})

                            var titulo = (this.obtenerTituloBusquedaMensajes())
                            XLSX.writeFile(libro, titulo + ".xlsx")
                        
                        this.$emit("restablecervalores");

            },


            /**
             * Función encargada de imprimir el reporte de mensajes no recibidos
             */
            DescargarExcelMensajesNoRecibidos:function()
            {

            
                // bootbox.confirm({
                //     title: "Mensaje del sistema",
                //     message: "Está por descargar en excel el reporte de mensajes no recibidos. <br />¿Desea continuar?",
                //     buttons: {
                //     cancel: {
                //         label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                //     },
                //     confirm: {
                //         label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Descargar reporte en excel'
                //     }
                //     },
                //     callback: (respuestaContinuar) => {
                //     if (respuestaContinuar) {

                        
                //             var tabla = document.getElementById("tablaDeReporteDeMensajesNoRecibidos_reporte_table")
                //             var libro = XLSX.utils.table_to_book(tabla, {raw : true})

                //             var titulo = (this.obtenerTituloBusquedaMensajesNoRecibidos())
                //             XLSX.writeFile(libro, titulo + ".xlsx")
                        


                //         if(respuestaContinuar){

                //         this.$emit("restablecervalores");


                //         }

                        
                //     }
                //     }
                // });


                            var tabla = document.getElementById("tablaDeReporteDeMensajesNoRecibidos_reporte_table")
                            var libro = XLSX.utils.table_to_book(tabla, {raw : true})

                            var titulo = (this.obtenerTituloBusquedaMensajesNoRecibidos())
                            XLSX.writeFile(libro, titulo + ".xlsx")
                        
                            this.$emit("restablecervalores");

            },


            /**
             * Función encargada de imprimir el reporte de catalogo de firmantes
             */
            DescargarExcelCatalogoDeFirmantes:function()
            {

            
                // bootbox.confirm({
                //     title: "Mensaje del sistema",
                //     message: "Está por descargar en excel el reporte del catalogo de firmantes. <br />¿Desea continuar?",
                //     buttons: {
                //     cancel: {
                //         label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                //     },
                //     confirm: {
                //         label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Descargar reporte en excel'
                //     }
                //     },
                //     callback: (respuestaContinuar) => {
                //     if (respuestaContinuar) {

                        
                //             var tabla = document.getElementById("tablaDeReporteDeCatalogoDeFirmantes_reporte_excel_table")
                //             var libro = XLSX.utils.table_to_book(tabla, {raw : true})

                //             var titulo = (this.obtenerTituloBusquedaReporteDeCatalogoDeFirmantes())
                //             XLSX.writeFile(libro, titulo + ".xlsx")
                        


                //         if(respuestaContinuar){

                //         this.$emit("restablecervalores");


                //         }

                        
                //     }
                //     }
                // });


                            var tabla = document.getElementById("tablaDeReporteDeCatalogoDeFirmantes_reporte_excel_table")
                            var libro = XLSX.utils.table_to_book(tabla, {raw : true})

                            var titulo = (this.obtenerTituloBusquedaReporteDeCatalogoDeFirmantes())
                            XLSX.writeFile(libro, titulo + ".xlsx")
                        
                            this.$emit("restablecervalores");

            },


            /**
             * Función encargada de imprimir el reporte de catalogo de firmantes dados de baja
             */
            DescargarExcelCatalogoDeFirmantesDadosDeBaja:function()
            {

            
                // bootbox.confirm({
                //     title: "Mensaje del sistema",
                //     message: "Está por descargar en excel el reporte del catalogo de firmantes dados de baja. <br />¿Desea continuar?",
                //     buttons: {
                //     cancel: {
                //         label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                //     },
                //     confirm: {
                //         label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Descargar reporte en excel'
                //     }
                //     },
                //     callback: (respuestaContinuar) => {
                //     if (respuestaContinuar) {

                        
                //             var tabla = document.getElementById("tablaDeReporteDeCatalogoDeFirmantesDadosDeBaja_reporte_excel_table")
                //             var libro = XLSX.utils.table_to_book(tabla, {raw : true})

                //             var titulo = (this.obtenerTituloBusquedaReporteDeCatalogoDeFirmantesDadosDeBaja())
                //             XLSX.writeFile(libro, titulo + ".xlsx")
                        


                //         if(respuestaContinuar){

                //         this.$emit("restablecervalores");


                //         }

                        
                //     }
                //     }
                // });


                            var tabla = document.getElementById("tablaDeReporteDeCatalogoDeFirmantesDadosDeBaja_reporte_excel_table")
                            var libro = XLSX.utils.table_to_book(tabla, {raw : true})

                            var titulo = (this.obtenerTituloBusquedaReporteDeCatalogoDeFirmantesDadosDeBaja())
                            XLSX.writeFile(libro, titulo + ".xlsx")

                            this.$emit("restablecervalores");




            },


            /**
             * Función encargada de imprimir el reporte de la bitacora de movimientos
             */
            DescargarExcelBitacoraDeMovimientos:function()
            {

            
                // bootbox.confirm({
                //     title: "Mensaje del sistema",
                //     message: "Está por descargar en excel el reporte de la bitacora de movimientos. <br />¿Desea continuar?",
                //     buttons: {
                //     cancel: {
                //         label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                //     },
                //     confirm: {
                //         label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Descargar reporte en excel'
                //     }
                //     },
                //     callback: (respuestaContinuar) => {
                //     if (respuestaContinuar) {

                        
                //             var tabla = document.getElementById("tablaReporteDeBitacoraDeMovimientos_reporte_table")
                //             var libro = XLSX.utils.table_to_book(tabla, {raw : true})

                //             var titulo = (this.obtenerTituloBusquedaMovimientos())
                //             XLSX.writeFile(libro, titulo + ".xlsx")
                        


                //         if(respuestaContinuar){

                //         this.$emit("restablecervalores");


                //         }

                        
                //     }
                //     }
                // });

                            var tabla = document.getElementById("tablaReporteDeBitacoraDeMovimientos_reporte_table")
                            var libro = XLSX.utils.table_to_book(tabla, {raw : true})

                            var titulo = (this.obtenerTituloBusquedaMovimientos())
                            XLSX.writeFile(libro, titulo + ".xlsx")
                    

                            this.$emit("restablecervalores");

            },


            /**
             * Función encargada de imprimir el reporte de certificados cobrados
             */
            DescargarExcelCertificadosCobrados:function()
            {

            
                // bootbox.confirm({
                //     title: "Mensaje del sistema",
                //     message: "Está por descargar en excel el reporte de certificados cobrados. <br />¿Desea continuar?",
                //     buttons: {
                //     cancel: {
                //         label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                //     },
                //     confirm: {
                //         label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Descargar reporte en excel'
                //     }
                //     },
                //     callback: (respuestaContinuar) => {
                //     if (respuestaContinuar) {

                //         this.mostrarsolonumeros= true;

                        
                //             var tabla = document.getElementById("tablaDeReporteDeRelacionDeCertificadosCobrados_reporte_excel_table")
                //             var libro = XLSX.utils.table_to_book(tabla, {raw : true})


                            


                            

                                                    


                //              Object.keys(libro.Sheets).forEach((sheet) =>{
                //             Object.keys(libro.Sheets[sheet]).forEach((celda)=>{
                //             if(!isNaN(libro.Sheets[sheet][celda].v) && !isNaN(parseFloat(libro.Sheets[sheet][celda].v))){
                //                 libro.Sheets[sheet][celda].v = Number(libro.Sheets[sheet][celda].v)
                //                 libro.Sheets[sheet][celda].t = 'n'

                                
                //             }
                //             })
                //             });



                //             var col = XLSX.utils.decode_col("C"); //decode_col converts Excel col name to an integer for col #
                //             var formato = "$#,##0.00;(#,##0.00)"; // or any Excel number format

                //             /* get worksheet range */
                //             const range = XLSX.utils.decode_range(libro.Sheets.Sheet1['!ref']);
                //             for(let row = range.s.r + 1; row <= range.e.r; ++row) {
                //               /* find the data cell (range.s.r + 1 skips the header row of the worksheet) */
                //               const ref = XLSX.utils.encode_cell({r:row, c:col});
                //               /* if the particular row did not contain data for the column, the cell will not be generated */
                //              if(!libro.Sheets.Sheet1[ref]) continue
                //               /* `.t == "n"` for number cells */
                                
                //              if(libro.Sheets.Sheet1[ref].t != 'n') continue
                //                                           /* assign the `.z` number format */
                              
                //               libro.Sheets.Sheet1.v = Number(libro.Sheets.Sheet1.v)
                //               libro.Sheets.Sheet1.t = 'n' 
                //               libro.Sheets.Sheet1[ref].z = formato;


                //              }



                //             var titulo = (this.obtenerTituloBusquedaCertificadosCobrados())
                //             XLSX.writeFile(libro, titulo + ".xlsx")

                            
                        


                //         if(respuestaContinuar){

                //         this.$emit("restablecervalores");
                //         this.mostrarsolonumeros= false;


                //         }

                        
                //     }
                //     }
                // });



                        this.mostrarsolonumeros= true;

                        
                            var tabla = document.getElementById("tablaDeReporteDeRelacionDeCertificadosCobrados_reporte_excel_table")
                            var libro = XLSX.utils.table_to_book(tabla, {raw : true})


                                 


                             Object.keys(libro.Sheets).forEach((sheet) =>{
                            Object.keys(libro.Sheets[sheet]).forEach((celda)=>{
                            if(!isNaN(libro.Sheets[sheet][celda].v) && !isNaN(parseFloat(libro.Sheets[sheet][celda].v))){
                                libro.Sheets[sheet][celda].v = Number(libro.Sheets[sheet][celda].v)
                                libro.Sheets[sheet][celda].t = 'n'

                                
                            }
                            })
                            });



                            var col = XLSX.utils.decode_col("C"); //decode_col converts Excel col name to an integer for col #
                            var formato = "$#,##0.00;(#,##0.00)"; // or any Excel number format

                            /* get worksheet range */
                            const range = XLSX.utils.decode_range(libro.Sheets.Sheet1['!ref']);
                            for(let row = range.s.r + 1; row <= range.e.r; ++row) {
                              /* find the data cell (range.s.r + 1 skips the header row of the worksheet) */
                              const ref = XLSX.utils.encode_cell({r:row, c:col});
                              /* if the particular row did not contain data for the column, the cell will not be generated */
                             if(!libro.Sheets.Sheet1[ref]) continue
                              /* `.t == "n"` for number cells */
                                
                             if(libro.Sheets.Sheet1[ref].t != 'n') continue
                                                          /* assign the `.z` number format */
                              
                              libro.Sheets.Sheet1.v = Number(libro.Sheets.Sheet1.v)
                              libro.Sheets.Sheet1.t = 'n' 
                              libro.Sheets.Sheet1[ref].z = formato;


                             }



                            var titulo = (this.obtenerTituloBusquedaCertificadosCobrados())
                            XLSX.writeFile(libro, titulo + ".xlsx")

                            

                        this.$emit("restablecervalores");
                        this.mostrarsolonumeros= false;






            },



                        /**
             * Función encargada de imprimir el reporte de certificados pagados
             */
            DescargarExcelCertificadosPagados:function()
            {

            
                // bootbox.confirm({
                //     title: "Mensaje del sistema",
                //     message: "Está por descargar en excel el reporte de certificados pagados. <br />¿Desea continuar?",
                //     buttons: {
                //     cancel: {
                //         label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                //     },
                //     confirm: {
                //         label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Descargar reporte en excel'
                //     }
                //     },
                //     callback: (respuestaContinuar) => {
                //     if (respuestaContinuar) {

                //         this.mostrarsolonumeros= true;

                        
                //             var tabla = document.getElementById("tablaDeReporteDeRelacionDeCertificadosCobrados_reporte_excel_table")
                //             var libro = XLSX.utils.table_to_book(tabla, {raw : true})


                            


                            

                                                    


                //              Object.keys(libro.Sheets).forEach((sheet) =>{
                //             Object.keys(libro.Sheets[sheet]).forEach((celda)=>{
                //             if(!isNaN(libro.Sheets[sheet][celda].v) && !isNaN(parseFloat(libro.Sheets[sheet][celda].v))){
                //                 libro.Sheets[sheet][celda].v = Number(libro.Sheets[sheet][celda].v)
                //                 libro.Sheets[sheet][celda].t = 'n'

                                
                //             }
                //             })
                //             });



                //             var col = XLSX.utils.decode_col("C"); //decode_col converts Excel col name to an integer for col #
                //             var formato = "$#,##0.00;(#,##0.00)"; // or any Excel number format

                //             /* get worksheet range */
                //             const range = XLSX.utils.decode_range(libro.Sheets.Sheet1['!ref']);
                //             for(let row = range.s.r + 1; row <= range.e.r; ++row) {
                //               /* find the data cell (range.s.r + 1 skips the header row of the worksheet) */
                //               const ref = XLSX.utils.encode_cell({r:row, c:col});
                //               /* if the particular row did not contain data for the column, the cell will not be generated */
                //              if(!libro.Sheets.Sheet1[ref]) continue
                //               /* `.t == "n"` for number cells */
                                
                //              if(libro.Sheets.Sheet1[ref].t != 'n') continue
                //                                           /* assign the `.z` number format */
                              
                //               libro.Sheets.Sheet1.v = Number(libro.Sheets.Sheet1.v)
                //               libro.Sheets.Sheet1.t = 'n' 
                //               libro.Sheets.Sheet1[ref].z = formato;


                //              }



                //             var titulo = (this.obtenerTituloBusquedaCertificadosCobrados())
                //             XLSX.writeFile(libro, titulo + ".xlsx")

                            
                        


                //         if(respuestaContinuar){

                //         this.$emit("restablecervalores");
                //         this.mostrarsolonumeros= false;


                //         }

                        
                //     }
                //     }
                // });




                        this.mostrarsolonumeros= true;

                        
                            var tabla = document.getElementById("tablaDeReporteDeRelacionDeCertificadosCobrados_reporte_excel_table")
                            var libro = XLSX.utils.table_to_book(tabla, {raw : true})                      


                             Object.keys(libro.Sheets).forEach((sheet) =>{
                            Object.keys(libro.Sheets[sheet]).forEach((celda)=>{
                            if(!isNaN(libro.Sheets[sheet][celda].v) && !isNaN(parseFloat(libro.Sheets[sheet][celda].v))){
                                libro.Sheets[sheet][celda].v = Number(libro.Sheets[sheet][celda].v)
                                libro.Sheets[sheet][celda].t = 'n'

                                
                            }
                            })
                            });



                            var col = XLSX.utils.decode_col("C"); //decode_col converts Excel col name to an integer for col #
                            var formato = "$#,##0.00;(#,##0.00)"; // or any Excel number format

                            /* get worksheet range */
                            const range = XLSX.utils.decode_range(libro.Sheets.Sheet1['!ref']);
                            for(let row = range.s.r + 1; row <= range.e.r; ++row) {
                              /* find the data cell (range.s.r + 1 skips the header row of the worksheet) */
                              const ref = XLSX.utils.encode_cell({r:row, c:col});
                              /* if the particular row did not contain data for the column, the cell will not be generated */
                             if(!libro.Sheets.Sheet1[ref]) continue
                              /* `.t == "n"` for number cells */
                                
                             if(libro.Sheets.Sheet1[ref].t != 'n') continue
                                                          /* assign the `.z` number format */
                              
                              libro.Sheets.Sheet1.v = Number(libro.Sheets.Sheet1.v)
                              libro.Sheets.Sheet1.t = 'n' 
                              libro.Sheets.Sheet1[ref].z = formato;


                             }



                            var titulo = (this.obtenerTituloBusquedaCertificadosCobrados())
                            XLSX.writeFile(libro, titulo + ".xlsx")

                            
                        
                           this.$emit("restablecervalores");
                           this.mostrarsolonumeros= false;




            },


                        /**
             * Función encargada de imprimir el reporte de cheques cobrados
             */
            DescargarExcelChequesCobrados:function()
            {

            
                // bootbox.confirm({
                //     title: "Mensaje del sistema",
                //     message: "Está por descargar en excel el reporte de cheques cobrados. <br />¿Desea continuar?",
                //     buttons: {
                //     cancel: {
                //         label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                //     },
                //     confirm: {
                //         label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Descargar reporte en excel'
                //     }
                //     },
                //     callback: (respuestaContinuar) => {
                //     if (respuestaContinuar) {

                //         this.mostrarsolonumeros= true;

                        
                //             var tabla = document.getElementById("tablaDeReporteDeRelacionDeChequesCobrados_reporte_excel_table")
                //             var libro = XLSX.utils.table_to_book(tabla, {raw : true})


                //             // console.log(libro)

                                                    


                //              Object.keys(libro.Sheets).forEach((sheet) =>{
                //             Object.keys(libro.Sheets[sheet]).forEach((celda)=>{
                //             if(!isNaN(libro.Sheets[sheet][celda].v) && !isNaN(parseFloat(libro.Sheets[sheet][celda].v))){
                //                 libro.Sheets[sheet][celda].v = Number(libro.Sheets[sheet][celda].v)
                //                 libro.Sheets[sheet][celda].t = 'n'

                                
                //             }
                //             })
                //             });



                //             var col = XLSX.utils.decode_col("H"); //decode_col converts Excel col name to an integer for col #
                //             var formato = "$#,##0.00;(#,##0.00)"; // or any Excel number format

                //             /* get worksheet range */
                //             let range = XLSX.utils.decode_range(libro.Sheets.Sheet1['!ref']);


                //             // console.log(range)
                //             for(let row = range.s.r + 1; row <= range.e.r; ++row) {
                //               /* find the data cell (range.s.r + 1 skips the header row of the worksheet) */
                //               let ref = XLSX.utils.encode_cell({r:row, c:col});

                //               // console.log(ref, "referencia")
                //               /* if the particular row did not contain data for the column, the cell will not be generated */
                //              if(!libro.Sheets.Sheet1[ref]) continue;
                //               /* `.t == "n"` for number cells */
                                
                //              if(libro.Sheets.Sheet1[ref].t != 'n') continue;
                //                                           /* assign the `.z` number format */
                              
                //               libro.Sheets.Sheet1.v = Number(libro.Sheets.Sheet1.v)
                //               libro.Sheets.Sheet1.t = 'n' 
                //               libro.Sheets.Sheet1[ref].z = formato;


                //              }



                //             var col2 = XLSX.utils.decode_col("I"); //decode_col converts Excel col name to an integer for col #
                            

                //             /* get worksheet range */
                            
                //             for(let row = range.s.r + 1; row <= range.e.r; ++row) {
                //               /* find the data cell (range.s.r + 1 skips the header row of the worksheet) */
                //               let ref = XLSX.utils.encode_cell({r:row, c:col2});
                //               /* if the particular row did not contain data for the column, the cell will not be generated */
                //              if(!libro.Sheets.Sheet1[ref]) continue;
                //               /* `.t == "n"` for number cells */
                                
                //              if(libro.Sheets.Sheet1[ref].t != 'n') continue;
                //                                           /* assign the `.z` number format */
                              
                //               libro.Sheets.Sheet1.v = Number(libro.Sheets.Sheet1.v)
                //               libro.Sheets.Sheet1.t = 'n' 
                //               libro.Sheets.Sheet1[ref].z = formato;


                //              }






                //             var titulo = (this.obtenerTituloBusquedaChequesCobrados())
                //             XLSX.writeFile(libro, titulo + ".xlsx")

                            
                        


                //         if(respuestaContinuar){

                //         this.$emit("restablecervalores");
                //         this.mostrarsolonumeros= false;


                //         }

                        
                //     }
                //     }
                // });



                            this.mostrarsolonumeros= true;
                     
                            var tabla = document.getElementById("tablaDeReporteDeRelacionDeChequesCobrados_reporte_excel_table")
                            var libro = XLSX.utils.table_to_book(tabla, {raw : true})


                            // console.log(libro)                                               

                             Object.keys(libro.Sheets).forEach((sheet) =>{
                            Object.keys(libro.Sheets[sheet]).forEach((celda)=>{
                            if(!isNaN(libro.Sheets[sheet][celda].v) && !isNaN(parseFloat(libro.Sheets[sheet][celda].v))){
                                libro.Sheets[sheet][celda].v = Number(libro.Sheets[sheet][celda].v)
                                libro.Sheets[sheet][celda].t = 'n'

                                
                            }
                            })
                            });



                            var col = XLSX.utils.decode_col("H"); //decode_col converts Excel col name to an integer for col #
                            var formato = "$#,##0.00;(#,##0.00)"; // or any Excel number format

                            /* get worksheet range */
                            let range = XLSX.utils.decode_range(libro.Sheets.Sheet1['!ref']);


                            // console.log(range)
                            for(let row = range.s.r + 1; row <= range.e.r; ++row) {
                              /* find the data cell (range.s.r + 1 skips the header row of the worksheet) */
                              let ref = XLSX.utils.encode_cell({r:row, c:col});

                              // console.log(ref, "referencia")
                              /* if the particular row did not contain data for the column, the cell will not be generated */
                             if(!libro.Sheets.Sheet1[ref]) continue;
                              /* `.t == "n"` for number cells */
                                
                             if(libro.Sheets.Sheet1[ref].t != 'n') continue;
                                                          /* assign the `.z` number format */
                              
                              libro.Sheets.Sheet1.v = Number(libro.Sheets.Sheet1.v)
                              libro.Sheets.Sheet1.t = 'n' 
                              libro.Sheets.Sheet1[ref].z = formato;


                             }



                            var col2 = XLSX.utils.decode_col("I"); //decode_col converts Excel col name to an integer for col #
                            

                            /* get worksheet range */
                            
                            for(let row = range.s.r + 1; row <= range.e.r; ++row) {
                              /* find the data cell (range.s.r + 1 skips the header row of the worksheet) */
                              let ref = XLSX.utils.encode_cell({r:row, c:col2});
                              /* if the particular row did not contain data for the column, the cell will not be generated */
                             if(!libro.Sheets.Sheet1[ref]) continue;
                              /* `.t == "n"` for number cells */
                                
                             if(libro.Sheets.Sheet1[ref].t != 'n') continue;
                                                          /* assign the `.z` number format */
                              
                              libro.Sheets.Sheet1.v = Number(libro.Sheets.Sheet1.v)
                              libro.Sheets.Sheet1.t = 'n' 
                              libro.Sheets.Sheet1[ref].z = formato;


                             }






                            var titulo = (this.obtenerTituloBusquedaChequesCobrados())
                            XLSX.writeFile(libro, titulo + ".xlsx")

                            
                        


                        

                            this.$emit("restablecervalores");
                            this.mostrarsolonumeros= false;


                        



            },
















        }
    }
 </script>

 <style scoped>
    .border_fila{
        border: black 1px solid
    }
    #encabezado-filtros .btn-sm {
    padding-left: 10px;
    padding-right: 10px;
    cursor: pointer;
    font-size: 16px;
    }

    .iconoDeshabilitado
    {
        cursor: not-allowed;
        opacity: 0.4;
    }
    .iconoHabilitado{
        cursor: pointer;
    }
    .altoDeTablaFijo
    {
        max-height:80vh;
    }
    .altoDeTablaFijo thead th {
        position: sticky;
        top: 0;
    }

    li{

         list-style-type: none;
    }

    ul{
        padding-left: 0.0rem!important;
        text-align: center;
        
    }

    .div-verificacion {


        color:black;


    }

    .thead-green{
        background-color: var(--verde-pj-100);
    }



 </style>



// WEBPACK FOOTER //
// src/components/SIVAC/Comun/TablaDeResultadosFirmas.vue